import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useMemo,
  useId,
  useCallback,
} from "react";
import FavoriteIcon from "../../Favorite/FavoriteIcon.js";
import CardFullView from "../CardFullView/CardFullView";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { UserContext } from "../../login/LoginForm";
import { AuthContext } from "../../login/AuthContext";
import { getItem } from "../../../utils/localStorage";
import Select from "react-select";
import { useSport } from "../../../utils/SportsProvider";

//import GridViewMain from "./GridViewMain";
import MySvgButtonPlus from "../../UsefulComponent/MySvgButtonPlus";
import ConfirmationModal from "../ConfirmationModal";
import FilterComponent from "../FilterComponent";
import NameSelect from "../NameSelect";
import MoreOptionsButton from "../../UsefulComponent/moreOptionButtonSingle";
import CheckOptions from "../../UsefulComponent/checkOptions";
import EditOptionButton from "../../UsefulComponent/editOptionButton";
import { teams } from "../../CreateCardForm/teamslist";
// import css CardGrid2
import cardDesign from "../../UsefulComponent/cardDesign";
import PaginationComponent from "../PaginationComponent";
import LoadMoreBar from "../LoadMoreBar.jsx";
import SortingSelect from "../SortingSelect";
import axios from "axios";
import translations from "../../../utils/language/translations.json";
//Unique to CardGridSell
import { useTranslation } from "react-i18next";
import SaleModals from "../../GridViewSellTrade/SaleModals";
import { toast } from "react-toastify";
import { useFavorites } from "../../Favorite/FavoriteProvider";
import SpinnerIcon from "../../../utils/icon/SpinnerIcon";
import ImageSelector from "../../../utils/icon/ImageSelector";
import profile from "../../../assets/svgs/profile.png";
import { preventDefault } from "@fullcalendar/core/internal";
import CopyIcon from "../../../utils/icon/CopyIcon";
import { getCountryCode } from "../../UsefulComponent/CountryMapping";
import ActionModal from "./ActionModal";
import LazyImage from "../../UsefulComponent/LazyImage";
import zIndex from "@mui/material/styles/zIndex";
import ModalTradeOffer from "../../GridViewSellTrade/ViewSaleTradeOffer/ModalTradeOffer";
import Sousmenu from "./Sousmenu";
import AddIcon from "../../../utils/icon/AddIcon";
import CheckIcon from "../../../utils/icon/CheckIcon";
import search from "../../../assets/svgs/search.svg";
import { hasConsent } from "../../login/hasConsent";
import WatchListActions from "../WatchListActions";
import CardOverlayActions from "./CardOverlayActions.jsx";
//Unique to CardGridTrade
function FullCardGrid({
  setCards,
  cards,
  groupedCards,
  viewAsGrid,
  viewOnly,
  cardGridType,
  ForSearch,
  MultiCardOfferSelection,
  SetMultiCardOfferSelection,
  toggleViewAsGrid,
  preSelectedCards,
  setModal,
  sport,
}) {
  const { state } = useSport();
  const lastScrollY = useRef(0);

  const {
    favoriteSellers,
    setFavoriteCards,
    favoriteCards,
    addFavoriteCard,
    removeFavoriteCard,
  } = useFavorites();
  //Filter
  const collectionSubmitRef = useRef(null);
  const [isFilterVisible, setIsFilterVisible] = useState(
    () => window.innerWidth >= 769,
  );

  const stylingSelect = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222",
      borderColor: "#444", // subtle
      boxShadow: "0 0 4px rgba(0, 102, 255, 0.2)", // slight glow
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1a1a1a", // Set the background color of the dropdown menu to black
      color: "white", // Set the text color of the dropdown menu to white
    }),
    option: (provided, state) => ({
      ...provided,
      color: "white", // Set the text color for selected and non-selected options
      backgroundColor: state.isSelected ? "#0066FFED" : null, // Set the background color for selected options
      "&:hover": {
        backgroundColor: "#0066FFED", // Set the background color for hover effect
        color: "white", // Set the text color for hover effect
      },
    }),
  };
  const [showMore, setShowMore] = useState(false); // State for showing additional filter content
  //Commun all 3*
  const [isTradeModalOpen, setIsTradeModalOpen] = useState(false);
  const [isSaleModalOpen, setIsSaleModalOpen] = useState(false);
  const hasEffectRunRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  // const t = (key) => translations.CardGrid[key][currentLang]; // Adjust the path according to your JSON structure

  // Safe translation function
  const t = (key) => {
    if (!translations.CardGrid || !translations.CardGrid[key]) {
      console.warn(`Missing translation key: ${key}`); // Log missing keys
      return key; // Return the key as fallback instead of breaking the app
    }

    return translations.CardGrid[key][currentLang] || key;
  };
  const [selectedAction1, setSelectedAction1] = useState("");
  const [collections, setCollections] = useState([]); // State to hold the collections array
  const [defaultWatchlist, setDefaultWatchlist] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState("");
  const [selectedCollectionLive, setSelectedCollectionLive] = useState("");
  const [selectedCollectionTitle, setSelectedCollectionTitle] = useState("");
  const [selectedCollectionIsDefault, setSelectedCollectionIsDefault] =
    useState();
  const [selectedCollectionIsPublic, setSelectedCollectionIsPublic] =
    useState();
  const [isViewCollection, setIsViewCollection] = useState(false);
  const [selectedCard, setSelectedCard] = useState();
  const [selectedCards, setSelectedCards] = useState(
    preSelectedCards ? preSelectedCards : [],
  );
  console.log("preSelectedCards", preSelectedCards);
  console.log("selectedCards", selectedCards);
  const [allCollectionCards, setAllCollectionCards] = useState([]);
  //const [favoriteCards,setFavoriteCards] = useState([])
  const [recentlyDeletedCards, setRecentlyDeletedCards] = useState([]);
  const [isViewRecentlyDeleted, setIsViewRecentlyDeleted] = useState(false);
  const [selectedCollectionCards, setSelectedCollectionCards] = useState([]);
  const [tempoCards, setTempoCards] = useState([]);
  const [multiEditState, setMultiEditState] = useState(
    MultiCardOfferSelection ? true : false,
  );
  const [filterValues, setFilterValues] = useState({});
  const [filteredCards, setFilteredCards] = useState([]);
  const [nameCounts, setNameCounts] = useState({});
  const [teamsIdCounts, setTeamsIdCounts] = useState({});
  const [setCounts, setSetCounts] = useState({});
  const [variationNameCounts, setVariationNameCounts] = useState({});
  const [cardNameCounts, setCardNameCounts] = useState({});
  const [yearCounts, setYearCounts] = useState({});
  const [isRookieCounts, setIsRookieCounts] = useState({});
  const [isPatchCounts, setIsPatchCounts] = useState({});
  const [isJerseyCounts, setIsJerseyCounts] = useState({});
  const [isAutoCounts, setIsAutoCounts] = useState({});
  const [isForSaleCounts, setIsForSaleCounts] = useState({});
  const [isForTradeCounts, setIsForTradeCounts] = useState({});
  const [isOnEbayCounts, setIsOnEbayCounts] = useState({});
  const [isPCCounts, setIsPCCounts] = useState({});
  const [isGoneCounts, setIsGoneCounts] = useState({});
  const [conditionCardCounts, setConditionCardCounts] = useState({});
  const [isGradedCounts, setIsGradedCounts] = useState({});
  const [gradeCompanyCounts, setGradeCompanyCounts] = useState({});
  const [gradeCounts, setGradeCounts] = useState({});
  const [showNameCounts, setShowNameCounts] = useState({});

  const [soldPriceInput, setSoldPriceInput] = useState(0);
  const [selectedCollectionInnerText, setSelectedCollectionInnerText] =
    useState({});
  const [isGoneChecked, setIsGoneChecked] = useState({});

  const { userId, liveCsrfToken, isAuthenticated, loading, jwtToken } =
    useContext(AuthContext);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [totalSellingValue, setTotalSellingValue] = useState(0);
  const [totalCardValue, setTotalCardValue] = useState(0);
  const [totalCardLenght, setTotalCardLenght] = useState(0);
  const [searchBarSelectName, setSearchBarSelectName] = useState("");
  const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
  const [singleCardOperationId, setSingleCardOperationId] = useState(0);
  const [attributeFilterLogic, setAttributeFilterLogic] = useState("Or"); // Default to "Or"
  const [isWhatFilterLogic, setIsWhatFilterLogic] = useState("Or");
  const [filteredGroupedCards, setFilteredGroupedCards] = useState([]);

  // const [currentPage, setCurrentPage] = useState(1);
  // const [itemsPerPage, setItemsPerPage] = useState(50);
  // const lastItemIndex = currentPage * itemsPerPage;
  // const firstItemIndex = lastItemIndex - itemsPerPage;
  // const currentItems = filteredCards.slice(firstItemIndex, lastItemIndex);
  // const visibleCardIds = currentItems.map((card) => card.id); // Extract IDs

  // const totalPages = Math.ceil(filteredCards.length / itemsPerPage);

  // const totalPagesGrouped = Math.ceil(filteredGroupedCards.size / itemsPerPage);
  // const currentItemsGrouped = Array.from(filteredGroupedCards.values()).slice(
  //   firstItemIndex,
  //   lastItemIndex
  // );

  // replace pagination states
  const [itemsShown, setItemsShown] = useState(20); // initial batch
  const SHOW_MORE_STEPS = [20, 30, 50, 100]; // escalating steps
  const [stepIndex, setStepIndex] = useState(0);

  // if you want different counts in grid mode, you can keep one state per mode
  // const [itemsShownGrouped, setItemsShownGrouped] = useState(20);

  useEffect(
    () => {
      // whenever filters or search change, reset the list
      setItemsShown(20);
      setStepIndex(0);
    },
    [
      /* put your filter deps here: search, tags, priceRange, etc. */
    ],
  );

  // flat list
  const totalFlat = filteredCards.length;
  const currentItems = filteredCards.slice(0, itemsShown);
  const visibleCardIds = currentItems.map((c) => c.id);

  // grouped list
  const groupedArray = Array.from(filteredGroupedCards.values());
  const totalGrouped = groupedArray.length;
  const currentItemsGrouped = groupedArray.slice(0, itemsShown);
  const groupedVisibleCardIds = currentItemsGrouped.map((c) => c.id);

  const handleShowMore = (total) => {
    const step =
      SHOW_MORE_STEPS[Math.min(stepIndex, SHOW_MORE_STEPS.length - 1)];
    setItemsShown((prev) => Math.min(prev + step, total));
    if (stepIndex < SHOW_MORE_STEPS.length - 1)
      setStepIndex((prev) => prev + 1);
  };
  // const groupedVisibleCardIds = currentItemsGrouped.map((card) => card.id); // Extract IDs

  const [sortValue, setSortValue] = useState("");
  const [searchTermInput, setSearchTermInput] = useState("");
  const [activeSearchTerm, setActiveSearchTerm] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [triggerFilterChange, setTriggerFilterChange] = useState(false);
  const [viewImageOnly, setViewImageOnly] = useState(true);
  const [viewPrice, setViewPrice] = useState(true);
  const [isEditingPriceVisible, setIsEditingPriceVisible] = useState(false);
  const [expandedCardId, setExpandedCardId] = useState(null);
  const initialOpenFilters = {
    GroupBy: true,
    "Filter Attribut": true,
    "Filter Graded": true,
    Name: true,
    TeamsId: true,
    SetName: true,
    cardName: true,
    variationName: true,
    YearMade: true,
    GradeCompany: true,
    Grade: true,
    ConditionCard: true,
    ShowName: true, // only appears in Sell view
    isGone: true,
  };

  useEffect(() => {
    setItemsShown(20);
    setStepIndex(0);
  }, [filterValues, activeSearchTerm, selectedCollectionLive, viewAsGrid]);

  const cardTitleById = useMemo(() => {
    const m = new Map();
    (cards || []).forEach((c) => {
      m.set(Number(c.CardId), c.SearchTitle || c.cardName || `#${c.CardId}`);
    });
    return m;
  }, [cards]);

  const [openSections, setOpenSections] = useState({
    TagsAndAttributes: true,
    Condition: true,
    Player: true,
    YearAndSet: true,
    Price: true,
    Misc: true, // e.g., isGone, etc.
  });

  const [openFilters, setOpenFilters] = useState(initialOpenFilters);
  //End Commun *3
  //Unique to CardGrid
  const [
    confirmationVisibleForDeleteFromCollectionOnly,
    setConfirmationVisibleForDeleteFromCollectionOnly,
  ] = useState(false);
  const [
    confirmationVisibleForDeleteCards,
    setConfirmationVisibleForDeleteCards,
  ] = useState(false);
  const [
    confirmationVisibleCreateNewCollection,
    setConfirmationVisibleCreateNewCollection,
  ] = useState(false);
  const [createNewCollectionTitle, setCreateNewCollectionTitle] = useState("");
  const [
    confirmationVisibleDeleteCollection,
    setConfirmationVisibleDeleteCollection,
  ] = useState(false);
  const [
    confirmationVisibleRenameWatchList,
    setConfirmationVisibleRenameWatchList,
  ] = useState(false);
  const [
    confirmationVisibleForMarkAsSold,
    setConfirmationVisibleForMarkAsSold,
  ] = useState(false);

  const [renameCollectionTitle, setRenameCollectionTitle] = useState("");
  const [userResponse, setUserResponse] = useState(false);
  const [needToReset, setNeedToReset] = useState(false);
  const [isPcUpdate, setIsPcUpdate] = useState(false);
  const [isForSaleUpdate, setIsForSaleUpdate] = useState(false);
  const [isForTradeUpdate, setIsForTradeUpdate] = useState(false);
  const [isOnEbayUpdate, setIsOnEbayUpdate] = useState(false);
  const initialIsGoneChecked = {
    0: true, // Default value for "No"
    1: false, // Default value for "Yes"
  };
  const [selectedTradeCard, setSelectedTradeCard] = useState(null);
  //Unique to CardGridSell
  const [allCollectionUnavailable, setAllCollectionUnavailable] = useState([]);
  const [unavailableCardInfo, setUnavailableCardInfo] = useState([]);
  const [isViewMyListings, setIsViewMyListings] = useState(false);
  const [confirmationVisibleNotForSale, setConfirmationVisibleNotForSale] =
    useState(false);

  const [myListingCounts, setMyListingCounts] = useState(0);
  const [getShippingPreference, setShippingPreference] = useState(null);

  const [tradingPreferences, setTradingPreferences] = useState([]);
  const [selectedTradePref, setSelectedTradePref] = useState(null);
  // const [confirmationVisibleForDeleteFromCollectionOnly, setConfirmationVisibleForDeleteFromCollectionOnly] = useState(false);
  // const [confirmationVisibleNotForSale,setConfirmationVisibleNotForSale] = useState(false);
  // const [confirmationVisibleForDeleteCards, setConfirmationVisibleForDeleteCards] = useState(false);
  // const [confirmationVisibleDeleteWatchList,setConfirmationVisibleDeleteWatchList] = useState(false);
  // const [createNewCollectionTitle,setCreateNewCollectionTitle] = useState("");
  // const [confirmationVisibleRenameWatchList,setConfirmationVisibleRenameWatchList] = useState(false);
  // const [renameCollectionTitle,setRenameCollectionTitle] = useState("");
  const openSale = (card) => {
    setSelectedCard(card);
    setIsSaleModalOpen(true);
  };
  const [flippedCardId, setFlippedCardId] = useState(null);
  const [openMenuCardId, setOpenMenuCardId] = useState(null);
  const openMenuFor = (id) => setOpenMenuCardId(id);
  const closeMenu = () => setOpenMenuCardId(null);
  useEffect(() => {
    if (lastScrollY.current > 0) {
      window.scrollTo({ top: lastScrollY.current, behavior: "auto" });
      lastScrollY.current = 0;
    }
  }, [currentItems]); // or filterValues, or however your grid updates

  const handleToggleCard = (cardId) => {
    setFlippedCardId((prev) => (prev === cardId ? null : cardId)); // If the same card is clicked, flip back
  };

  const fetchShippingPreferences = async (userId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/api/get/shipping-preferences/${userId}`,
        {
          method: "GET",
          credentials: "include", // Ensure session cookies are sent with the request
        },
      );
      const preference = await response.json();

      setShippingPreference({
        label: preference.TemplateTitle,
        value: preference.ShippingPreferenceId,
        minorCardShipping: preference.MinorCardShipping,
        mediumCardShipping: preference.MediumCardShipping,
        bigCardShipping: preference.BigCardShipping,
        otherDetails: preference.OtherDetails,
        acceptOffer: preference.acceptOffer,
      });

      console.log("preference", preference);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const fetchTradingPreferences = async (userId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/api/get/trading-preferences/grid2/${userId}`,
        {
          method: "GET",
          credentials: "include", // Ensure session cookies are sent with the request
        },
      );

      const preference = await response.json();

      setTradingPreferences(preference);

      console.log("preferencetrade", preference);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    if (userId && liveCsrfToken) {
      fetchShippingPreferences(userId);
      fetchTradingPreferences(userId);
    }
  }, [userId, liveCsrfToken]);

  useEffect(() => {
    console.log(viewAsGrid);
  }, [viewAsGrid]);

  const PriceEditChange = ({ card, onPriceUpdate }) => {
    const [isEditingPrice, setIsEditingPrice] = useState(true);
    const [editableValue, setEditableValue] = useState(
      card.EstimateValue ? card.EstimateValue : -1,
    );
    const [editableTV, setEditableTV] = useState(
      card.tradeValue ? card.tradeValue : -1,
    );
    const [editableSalePrice, setEditableSalePrice] = useState(
      card.Price ? card.Price : -1,
    );
    const [editableOffer, setEditableOffer] = useState(card.BestOffer === 1);
    const [currentUsercardId, setCurrentUsercardId] = useState(card.id);
    const [shippingPrice, setShippingPrice] = useState(card.Shipping);

    // State to track the original data
    const [originalData, setOriginalData] = useState({
      EstimateValue: card.EstimateValue,
      Price: card.Price,
      tradeValue: card.tradeValue,
      BestOffer: card.BestOffer === 1,
    });

    const updateShippingPrice = (price) => {
      let shippingPrice = 0;
      if (getShippingPreference) {
        if (price <= 15) {
          shippingPrice = getShippingPreference.minorCardShipping;
        } else if (price <= 75) {
          shippingPrice = getShippingPreference.mediumCardShipping;
        } else {
          shippingPrice = getShippingPreference.bigCardShipping;
        }
      }
      setShippingPrice(shippingPrice);
    };

    const handleEditClick = (event) => {
      event.stopPropagation();
      setIsEditingPrice(true);
    };
    const handleOfferChange = () => {
      setEditableOffer(!editableOffer);
    };
    const handleTVChange = (event) => {
      event.stopPropagation();
      const value = event.target.value;
      if (
        value === "" ||
        (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
      ) {
        setEditableTV(value);
      }
    };
    const handleTVBlur = () => {
      // Remove leading zeros and correct invalid formats
      let correctedValue = parseFloat(editableTV);
      // Check for NaN and set to a default or leave as is
      correctedValue = isNaN(correctedValue) ? 0 : correctedValue;
      setEditableTV(correctedValue);
    };
    const handleSalePriceChange = (event) => {
      event.stopPropagation();
      const value = event.target.value;
      if (
        value === "" ||
        (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
      ) {
        setEditableSalePrice(value);
        updateShippingPrice(parseFloat(value)); // Update the shipping price as the price changes
      }
    };
    const handleSalePriceBlur = () => {
      let correctedValue = parseFloat(editableSalePrice);
      correctedValue = isNaN(correctedValue) ? 0 : correctedValue;
      setEditableSalePrice(correctedValue);
      updateShippingPrice(correctedValue); // Update shipping price on blur
    };

    const handleValueChange = (event) => {
      event.stopPropagation();
      const value = event.target.value;
      // Allow empty string to clear the input, or check if it's a valid float number
      if (
        value === "" ||
        (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
      ) {
        setEditableValue(value);
      }
    };

    const handleValueBlur = () => {
      // Remove leading zeros and correct invalid formats
      let correctedValue = parseFloat(editableValue);
      // Check for NaN and set to a default or leave as is
      correctedValue = isNaN(correctedValue) ? 0 : correctedValue;
      setEditableValue(correctedValue);
    };

    const handleSaveClick = (event) => {
      event.stopPropagation();
      updateTables();
      onPriceUpdate(card.id, editableTV); // Call a function passed via props to update the price in the parent state or send it to the server
    };

    const updateEstimateValues = async (info) => {
      try {
        console.log("info updateEstimateValues", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/estimateValue/update/value`,
          { ...info, liveCsrfToken: liveCsrfToken }, // Include liveCsrfToken in the request body
          { withCredentials: true }, // Include credentials (cookies)
        );
        console.log("Updating estimateValue was a success", response.data);
      } catch (error) {
        console.error("Error Updating estimateValue", error);
      }
    };

    const insertIntoSellCards = async (info) => {
      try {
        console.log("info insertIntoSellCards", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/price/insert/sellcards`,
          { ...info, liveCsrfToken: liveCsrfToken },
          { withCredentials: true }, // Include liveCsrfToken in the request body
        );
        console.log("Insert into sellCards was a success", response.data);
      } catch (error) {
        console.error("Error Inserting sellCards", error);
      }
    };

    const updateForSaleStatus = async (info) => {
      try {
        console.log("info updateForSaleStatus", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/forsale/update/true`,
          { ...info, liveCsrfToken: liveCsrfToken },
          { withCredentials: true }, // Include liveCsrfToken in the request body
        );
        console.log("Updating forSale status was a success", response.data);
      } catch (error) {
        console.error("Error Updating forSale status", error);
      }
    };

    const updateSellCards = async (info) => {
      try {
        console.log("info updateSellCards", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/price/update/price`,
          { ...info, liveCsrfToken: liveCsrfToken },
          { withCredentials: true }, // Include liveCsrfToken in the request body
        );
        console.log("Updating price was a success", response.data);
      } catch (error) {
        console.error("Error Updating price", error);
      }
    };

    const insertIntoTradeCards = async (info) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/tradevalue/insert/tradecards`,
          { ...info, liveCsrfToken: liveCsrfToken },
          { withCredentials: true }, // Include liveCsrfToken in the request body
        );
        console.log("Insert into tradecards was a success", response.data);
      } catch (error) {
        console.error("Error Inserting tradecards", error);
      }
    };

    const updateForTradeStatus = async (info) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/fortrade/update/true`,
          { ...info, liveCsrfToken: liveCsrfToken },
          { withCredentials: true }, // Include liveCsrfToken in the request body
        );
        console.log("Updating forTrade status was a success", response.data);
      } catch (error) {
        console.error("Error Updating forTrade status", error);
      }
    };

    const updateTradeCards = async (info) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/tradevalue/update/tradevalue`,
          { ...info, liveCsrfToken: liveCsrfToken },
          { withCredentials: true }, // Include liveCsrfToken in the request body
        );
        console.log("Updating tradeValue was a success", response.data);
      } catch (error) {
        console.error("Error Updating tradeValue", error);
      }
    };

    const updateTables = async () => {
      const hasDataChanged = () => {
        return (
          originalData.EstimateValue !== editableValue ||
          originalData.Price !== editableSalePrice ||
          originalData.tradeValue !== editableTV ||
          originalData.BestOffer !== editableOffer
        );
      };

      if (hasDataChanged()) {
        try {
          if (
            originalData.EstimateValue !== editableValue &&
            editableValue !== null &&
            editableValue !== -1
          ) {
            await updateEstimateValues({
              userId: userId,
              userCardId: currentUsercardId,
              EstimateValue: editableValue,
            });
          }

          if (
            (originalData.Price !== editableSalePrice &&
              editableSalePrice !== null &&
              editableSalePrice !== -1) ||
            originalData.BestOffer != editableOffer
          ) {
            if (originalData.Price === null) {
              await insertIntoSellCards({
                userId: userId,
                userCardId: currentUsercardId,
                Price: editableSalePrice,
                BestOffer: editableOffer,
                Shipping: shippingPrice,
              });

              await updateForSaleStatus({
                userId: userId,
                userCardId: currentUsercardId,
                isForSale: true,
              });
              toast.success(t("Updated"));
            } else {
              await updateSellCards({
                userId: userId,
                userCardId: currentUsercardId,
                Price: editableSalePrice,
                BestOffer: editableOffer,
                Shipping: shippingPrice,
              });
              toast.success(t("Updated"));
            }
          }

          if (
            originalData.tradeValue !== editableTV &&
            editableTV !== null &&
            editableTV !== -1
          ) {
            if (originalData.tradeValue === null) {
              await insertIntoTradeCards({
                userId: userId,
                userCardId: currentUsercardId,
                tradeValue: editableTV,
              });

              await updateForTradeStatus({
                userId: userId,
                userCardId: currentUsercardId,
                isForTrade: true,
              });
            } else {
              await updateTradeCards({
                userId: userId,
                userCardId: currentUsercardId,
                tradeValue: editableTV,
              });
            }
          }

          // Set the new originalData after all updates
          setOriginalData({
            EstimateValue: editableValue,
            Price: editableSalePrice,
            tradeValue: editableTV,
          });
        } catch (error) {
          console.error("Failed to update card data:", error);
          // Handle error (e.g., show error message to the user)
        }
      } else {
        console.log("No changes to save");
      }
    };

    return (
      <div className="card-value" onClick={(event) => event.stopPropagation()}>
        {isEditingPrice ? (
          <>
            <div className="flex-h" style={{ gap: "7px" }}>
              {editableValue >= -1 && (
                <>
                  <div className="nappa">
                    <div>
                      <h4 style={{ textDecoration: "underline" }}>
                        {t("Value")}
                      </h4>
                    </div>
                    <input
                      type="text"
                      //style={{ textAlign: "center" }}
                      value={editableValue < 0 ? null : editableValue}
                      placeholder={editableValue < 0 ? "N/A" : ""}
                      onChange={handleValueChange}
                      onBlur={handleValueBlur}
                    />
                  </div>
                </>
              )}

              {editableTV >= -1 ? (
                <>
                  <div className="nappa">
                    <div>
                      <h4 style={{ textDecoration: "underline" }}>
                        {t("Trade(TV)")}
                      </h4>
                    </div>

                    <input
                      type="text"
                      // style={{ textAlign: "center" }}
                      value={editableTV < 0 ? null : editableTV}
                      placeholder={editableTV < 0 ? "N/A" : ""}
                      onChange={handleTVChange}
                      onBlur={handleTVBlur}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div></div>
                </>
              )}
            </div>

            {editableSalePrice >= -1 && (
              <>
                <div className="nappa">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h4
                      style={{
                        textDecoration: "underline",
                      }}
                    >
                      {t("ForSale Price")}
                    </h4>

                    <h4 style={{ textDecoration: "underline" }}>
                      {t("Offer")}?
                    </h4>
                  </div>
                  <div className="wasd">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <input
                        type="text"
                        // style={{ textAlign: "center" }}
                        value={editableSalePrice < 0 ? null : editableSalePrice}
                        placeholder={editableSalePrice < 0 ? "N/A" : ""}
                        onChange={handleSalePriceChange}
                        onBlur={handleSalePriceBlur}
                        style={{ minWidth: "75%" }}
                      />
                      <input
                        type="checkbox"
                        style={{ cursor: "pointer", transform: "scale(0.4)" }}
                        checked={editableOffer}
                        onChange={handleOfferChange}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        paddingLeft: "3px",
                      }}
                    >
                      <h4>
                        +
                        {shippingPrice === 0 || shippingPrice === null
                          ? t("Free")
                          : shippingPrice.toFixed(2)}
                        $
                      </h4>
                      <lable style={{ fontSize: "14px" }}>
                        {t("(Shipping)")}
                      </lable>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button onClick={handleSaveClick} className="button-primary">
                {t("Apply")}
              </button>
            </div>
          </>
        ) : (
          <>
            <button onClick={() => handleEditClick}>{t("Edit")}</button>
          </>
        )}
      </div>
    );
  };
  const handlePriceUpdate = (cardId, newPrice) => {
    // Update the card price in the parent state and optionally sync with the backend
    // const updatedCards = cards.map((card) =>
    //   card.id === cardId ? { ...card, estimateValue: newPrice } : card
    // );
    // setCards(updatedCards);
    console.log("outside priceupdate", cardId, newPrice);
    // Additionally, you can make an API call here to update the backend
  };

  const iconViewImageOnly = () => {
    const handleClickIcon = () => {
      setViewImageOnly(!viewImageOnly);
    };
    const eyeOpenIcon = () => {
      return (
        <button className="button-primary ExtraMargin">
          {t("Show Details")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            stroke="#fcfcfc"
            viewBox="0 0 24 24"
          >
            <g
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>{" "}
              <path d="M12.001 5C7.524 5 3.733 7.943 2.46 12c1.274 4.057 5.065 7 9.542 7 4.478 0 8.268-2.943 9.542-7-1.274-4.057-5.064-7-9.542-7z"></path>
            </g>
          </svg>
        </button>
      );
    };
    const eyeClosedIcon = () => {
      return (
        <button className="button-primary ExtraMargin">
          {t("Hide Details")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="#ffffff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M2.999 3l18 18M9.843 9.914a3 3 0 004.265 4.22M6.5 6.646A10.024 10.024 0 002.457 12c1.274 4.057 5.065 7 9.542 7 1.99 0 3.842-.58 5.4-1.582m-6.4-12.369c.329-.032.663-.049 1-.049 4.478 0 8.268 2.943 9.542 7a9.954 9.954 0 01-1.189 2.5"
            ></path>
          </svg>
        </button>
      );
    };

    return (
      <div onClick={() => handleClickIcon()}>
        {viewImageOnly ? eyeOpenIcon() : eyeClosedIcon()}
      </div>
    );
  };

  const iconViewPrice = () => {
    const handleClickIcon = () => {
      setViewPrice(!viewPrice);
    };

    const priceOpenIcon = () => {
      return (
        <button className="button-primary ExtraMargin">
          {t("Show Price")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={25}
            height={25}
            fill="#fff"
            viewBox="0 0 59.998 59.998"
          >
            <path d="M59.206.293a.999.999 0 0 0-1.414 0L54.085 4H30.802L1.532 33.511c-.666.666-1.033 1.553-1.033 2.495s.367 1.829 1.033 2.495l20.466 20.466a3.51 3.51 0 0 0 2.491 1.031 3.54 3.54 0 0 0 2.509-1.041l28.501-29.271V5.414l3.707-3.707a.999.999 0 0 0 0-1.414zm-5.707 28.581L25.574 57.553a1.53 1.53 0 0 1-2.162 0L2.946 37.087a1.532 1.532 0 0 1 .003-2.165L31.636 6h20.449l-4.833 4.833A4.969 4.969 0 0 0 44.499 10c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5a4.969 4.969 0 0 0-.833-2.753l4.833-4.833v21.46zm-6-13.874c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3c.462 0 .894.114 1.285.301l-1.992 1.992a.999.999 0 1 0 1.414 1.414l1.992-1.992c.188.391.301.823.301 1.285z" />
            <path d="M42.246 31.281 31.64 41.888a.999.999 0 1 0 1.414 1.414L43.66 32.695a.999.999 0 1 0-1.414-1.414zM45.779 27.74a1.012 1.012 0 0 0 0 1.42c.189.189.449.29.71.29.26 0 .52-.101.699-.29a.985.985 0 0 0 0-1.42c-.37-.37-1.029-.37-1.409 0zM37.296 19.26a.999.999 0 1 0-1.414-1.414L25.275 28.453a.999.999 0 1 0 1.414 1.414L37.296 19.26zM33.761 31.281a.997.997 0 0 0 1.414 0l7.071-7.071a.999.999 0 1 0-1.414-1.414l-7.071 7.071a.999.999 0 0 0 0 1.414zM28.104 35.523l-1.414 1.414a.999.999 0 1 0 1.414 1.414l1.414-1.414a.999.999 0 1 0-1.414-1.414zM17.497 28.745a.997.997 0 0 0 .707-.293L28.81 17.846a.999.999 0 1 0-1.414-1.414L16.79 27.038a.999.999 0 0 0 .707 1.707zM31.639 14.6c.26 0 .521-.1.71-.29.181-.189.29-.439.29-.71 0-.26-.109-.52-.3-.71-.37-.37-1.03-.37-1.41.01-.18.181-.29.44-.29.7s.11.521.29.71c.19.19.45.29.71.29zM22.449 31.28a.986.986 0 0 0-.29.71c0 .27.1.52.29.699.18.19.439.301.71.301.26 0 .52-.11.699-.29.19-.19.301-.45.301-.71 0-.261-.11-.521-.301-.71-.369-.37-1.04-.37-1.409 0zM32.349 34.109c.181-.18.29-.439.29-.71 0-.26-.109-.52-.29-.71-.38-.37-1.04-.37-1.42 0-.18.19-.29.45-.29.71 0 .271.11.521.29.71.19.19.45.29.71.29s.52-.099.71-.29zM24.651 47.627a4.983 4.983 0 0 0 .814-3.172 3.438 3.438 0 0 0-1.28-2.403 3.66 3.66 0 0 0-2.738-.781l-2.802.35-3.846-3.846a2.995 2.995 0 0 1 3.406.577.999.999 0 1 0 1.414-1.414 5.01 5.01 0 0 0-6.293-.635l-.779-.779a.999.999 0 1 0-1.414 1.414l.781.781a4.986 4.986 0 0 0-.813 3.172 3.438 3.438 0 0 0 1.279 2.402 3.66 3.66 0 0 0 2.739.783l2.802-.35 3.836 3.836c-1.111.501-2.51.318-3.396-.568a.999.999 0 1 0-1.414 1.414 4.965 4.965 0 0 0 3.535 1.465c.996 0 1.946-.291 2.757-.829l.622.622a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.624-.625zm-9.78-5.535a1.637 1.637 0 0 1-1.231-.352 1.462 1.462 0 0 1-.547-1.016 2.99 2.99 0 0 1 .295-1.532l2.742 2.742-1.259.158zm6.824 1.163c.433-.059.886.072 1.229.351.32.26.515.62.548 1.016a2.981 2.981 0 0 1-.296 1.532l-2.741-2.741 1.26-.158z" />
          </svg>
        </button>
      );
    };
    const priceClosedIcon = () => {
      return (
        <button className="button-primary ExtraMargin">
          {t("Hide Price")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={30}
            height={30}
            fill="#fff"
            viewBox="0 0 59.998 59.998"
          >
            <path d="M59.206.293a.999.999 0 0 0-1.414 0L54.085 4H30.802L1.532 33.511c-.666.666-1.033 1.553-1.033 2.495s.367 1.829 1.033 2.495l20.466 20.466a3.51 3.51 0 0 0 2.491 1.031 3.54 3.54 0 0 0 2.509-1.041l28.501-29.271V5.414l3.707-3.707a.999.999 0 0 0 0-1.414zm-5.707 28.581L25.574 57.553a1.53 1.53 0 0 1-2.162 0L2.946 37.087a1.532 1.532 0 0 1 .003-2.165L31.636 6h20.449l-4.833 4.833A4.969 4.969 0 0 0 44.499 10c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5a4.969 4.969 0 0 0-.833-2.753l4.833-4.833v21.46zm-6-13.874c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3c.462 0 .894.114 1.285.301l-1.992 1.992a.999.999 0 1 0 1.414 1.414l1.992-1.992c.188.391.301.823.301 1.285z" />
          </svg>
        </button>
      );
    };

    return (
      <div onClick={() => handleClickIcon()}>
        {viewPrice ? priceClosedIcon() : priceOpenIcon()}
      </div>
    );
  };

  // const handleChangePage = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  // const handleChangeItemsPerPage = (event) => {
  //   setItemsPerPage(Number(event.target.value));
  //   setCurrentPage(1); // Reset to the first page when changing the number of items per page
  // };

  const handleToggleFilters = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  //-----------------------------------------------FetchData(Get)---------------------------------------------------
  //----------------------Get Collections ForUniqueCardGrid----------------------
  function fetchCollectionsCards() {
    let apiEndpoint;
    let processResponse;
    if (userId && liveCsrfToken) {
      console.log("fetchCollectionsCards");
      const cardType = state.sport === "Hockey" ? "Hockey" : "Pokemon";
      // Determine which API endpoint and processing function to use
      if (cardGridType === "CardGrid") {
        apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUserCards/${userId}?cardType=${encodeURIComponent(cardType)}`;
        processResponse = (data) =>
          data.map((item) => ({
            userCardId: item.userCardId,
            ListId: item.ListId,
          }));
      } else if (cardGridType === "CardGridSell") {
        apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/getWatchListCards_MyListing/${userId}?cardType=${encodeURIComponent(cardType)}`;
        processResponse = (data) =>
          data.map((item) => ({
            userCardId: item.userCardId,
            WatchListId: item.WatchListId,
            ListId: item.WatchListId,
            CardId: item.CardId,
            //isAvailable: item.isAvailable,
          }));
      }

      // Prepare the request with CSRF token
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-csrf-token": liveCsrfToken, // Include CSRF token in headers
        },
        credentials: "include", // Ensure cookies are sent with the request
      };

      // Perform the API call to get the data
      fetch(apiEndpoint, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (!data || data.error) {
            console.error("Error fetching data:", data?.error);
            return;
          }

          const formattedData = processResponse(data);
          const myListings = data.filter(
            (card) => Number(card.UserId) === Number(userId),
          );
          // console.log("myListings", myListings);
          setMyListingCounts(myListings.length);

          // Update the state with the formatted data
          //console.log("Formatted Data:", formattedData, myListings.length);
          setAllCollectionCards(formattedData);
          // setFavoriteCards(
          //   formattedData.reduce((acc, card) => {
          //     if (card.WatchListId) {
          //       acc[card.userCardId] = {
          //         isFavorite: true,
          //         WatchListId: card.WatchListId,
          //       };
          //     }
          //     return acc;
          //   }, {})
          // );
        })

        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
    console.log("skipped fetchCollectionsCards not logging");
  }

  //----------------------Get CardsForUser----------------------

  //   function fetchCollections() {
  //     let apiEndpoint;
  //     let processResponse;
  //     console.log("fetchCollections() 856");
  //     // Determine which API endpoint to use based on CardGridType
  //     if (cardGridType === "CardGrid") {
  //       console.log("fetchCollections() 860");
  //       apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUser/${userId}`;
  //       processResponse = (data) =>
  //         data.map((item) => ({
  //           ListId: item.ListId,
  //           Title: item.Title,
  //           collectionCount: item.collectionCount,
  //           Public: item.Public,
  //         }));
  //     } else if (cardGridType === "CardGridSell") {
  //       apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/getWatchList/${userId}`;
  //       processResponse = (data) =>
  //         data.map((item) => ({
  //           ListId: item.WatchListId,
  //           WatchListId: item.WatchListId,
  //           Title: item.Title,
  //           collectionCount: item.watchlistCount,
  //           isDefault: item.isDefault,
  //           Public: item.Public,
  //         }));
  //     }
  //     // Perform the API call to get the collections
  //     fetch(apiEndpoint, {
  //   method: 'GET',
  //   credentials: 'include', // Ensures cookies (like session) are sent
  //   "Authorization": `Bearer ${jwtToken}`,
  // })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         // Update the collections state with the data from the API response
  //         const formattedData = processResponse(data);
  //         setCollections(formattedData);
  //         console.log("quebec formattedData", formattedData);
  //         setDefaultWatchlist(
  //           formattedData.find((collection) => collection.isDefault)
  //         );
  //         console.log(
  //           "DefaultWatchList",
  //           formattedData.find((collection) => collection.isDefault)
  //         );
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching collections:", error);
  //         console.log("fetchCollections() error");
  //       });
  //   }
  function fetchCollections() {
    let apiEndpoint;
    let processResponse;

    const cardType = state.sport === "Hockey" ? "Hockey" : "Pokemon"; // ✅
    const typeParam = `cardType=${encodeURIComponent(cardType)}`;

    console.log("fetchCollections() 856");

    if (cardGridType === "CardGrid") {
      console.log("fetchCollections() 860");
      apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUser/${userId}?${typeParam}`;

      processResponse = (data) =>
        data.map((item) => ({
          ListId: item.ListId,
          Title: item.Title,
          collectionCount: item.collectionCount, // IMPORTANT: doit être filtré côté backend aussi
          Public: item.Public,
        }));
    } else if (cardGridType === "CardGridSell") {
      apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/getWatchList/${userId}?${typeParam}`;

      processResponse = (data) =>
        data.map((item) => ({
          ListId: item.WatchListId,
          WatchListId: item.WatchListId,
          Title: item.Title,
          collectionCount: item.watchlistCount, // IMPORTANT: doit être filtré côté backend aussi
          isDefault: item.isDefault,
          Public: item.Public,
        }));
    } else {
      return;
    }

    fetch(apiEndpoint, {
      method: "GET",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        // Si tu utilises un header CSRF dans ton backend, décommente:
        "x-csrf-token": liveCsrfToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const formattedData = processResponse(data);
        setCollections(formattedData);
        console.log("fetchCollections() CardGrid apiEndpoint:", formattedData);
        // ✅ Seulement utile pour Watchlist
        if (cardGridType === "CardGridSell") {
          const def = formattedData.find((c) => c.isDefault);
          setDefaultWatchlist(def);
        }
      })
      .catch((error) => {
        console.error("Error fetching collections:", error);
      });
  }

  // function fetchRecentlyDeletedCards() {
  //   fetch(`${process.env.REACT_APP_API_BASE}/api/card/getRecentlyDeletedCards/${userId}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Update the collections state with the data from the API response

  //       setRecentlyDeletedCards(data);
  //     })
  //     .catch((error) => {
  //       // Handle the error
  //       console.error("Error fetching recently deleted cards:", error);
  //     });
  // }
  function fetchUnavailableCardInfo() {
    if (!userId || typeof userId !== "number") {
      console.error("Invalid user ID provided");
      return;
    }

    // Prepare the request with CSRF token
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "CSRF-Token": liveCsrfToken, // Include CSRF token in headers
      },
      credentials: "include", // Ensure cookies are sent with the request
    };

    // Perform the API call to get the unavailable card information
    fetch(
      `${process.env.REACT_APP_API_BASE}/api/marketplace/getUnavailableCardInfo/${userId}`,
      requestOptions,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch unavailable card information");
        }
        return response.json();
      })
      .then((data) => {
        // Update the unavailableCardInfo state with the data from the API response
        setUnavailableCardInfo(data);
      })
      .catch((error) => {
        // Handle the error
        console.error("Error fetching unavailable card information:", error);
      });
  }
  //----------------------End Get Collections/User----------------------
  //----------------------UseEffectToAssign(Cards/Collections)-------------------Must adapt

  // derive a simple readiness flag
  const authReady = !!userId && !!liveCsrfToken && !loading && isAuthenticated;

  // make a single fetchAll that uses the latest values
  const fetchAll = useCallback(() => {
    if (!authReady) return;

    if (cardGridType === "CardGridSell" || cardGridType === "CardGrid") {
      console.log("TRIGGGGGERERR");
      fetchCollections();
      fetchCollectionsCards();
      // (optional) also fetchUnavailableCardInfo() when needed
    }
  }, [authReady, cardGridType, state]); // keep deps minimal; fetch* refs are stable or inline them

  // run whenever auth becomes ready, or view changes
  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  // if you want to see what you fetched, react to state:
  useEffect(() => {
    console.log("allCollectionCards (fresh):", allCollectionCards);
  }, [allCollectionCards]);

  // useEffect(() => {
  //   console.log("fetchCollections() useeffect 928 avant if ");
  //   console.log("cardGridType:", cardGridType);

  //   if (userId && liveCsrfToken) {
  //     if (cardGridType === "CardGridSell" || cardGridType === "CardGrid") {
  //       console.log("fetchCollections() useeffect 928 dans 1er if ");
  //       fetchCollections();
  //       fetchCollectionsCards();
  //       console.log(allCollectionCards);
  //     }

  //     // if (cardGridType === "CardGridSell") {
  //     //   fetchUnavailableCardInfo();
  //     //   console.log("fetchCollections() useeffect 928 dans 2e if ");
  //     // }
  //   }
  //   // fetchRecentlyDeletedCards();
  //   // console.log("recentlyDeletedCards", recentlyDeletedCards);
  // }, [cardGridType,userId]);

  useEffect(() => {
    // Check if the effect has already run
    if (!hasEffectRunRef.current && cardGridType === "CardGrid") {
      setCheckedCheckboxes({ No: true });
      setFilterValues({ isGone: { No: true } });
      // Update the ref to indicate that the effect has run
      hasEffectRunRef.current = true;
    }
    if (cardGridType === "CardGridSell" && MultiCardOfferSelection === true) {
      setFilterValues({ GroupBy: { isForTrade: true } });
      //updateFilterValues("isForTrade", "isForTrade", true);
    } else if (
      cardGridType === "CardGridTrade" &&
      MultiCardOfferSelection === true
    ) {
      {
        setFilterValues({ GroupBy: { isForTrade: true } });
        updateFilterValues("isForTrade", "isForTrade", true);
      }
    }
  }, []);

  useEffect(() => {
    console.log("isGoneChecked ", isGoneChecked);
    console.log("checkedCheckboxes", checkedCheckboxes);
  }, [isGoneChecked]);

  useEffect(() => {
    console.log("-------------", filterValues);
  }, [filterValues]);
  //----------------------End UseEffectToAssign(Cards/Collections)-------------------
  //-----------------------------------------------End Of FetchData(Get)---------------------------------------------------
  //-----------------------------------------------HandleSingleAction---------------------------------------------------

  //-----------------------------------------------End - HandleSingleAction---------------------------------------------------
  //-----------------------------------------------actionCreateNewCollection - Handle - FetchData(Post)/CreateCollectionThenAssign---------------------------------------------------
  function handleCreateNewCollection() {
    console.log("Creating a collection and assigning to it");
    setCreateNewCollectionTitle((currentTitle) => {
      if (!currentTitle || currentTitle.trim() === "") {
        toast.error(t("InvalidCollectionTitle"));
        return currentTitle; // Stop execution
      }
      console.log(
        "Creating a collection collectionTitle",
        currentTitle,
        "createNewCollectionTitle",
        createNewCollectionTitle,
      );

      let apiEndpoint, successCallback;

      // Determine which API endpoint to use based on CardGridType
      if (cardGridType === "CardGrid") {
        apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/collection/add/collection`;
        successCallback = (data) => {
          const { listId } = data;
          console.log("Created list ID:", listId);
          console.log("Created list Title:", currentTitle);
          setCollections((prevCollections) => [
            ...prevCollections,
            {
              ListId: listId, // Use correct structure
              Title: currentTitle,
              collectionCount: 0, // Initialize count as 0
            },
          ]);
          if (selectedCards.length > 0) insertCardsIntoList("CardGrid", listId);
        };
      } else if (cardGridType === "CardGridSell") {
        apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/add/watchlist`;
        successCallback = (data) => {
          const { watchlistId } = data;
          console.log("Created list ID:", watchlistId);
          console.log("Created list Title:", currentTitle);
          setCollections((prevCollections) => [
            ...prevCollections,
            {
              ListId: watchlistId, // Use correct structure
              Title: currentTitle,
              collectionCount: 0, // Initialize count as 0
            },
          ]);
          if (selectedCards.length > 0)
            insertCardsIntoList("CardGridSell", watchlistId);
        };
      }

      // Perform the API call to create a collection or watchlist
      fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ userId, currentTitle, liveCsrfToken }), // Include CSRF token
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.listId || data.watchlistId) {
            successCallback(data);
            toast.success(t("WatchlistCreatedSuccessfully"));
          } else {
            console.error("Error creating list:", data.error);
            toast.error(t("ErrorCreatingWatchlist"));
          }
          fetchCollections();
          fetchCollectionsCards();
          setCreateNewCollectionTitle("");
          setSelectedAction1("");
        })
        .catch((error) => {
          console.error("Error creating list:", error);
          toast.error(t("ErrorCreatingWatchlist"));
        });

      return currentTitle;
    });
  }

  function handleRenameCollection() {
    setRenameCollectionTitle((currentTitle) => {
      if (!currentTitle || currentTitle.trim() === "") {
        toast.error(t("Please enter a valid collection name"));
        return currentTitle; // Stop execution if invalid
      }

      let apiEndpoint;

      // Determine the API endpoint based on the CardGridType
      if (cardGridType === "CardGrid") {
        apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/collection/rename/collection`;
      } else if (cardGridType === "CardGridSell") {
        apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/rename/watchlist`;
      }

      const requestData = {
        userId,
        currentTitle,
        selectedCollectionLive,
        liveCsrfToken, // Include CSRF token in the request body
      };

      fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            // Collection renamed successfully
            console.log("Renamed list", "Title:", currentTitle);
            toast.success(t("WatchlistRenamedSuccess"));
            setCollections((prev) =>
              prev.map((collection) =>
                collection.ListId === selectedCollectionLive
                  ? { ...collection, Title: currentTitle } // ✅ Update UI immediately
                  : collection,
              ),
            );
            setModalVisible(false);
          } else {
            // Error occurred during renaming
            console.error("Error renaming list:", data.error);
            toast.error(t("ErrorRenamingWatchlist"));
          }
        })
        .catch((error) => {
          console.error("Error renaming list:", error);
          toast.error(t("ErrorRenamingWatchlist"));
        });
      return currentTitle;
    });
  }

  function handleSetAsDefault(selectedCollectionWatchListId) {
    console.log(
      "Setting the collection as default with id:",
      selectedCollectionWatchListId,
    );

    const apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/setAsDefault`;

    const requestData = {
      userId,
      selectedCollectionWatchListId,
      liveCsrfToken, // Include CSRF token in the request body
    };

    fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Collection successfully set as default
          console.log(
            "Default list set successfully. Collection ID:",
            selectedCollectionWatchListId,
          );
          setDefaultWatchlist(selectedCollectionWatchListId);

          // ✅ Update collections list to mark only this as default
          setCollections((prevCollections) =>
            prevCollections.map((collection) => ({
              ...collection,
              isDefault: collection.ListId === selectedCollectionWatchListId, // Only one default
            })),
          );
          toast.success(t("WatchlistSetAsDefaultSuccess"));
        } else {
          // Error occurred during setting default
          console.error("Error setting default list:", data.error);
          toast.error(t("ErrorSettingDefaultWatchlist"));
        }
      })
      .catch((error) => {
        console.error("Error setting default list:", error);
        toast.error(t("ErrorSettingDefaultWatchlist"));
      });
  }

  //-----------------------------------------------FetchData(Post)/AddCardToCollection---------------------------------------------------
  // Function to insert into cards_cardslist table
  function insertIntoCardsCardsList(listId) {
    const requestData = {
      listId: listId,
      cardIds: selectedCards,
    };

    fetch(`${process.env.REACT_APP_API_BASE}/api/collection/add/card`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Card inserted into cards_cardslist table");
      })
      .catch((error) => {
        console.error("Error inserting card into cards_cardslist:", error);
      });
  }
  function insertSingleIntoCardsCardsList(listId, cardId) {
    const requestData = {
      listId: listId,
      cardIds: cardId,
      liveCsrfToken: liveCsrfToken,
      userId: userId,
    };

    fetch(`${process.env.REACT_APP_API_BASE}/api/collection/add/card`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Card inserted into cards_cardslist table");
      })
      .catch((error) => {
        console.error("Error inserting card into cards_cardslist:", error);
      });
  }

  // WATCH LIST FOR CARDGRIDSELL
  function insertIntoCardsWatchList(WatchlistId, liveCsrfToken) {
    const requestData = {
      WatchListId: WatchlistId,
      cardIds: selectedCards,
      liveCsrfToken: liveCsrfToken,
      userId: userId, // Include CSRF token in the request body
    };

    fetch(
      `${process.env.REACT_APP_API_BASE}/api/marketplace/watchlist/add/cards`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // Ensure credentials (cookies) are included
        body: JSON.stringify(requestData),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          toast.success(t("CardsInsertedIntoWatchlistSuccess"));
        } else if (data.error) {
          toast.error(t("FailedToInsertCardsIntoWatchlist"));
        }
      })
      .catch((error) => {
        console.error("Error inserting card into cards_watchlist:", error);
        toast.error(t("ErrorInsertingCardIntoWatchlist"));
      });
  }

  function insertCardsIntoList(listType, listId, cardsId) {
    if (!listId) {
      toast.error("Please select a list first.");
      console.warn("ListId not set, skipping insert.");
      return;
    }
    // Set endpoint and parameter key based on the list type
    console.log("listType, listId, cardsId", listType, listId, cardsId);
    const endpoint =
      listType === "CardGrid"
        ? `${process.env.REACT_APP_API_BASE}/api/collection/add/card`
        : `${process.env.REACT_APP_API_BASE}/api/marketplace/watchlist/add/cards`;
    const key = listType === "CardGrid" ? "listId" : "WatchListId";

    // Ensure we use `cardsId` if provided, otherwise fallback to `selectedCards`
    const cardIdsToUse =
      Array.isArray(cardsId) && cardsId.length > 0 ? cardsId : selectedCards;

    // Prepare request data
    const requestData = {
      [key]: listId,
      cardIds: cardIdsToUse,
      userId: userId,
      liveCsrfToken: liveCsrfToken,
    };
    console.log("pre-insert requestData", requestData);
    // Execute fetch request
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        toast.success(t("Card(s) Added"));
        console.log(
          `Card inserted into ${
            listType === "CardGrid" ? "cards_cardslist" : "cards_watchlist"
          } table`,
        );

        //         // **Update allCollectionCards after adding**
        //         setAllCollectionCards((prevCards) => [
        //           ...prevCards,
        //           ...selectedCards.map((cardId) => ({
        //             userCardId: cardId, // Ensure this field matches the existing structure
        //             ListId: listId, // Assign the new list ID
        //           })),
        //         ]);
        //        // ✅ Update collection count
        // setCollections((prevCollections) =>
        //   prevCollections.map((collection) =>
        //     parseInt(collection.ListId) === parseInt(listId)
        //       ? {
        //           ...collection,
        //           collectionCount: collection.collectionCount + selectedCards.length,
        //         }
        //       : collection
        //   )
        // );

        // Filter out cards that are already in the list
        const uniqueNewCards = selectedCards.filter(
          (cardId) =>
            !allCollectionCards.some(
              (existingCard) =>
                parseInt(existingCard.userCardId) === parseInt(cardId) &&
                String(existingCard.ListId) === String(listId),
            ),
        );

        // ✅ Update allCollectionCards without duplicates
        setAllCollectionCards((prevCards) => [
          ...prevCards,
          ...uniqueNewCards.map((cardId) => ({
            userCardId: cardId,
            ListId: listId,
          })),
        ]);

        // ✅ Update collection count only by number of unique new cards
        setCollections((prevCollections) =>
          prevCollections.map((collection) =>
            String(collection.ListId) === String(listId)
              ? {
                  ...collection,
                  collectionCount:
                    collection.collectionCount + uniqueNewCards.length,
                }
              : collection,
          ),
        );
      })
      .catch((error) => {
        toast.error(t("Error Adding those card(s)"));
        console.error(
          `Error inserting card into ${
            listType === "CardGrid" ? "cards_cardslist" : "cards_watchlist"
          }:`,
          error,
        );
      });
  }
  //-----------------------------------------------FetchData(Delete)/CardFromCollection---------------------------------------------------
  // Function to delete from cards_cardslist table
  function removeFromCardsCardsList() {
    const cardIds =
      singleCardOperationId !== 0
        ? [singleCardOperationId]
        : [...selectedCards];
    let apiEndpoint, requestData;

    // Select the API endpoint and set requestData based on CardGridType
    if (cardGridType === "CardGrid") {
      apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/collection/remove/card`;
      requestData = {
        listId: selectedCollectionLive, // Assuming this is a list ID for collections
        cardIds: cardIds,
        liveCsrfToken: liveCsrfToken,
        userId: userId,
      };
    } else if (cardGridType === "CardGridSell") {
      apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/remove/card`;
      requestData = {
        WatchListId: selectedCollectionLive, // Assuming this is a watchlist ID for marketplace
        cardIds: cardIds,
        liveCsrfToken: liveCsrfToken,
        userId: userId,
      };
    }

    fetch(apiEndpoint, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // Include credentials (cookies)
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        toast.success(t("Cards deleted successfully"));

        // ✅ Remove deleted cards from `allCollectionCards`
        setAllCollectionCards((prevCards) =>
          prevCards.filter(
            (card) =>
              parseInt(card.ListId) !== parseInt(selectedCollectionLive) || // Keep cards from other lists
              !cardIds.includes(parseInt(card.userCardId)), // Remove matching deleted cards
          ),
        );

        // ✅ Update `selectedCollectionCards` to match the current list
        setSelectedCollectionCards((prevCards) =>
          prevCards.filter(
            (card) => !cardIds.includes(parseInt(card.userCardId)),
          ),
        );

        setCollections((prevCollections) =>
          prevCollections.map((collection) =>
            parseInt(collection.ListId) === parseInt(selectedCollectionLive)
              ? {
                  ...collection,
                  collectionCount: Math.max(
                    0,
                    collection.collectionCount - cardIds.length,
                  ),
                }
              : collection,
          ),
        );
        // ✅ Ensure UI updates by removing from selected cards too
        setSelectedCards([]);

        setConfirmationVisibleForDeleteFromCollectionOnly(false);
        setSelectedCards([]);
        // fetchCollectionsCards();
        // fetchCollections();
        // setNeedToReset(!needToReset);
        setSingleCardOperationId(0);
      })
      .catch((error) => {
        toast.error(t("Failed to delete cards"));
        setConfirmationVisibleForDeleteFromCollectionOnly(false);
      });
  }

  function removeFromWatchListUnavailable(cardId) {
    const requestData = {
      WatchListId: selectedCollectionLive,
      cardId: cardId,
      liveCsrfToken: liveCsrfToken, // Include CSRF token
    };

    fetch(
      `${process.env.REACT_APP_API_BASE}/api/marketplace/remove/unavailableCards`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // Include credentials (cookies)
        body: JSON.stringify(requestData),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          console.log("Cards deleted from cards_watchlist table");
          fetchCollectionsCards();
          fetchCollections();
          setNeedToReset(!needToReset);
        } else {
          console.error("Failed to delete cards from cards_watchlist.");
        }
      })
      .catch((error) => {
        console.error("Error deleting cards from cards_watchlist:", error);
      });
  }

  //----------------------Delete watchlist and cards_watchlist

  function deleteCollection(isConfirmed) {
    if (isConfirmed) {
      const requestData = {
        listId: selectedCollectionLive,
        userId: userId,
        liveCsrfToken: liveCsrfToken,
      };
      // Handle user's response
      console.log("This is it", selectedCollectionLive, userId);
      fetch(
        `${process.env.REACT_APP_API_BASE}/api/collection/remove/thisWatchList`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(requestData),
        },
      )
        .then((response) => response.json())
        .then(() => {
          console.log("Collection Deleted");
          fetchCollectionsCards();
          fetchCollections();
          setNeedToReset(!needToReset);
        })
        .catch((error) => {
          console.error("Error deleting this collection", error);
        });
      setConfirmationVisibleDeleteCollection(false);
    }
  }

  function deleteCollectionOrWatchlist() {
    let apiEndpoint, requestData;

    // Select the API endpoint and set requestData based on CardGridType
    if (cardGridType === "CardGrid") {
      apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/collection/remove/thisWatchList`;
      requestData = {
        listId: selectedCollectionLive, // Assuming this is a list ID for collections
        userId: userId,
        liveCsrfToken, // Include CSRF token in the request body
      };
    } else if (cardGridType === "CardGridSell") {
      apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/remove/thisWatchList`;
      requestData = {
        WatchListId: selectedCollectionLive, // Assuming this is a watchlist ID for marketplace
        userId: userId,
        liveCsrfToken, // Include CSRF token in the request body
      };
    }

    fetch(apiEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          // Watchlist or collection deleted successfully
          toast.success(t("CollectionOrWatchlistDeletedSuccess")); // Success toast
          // Remove the deleted collection from state
          setCollections((prevCollections) =>
            prevCollections.filter(
              (collection) =>
                parseInt(collection.ListId) !==
                parseInt(selectedCollectionLive),
            ),
          );
          setSelectedCollectionLive("");
        } else {
          // Error occurred during deletion
          toast.error(t("ErrorDeletingCollectionOrWatchlist")); // Error toast
          console.error(
            "Failed to delete the collection/watchlist. Server error:",
            data.error,
          );
        }
      })
      .catch((error) => {
        toast.error(t("ErrorDeletingCollectionOrWatchlist")); // Error toast
        console.error("Error deleting the collection/watchlist:", error);
      });
  }

  //-----------------------Not For Sale - Group delete.  /api/marketplace/changeStatus/NotForSale
  function removeFromMarketplaceNotForSale(isConfirmed) {
    if (isConfirmed) {
      const requestData = {
        userId: userId, // Change key to lowercase "userId"
        cardIds: selectedCards,
        liveCsrfToken: liveCsrfToken, // Include CSRF token in the request body
      };

      fetch(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/changeStatus/NotForSale`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include", // Include credentials (cookies)
          body: JSON.stringify(requestData),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            toast.success(t("Updated"));

            fetchCollectionsCards();
            fetchCollections();
            setNeedToReset(!needToReset);
            setConfirmationVisibleNotForSale(false);
          } else {
            toast.error(t("Update failed"));
            console.error(
              "Failed to remove listings. Server error:",
              data.error,
            );
          }
        })
        .catch((error) => {
          console.error("Error deleting Listings", error);
        });
    }
  }

  function removeFromMarketplaceNotForTrade(isConfirmed) {
    if (isConfirmed) {
      const requestData = {
        userId: userId, // Change key to lowercase "userId"
        cardIds: selectedCards,
        liveCsrfToken: liveCsrfToken, // Include CSRF token in the request body
      };

      fetch(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/changeStatus/NotForTrade`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include", // Include credentials (cookies)
          body: JSON.stringify(requestData),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            toast.success(t("Updated"));
            fetchCollectionsCards();
            fetchCollections();
            setNeedToReset(!needToReset);
            setConfirmationVisibleNotForSale(false);
          } else {
            toast.error(t("Update failed"));
          }
        })
        .catch((error) => {
          console.error("Error deleting Listings:", error);
        });
    }
  }

  // function removeFromMarketplaceNotForSaleSingle(isConfirmed, cardId) {
  //   if (isConfirmed) {
  //     const requestData = {
  //       userId: userId, // Change key to lowercase "userId"
  //       cardIds: [cardId],
  //       liveCsrfToken: liveCsrfToken, // Include CSRF token in the request body
  //     };

  //     fetch("https://projet-collect-v1-production.up.railway.app/api/marketplace/changeStatus/NotForSale", {
  //       method: "DELETE",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       credentials: "include", // Include credentials (cookies)
  //       body: JSON.stringify(requestData),
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.success) {
  //           toast.success(t("Updated"));
  //           fetchCollectionsCards();
  //           fetchCollections();
  //           setNeedToReset(!needToReset);
  //           setConfirmationVisibleNotForSale(false);
  //         } else {
  //           toast.error(t("Update failed"));
  //           console.error(
  //             "Failed to remove listings. Server error:",
  //             data.error
  //           );
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error deleting Listings", error);
  //       });
  //   }
  // }

  // function removeFromMarketplaceNotForTradeSingle(isConfirmed, cardId) {
  //   if (isConfirmed) {
  //     const requestData = {
  //       UserId: userId,
  //       cardIds: [cardId],
  //     };

  //     fetch("https://projet-collect-v1-production.up.railway.app/api/marketplace/changeStatus/NotForTrade", {
  //       method: "DELETE",
  //       headers: { "Content-Type": "application/json" },
  //       credentials: "include",
  //       body: JSON.stringify(requestData),
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.success) {
  //           toast.success(t("Updated"));
  //           fetchCollectionsCards();
  //           fetchCollections();
  //           setNeedToReset(!needToReset);
  //           setConfirmationVisibleNotForSale(false);
  //         } else {
  //           toast.error(t("Update failed"));
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error deleting Listings ", error);
  //       });
  //   }
  // }

  // function removeFromMarketplaceNotPC(isConfirmed, cardId) {
  //   if (isConfirmed) {
  //     const requestData = {
  //       userId: userId, // Change key to lowercase "userId"
  //       cardIds: [cardId],
  //       liveCsrfToken: liveCsrfToken, // Include CSRF token in the request body
  //     };

  //     fetch("https://projet-collect-v1-production.up.railway.app/api/marketplace/changeStatus/NotPC", {
  //       method: "DELETE",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       credentials: "include", // Include credentials (cookies)
  //       body: JSON.stringify(requestData),
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.success) {
  //           toast.success(t("Updated"));
  //           fetchCollectionsCards();
  //           fetchCollections();
  //           setNeedToReset(!needToReset);
  //         } else {
  //           toast.error(t("Update failed"));
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error removing PC", error);
  //       });
  //   }
  // }

  // function removeFromMarketplaceNotOnEbay(isConfirmed, cardId) {
  //   if (isConfirmed) {
  //     const requestData = {
  //       userId: userId,
  //       cardIds: [cardId],
  //       liveCsrfToken: liveCsrfToken, // Include CSRF token in the request body
  //     };

  //     fetch("https://projet-collect-v1-production.up.railway.app/api/marketplace/changeStatus/NotOnEbay", {
  //       method: "DELETE",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       credentials: "include", // Ensure credentials are included
  //       body: JSON.stringify(requestData),
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.success) {
  //           toast.success(t("Updated"));
  //           fetchCollectionsCards();
  //           fetchCollections();
  //           setNeedToReset(!needToReset);
  //         } else {
  //           toast.error(t("Update failed"));
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error removing OnEbay", error);
  //       });
  //   }
  // }

  // ✅ Generalized function to update filteredCards state
  const updateFilteredCard = (cardId, updatedFields) => {
    setFilteredCards((prevCards) =>
      prevCards.map((card) =>
        card.id === cardId
          ? { ...card, ...updatedFields } // ✅ Merge updated fields
          : card,
      ),
    );
  };

  // ✅ Remove from sale
  function removeFromMarketplaceNotForSaleSingle(isConfirmed, cardId) {
    if (isConfirmed) {
      const requestData = {
        userId,
        cardIds: [cardId],
        liveCsrfToken,
      };

      fetch(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/changeStatus/NotForSale`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(requestData),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            toast.success(t("Updated"));
            updateFilteredCard(cardId, { isForSale: false }); // ✅ Update state directly
          } else {
            toast.error(t("Update failed"));
          }
        })
        .catch((error) => console.error("Error removing from sale", error));
    }
  }

  // ✅ Remove from trade
  function removeFromMarketplaceNotForTradeSingle(isConfirmed, cardId) {
    if (isConfirmed) {
      const requestData = {
        userId,
        cardIds: [cardId],
      };

      fetch(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/changeStatus/NotForTrade`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(requestData),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            toast.success(t("Updated"));
            updateFilteredCard(cardId, { isForTrade: false }); // ✅ Update state directly
          } else {
            toast.error(t("Update failed"));
          }
        })
        .catch((error) => console.error("Error removing from trade", error));
    }
  }

  // ✅ Remove from PC
  function removeFromMarketplaceNotPC(isConfirmed, cardId) {
    if (isConfirmed) {
      const requestData = {
        userId,
        cardIds: [cardId],
        liveCsrfToken,
      };

      fetch(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/changeStatus/NotPC`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(requestData),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            toast.success(t("Updated"));
            updateFilteredCard(cardId, { isPC: false }); // ✅ Update state directly
          } else {
            toast.error(t("Update failed"));
          }
        })
        .catch((error) => console.error("Error removing from PC", error));
    }
  }

  // ✅ Remove from eBay
  function removeFromMarketplaceNotOnEbay(isConfirmed, cardId) {
    if (isConfirmed) {
      const requestData = {
        userId,
        cardIds: [cardId],
        liveCsrfToken,
      };

      fetch(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/changeStatus/NotOnEbay`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(requestData),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            toast.success(t("Updated"));
            updateFilteredCard(cardId, { isOnEbay: false }); // ✅ Update state directly
          } else {
            toast.error(t("Update failed"));
          }
        })
        .catch((error) => console.error("Error removing from eBay", error));
    }
  }

  function removeFromMarketplaceMarkAsSold(userCardId) {
    setSoldPriceInput((soldPrice) => {
      if (!soldPrice || soldPrice.trim() === "") {
        toast.error(t("Please enter a valid price"));
        return soldPrice; // Stop execution if invalid
      }

      const requestData = {
        userId: userId,
        userCardId: userCardId,
        liveCsrfToken: liveCsrfToken,
        price: soldPrice,
      };

      console.log(userCardId, "userCardId", "soldPrice", soldPrice);

      fetch(`${process.env.REACT_APP_API_BASE}/api/marketplace/markAsSold`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            toast.success(t("Updated"));

            // ✅ Call API to fully remove card after marking as sold
            fetch(`${process.env.REACT_APP_API_BASE}/api/remove/card`, {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
              },
              credentials: "include",
              body: JSON.stringify({
                cardIds: [userCardId], // ✅ Send as an array
                liveCsrfToken: liveCsrfToken,
                userId: userId,
              }),
            })
              .then((response) => response.json())
              .then((deleteData) => {
                if (deleteData.message) {
                  toast.success(t("ListingDisabledSuccess"));

                  // ✅ Remove the sold card from the UI
                  setFilteredCards((prevCards) =>
                    prevCards.filter(
                      (card) => parseInt(card.id) !== parseInt(userCardId),
                    ),
                  );
                } else {
                  toast.error(t("ListingDisabledFailed"));
                  console.error(
                    "Failed to delete card. Server error:",
                    deleteData.error,
                  );
                }
              })
              .catch((error) => {
                console.error("Error deleting card", error);
                toast.error(t("ErrorDeletingCollectionOrWatchlist"));
              });
          } else {
            toast.error(t("Update failed"));
            console.error("Failed to mark as sold. Server error:", data.error);
          }
        })
        .catch((error) => {
          console.error("Error marking as sold", error);
        });

      return soldPrice;
    });
  }

  //-----------------------------------------------FetchData(Put)/UpdateCardsStatus---------------------------------------------------
  function updateStatusForCards(confirmationToUpdateStatus) {
    const requestData = {
      userId: userId, // Include userId for validation
      cardIds: selectedCards, // Selected card IDs
      isPcUpdate: confirmationToUpdateStatus.isPcUpdate, // PC status update
      isForSaleUpdate: confirmationToUpdateStatus.isForSaleUpdate, // For sale status update
      isForTradeUpdate: confirmationToUpdateStatus.isForTradeUpdate, // For trade status update
      isOnEbayUpdate: confirmationToUpdateStatus.isOnEbayUpdate, // eBay status update
      liveCsrfToken: liveCsrfToken, // Include CSRF token for validation
    };

    fetch(`${process.env.REACT_APP_API_BASE}/api/collection/update/status`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        toast.success(t("Updated"));
        // Handle the response data if needed
      })
      .catch((error) => {
        toast.error(t("Update failed"));
      });
  }

  //-----------------------------------------------Filters---------------------------------------------------
  useEffect(() => {
    console.log("current card", cards);

    if (!Array.isArray(cards) || cards.length === 0) {
      setFilteredCards([]);
      setOriginalData([]);
      setFilteredGroupedCards(new Map());
      setTotalCardLenght(0);
      setTotalCardValue(0);
      setTotalSellingValue(0);
      return;
    }

    // -----------------------------
    // 1) Build active filters list (EXCLUDE special keys handled elsewhere)
    // -----------------------------
    const EXCLUDED_KEYS = new Set([
      "SearchBar",
      "ExactCardId",
      "ExactCardLabel",
      "ExactCardOnly",
    ]);

    const filterBy = Object.entries(filterValues).filter(([key, value]) => {
      if (EXCLUDED_KEYS.has(key)) return false;

      if (key === "minPrice" || key === "maxPrice") {
        return value !== "";
      }

      const checkedValues = Object.entries(value || {})
        .filter(([, v]) => v)
        .map(([k]) => k);

      return checkedValues.length > 0;
    });

    // -----------------------------
    // 2) Score cards for SearchTitle (works for Pokémon too)
    // -----------------------------
    const cardsWithScore = cards.map((card) => {
      let score = 0;

      const searchTitle =
        card.SearchTitle || card.searchTitle || card.Searchtitle || "";
      if (activeSearchTerm && searchTitle) {
        const keywords = activeSearchTerm.split(" ").filter(Boolean);
        const parts = searchTitle.split(" - ");

        const playerName = (parts[0] || "").toLowerCase();
        const yearAndSet =
          parts.length > 1 ? (parts[1] || "").toLowerCase() : "";
        const year = yearAndSet.split(" ")[0] || "";
        const cardName = parts.length > 2 ? (parts[2] || "").toLowerCase() : "";
        const variation =
          parts.length > 3 ? (parts[3] || "").toLowerCase() : "";
        const numberBehind =
          parts.length > 4 ? (parts[4] || "").toLowerCase() : "";

        keywords.forEach((kw) => {
          const q = kw.toLowerCase();
          if (playerName.includes(q)) score += 5;
          if (year.startsWith(q)) score += 3;
          if (cardName.includes(q)) score += 2;
          if (variation.includes(q)) score += 2;
          if (numberBehind.startsWith("#" + q)) score += 5;
        });
      }

      return { ...card, score };
    });

    // sort by score only (do not drop yet)
    const sortedCards = [...cardsWithScore].sort((a, b) => b.score - a.score);

    // -----------------------------
    // 3) Apply all regular filters (AND)
    //    + Search as AND too
    // -----------------------------
    const filteredCardsBase = sortedCards.filter((card) => {
      // Search AND
      if (activeSearchTerm) {
        if (!card.SearchTitle) return false;
        if (card.score <= 0) return false;
      }

      // Normal filters AND
      return filterBy.every(([key, value]) => {
        if (key === "SearchTitle") return true; // already handled

        if (key === "ShowName" && value?.SavedSeller) {
          const favoriteSellerIds = favoriteSellers.map((fav) => fav.SellerId);
          return favoriteSellerIds.length > 0
            ? favoriteSellerIds.includes(parseInt(card.UserId))
            : true;
        }

        if (key === "minPrice") {
          return (
            value === "" || parseFloat(card.EstimateValue) >= parseFloat(value)
          );
        }

        if (key === "maxPrice") {
          return (
            value === "" || parseFloat(card.EstimateValue) <= parseFloat(value)
          );
        }

        if (key === "Attribut") {
          const checkedValues = Object.entries(value || {})
            .filter(([, v]) => v)
            .map(([k]) => k);

          const attributeMatches = checkedValues.map((attr) => {
            switch (attr) {
              case "IsRookie":
                return card.IsRookie === "Rookie(RC)";
              case "IsAuto":
                return card.IsAuto !== "NotAuto";
              case "IsPatch":
                return card.IsPatch !== "NotPatch";
              case "IsJersey":
                return card.IsJersey !== "NotJersey";
              default:
                return false;
            }
          });

          return attributeFilterLogic === "Or"
            ? attributeMatches.some(Boolean)
            : attributeMatches.every(Boolean);
        }

        if (key === "GroupBy") {
          const checkedValues = Object.entries(value || {})
            .filter(([, v]) => v)
            .map(([k]) => k);

          const groupMatches = checkedValues.map((attr) => {
            switch (attr) {
              case "isPC":
                return card.isPC === "isPC";
              case "isOnEbay":
                return card.isOnEbay === "isOnEbay";
              case "isForTrade":
                return card.isForTrade === "isForTrade";
              case "isForSale":
                return card.isForSale === "isForSale";
              default:
                return false;
            }
          });

          return isWhatFilterLogic === "Or"
            ? groupMatches.some(Boolean)
            : groupMatches.every(Boolean);
        }

        // Generic include match
        const checkedValues = Object.entries(value || {})
          .filter(([, v]) => v)
          .map(([k]) => k);

        return checkedValues.includes(String(card[key]));
      });
    });

    // -----------------------------
    // 4) Collection filter
    // -----------------------------
    let filteredCards = filteredCardsBase;

    if (
      selectedCollectionLive &&
      selectedCollectionLive !== "" &&
      selectedCollectionLive !== 0
    ) {
      if (cardGridType === "CardGrid") {
        filteredCards = filteredCards.filter((card) =>
          selectedCollectionCards.some(
            (collectionCard) =>
              parseInt(card.id) === parseInt(collectionCard.userCardId),
          ),
        );
      }

      if (cardGridType === "CardGridSell") {
        filteredCards = filteredCards.filter((card) =>
          selectedCollectionCards.some(
            (collectionCard) =>
              parseInt(card.userCardId) === parseInt(collectionCard.userCardId),
          ),
        );
      }
    }

    // -----------------------------
    // 5) Exact Card filter (apply LAST)
    // -----------------------------
    const exactOnlyOn = !!filterValues?.ExactCardOnly?.Only;

    if (exactOnlyOn) {
      const wantedIds = Object.entries(filterValues?.ExactCardId || {})
        .filter(([, v]) => v)
        .map(([k]) => Number(k))
        .filter((n) => !Number.isNaN(n));

      if (wantedIds.length > 0) {
        const wantedSet = new Set(wantedIds);
        filteredCards = filteredCards.filter((card) =>
          wantedSet.has(Number(card.CardId)),
        );
      }
    }

    // -----------------------------
    // 6) Save + grouped + totals
    // -----------------------------
    setFilteredCards(filteredCards);
    setOriginalData(filteredCards);

    const uniqueIds = new Set(filteredCards.map((card) => card.CardId));
    const filteredGrouped = new Map(
      [...groupedCards].filter(([_, value]) => uniqueIds.has(value.CardId)),
    );
    setFilteredGroupedCards(filteredGrouped);

    const { totalValue, totalPrice, totalLength } = filteredCards.reduce(
      (acc, card) => {
        acc.totalValue += parseFloat(card.EstimateValue) || 0;
        acc.totalPrice += parseFloat(card.Price) || 0;
        acc.totalLength += 1;
        return acc;
      },
      { totalValue: 0, totalPrice: 0, totalLength: 0 },
    );

    setTotalCardLenght(totalLength);
    setTotalCardValue(totalValue);
    setTotalSellingValue(totalPrice);
  }, [
    cards,
    filterValues,
    activeSearchTerm,
    selectedCollectionCards,
    selectedCollectionLive,
    attributeFilterLogic,
    isWhatFilterLogic,
    triggerFilterChange,
    isViewCollection,
    isViewMyListings,
    viewAsGrid,
  ]);

  //--------------------------------------------End of useEffect for filters---------------------------------------------------

  function filterCardBySelectedCollection(selectedListId) {
    setTempoCards(cards);

    if (cardGridType === "CardGrid" || cardGridType === "CardGridSell") {
      const filteredData = allCollectionCards.filter(
        (item) => parseInt(item.ListId) === parseInt(selectedListId),
      );

      setSelectedCollectionCards(filteredData);
      console.log("setSelectedColelction 289", filteredData);

      console.log("allcollectioncards 291", allCollectionCards);
      if (cardGridType === "CardGrid") setIsViewCollection(true);
    } else setIsViewCollection = false;
  }

  // const applyTradingPreference = (pref) => {
  //   // Helper to parse stringified arrays
  //   const parseList = (raw) => {
  //     try {
  //       return JSON.parse(raw);
  //     } catch {
  //       return [];
  //     }
  //   };

  //   // 1. Player Names
  //   pref.PlayerNames?.split(",").forEach((player) => {
  //     const clean = player.trim();
  //     if (clean) updateFilterValues("Name", clean, true);
  //   });

  //   // 2. Set Names
  //   pref.SetNames?.split(",").forEach((set) => {
  //     const clean = set.trim();
  //     if (clean) updateFilterValues("SetName", clean, true);
  //   });

  //   // 3. Card Names
  //   pref.CardNames?.split(",").forEach((card) => {
  //     const clean = card.trim();
  //     if (clean) updateFilterValues("cardName", clean, true);
  //   });

  //   // 4. Variation Names
  //   pref.VariationNames?.split(",").forEach((variation) => {
  //     const clean = variation.trim();
  //     if (clean) updateFilterValues("variationName", clean, true);
  //   });

  //   // 5. Attribute Booleans
  //   if (pref.isOnlyRookie) updateFilterValues("IsRookie", "IsRookie", true);
  //   if (pref.isOnlyAuto) updateFilterValues("IsAuto", "IsAuto", true);
  //   if (pref.isOnlyPatch) updateFilterValues("IsPatch", "IsPatch", true);
  //   if (pref.isOnlyJersey) updateFilterValues("IsJersey", "IsJersey", true);
  // };

  // const handleTradePrefChange = (selectedOption) => {
  //   resetFilters();
  //   const selectedPref = tradingPreferences.find(
  //     (pref) => pref.TradingPreferencesId === parseInt(selectedOption?.value)
  //   );
  //   console.log("selectedPref", selectedPref);
  //   if (!selectedPref) {
  //     setSelectedTradePref("");
  //     return;
  //   }

  //   setSelectedTradePref(selectedOption);
  //   applyTradingPreference(selectedPref);
  // };

  // Utils
  const parseJSON = (raw) => {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };
  const splitCSV = (raw) =>
    (raw || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

  // --- Applique un template d’échange au panneau de filtres ---
  // const applyTradingPreference = (pref) => {
  //   // reset contrôlé si besoin (ou garde ton resetFilters() existant avant l’appel)
  //   console.log('what is pref', pref);
  //   const isPokemon = String(pref?.TypeOfCard || "").toLowerCase() === "pokemon";

  //   // 1) Players (Hockey: players.Name | Pokémon: PokemonList.CardName)
  //   const playerNames = splitCSV(pref?.PlayerNames);
  //   playerNames.forEach(name => updateFilterValues("Name", name, true));

  //   // 2) Sets (commun)
  //   const setNames = splitCSV(pref?.SetNames);
  //   setNames.forEach(set => updateFilterValues("SetName", set, true));

  //   // 3) Card Names (différent entre Hockey et Pokémon)
  //   if (isPokemon) {
  //     // Pokémon: CardNamesJSON = ["Bulbasaur - ...", ...] (SearchTitle)
  //     const cardNamesJson = parseJSON(pref?.CardNamesJSON);
  //     const cardNames = Array.isArray(cardNamesJson) ? cardNamesJson : splitCSV(pref?.CardNames);
  //     cardNames.forEach(cardLabel => updateFilterValues("PokemonCard", cardLabel, true));
  //   } else {
  //     // Hockey
  //     splitCSV(pref?.CardNames).forEach(card => updateFilterValues("cardName", card, true));
  //     splitCSV(pref?.VariationNames).forEach(v => updateFilterValues("variationName", v, true));
  //   }

  //   // 4) Booléens communs Hockey au besoin (si présents dans pref)
  //   if (pref?.isOnlyRookie)     updateFilterValues("IsRookie", "IsRookie", true);
  //   if (pref?.isOnlyAuto)       updateFilterValues("IsAuto", "IsAuto", true);
  //   if (pref?.isOnlyPatch)      updateFilterValues("IsPatch", "IsPatch", true);
  //   if (pref?.isOnlyJersey)     updateFilterValues("IsJersey", "IsJersey", true);

  //   // 5) Champs spécifiques Pokémon
  //   if (isPokemon) {
  //     // Raretés par NOMS (déjà résolus côté API) — ex.: "Rare Holo, Double Rare"
  //     const rarityNames = splitCSV(pref?.PokemonRarityNames);
  //     rarityNames.forEach(rn => updateFilterValues("variationName", rn, true));

  //     if (pref?.PokemonRarityExclusive) {
  //       // ton UI peut utiliser ce flag pour "ne montrer QUE ces raretés"
  //       updateFilterValues("PokemonRarityExclusive", "1", true);
  //     }

  // (parseJSON(pref.ListOfIdVariation) || []).forEach(id => {
  //   updateFilterValues("ExactCardId", String(id), true);
  // });

  // // Human-readable labels (separate bucket your chip renderer uses for display)
  // (parseJSON(pref.CardIdsJSON) || parseJSON(pref.ListOfIdVariation) || []).forEach(id => {
  //   const title = cardTitleById.get(Number(id)) || "(Unknown card)";
  //   updateFilterValues("ExactCardLabel", title, true);
  // });
  //   }
  // };

  // --- Applique un template d’échange au panneau de filtres ---
  const applyTradingPreference = (pref) => {
    console.log("what is pref", pref);

    const isPokemon =
      String(pref?.TypeOfCard || "").toLowerCase() === "pokemon";

    // Helpers (si tes fonctions existent déjà tu peux enlever ces fallback)
    const split = (raw) => splitCSV(raw);
    const json = (raw) => parseJSON(raw);

    // 1) Players
    // Hockey: players.Name (concat CSV)
    // Pokémon: PokemonList.CardName (concat CSV)
    split(pref?.PlayerNames).forEach((name) => {
      if (name) updateFilterValues("Name", name, true);
    });

    // 2) Sets
    // Hockey: SetNames (concat CSV)
    // Pokémon: souvent null dans ton payload actuel -> on peut fallback sur ListOfSetId si c'est des noms
    const setNames =
      split(pref?.SetNames).length > 0
        ? split(pref?.SetNames)
        : (() => {
            const raw = json(pref?.ListOfSetId);
            return Array.isArray(raw) ? raw.map(String) : [];
          })();

    setNames.forEach((set) => {
      if (set) updateFilterValues("SetName", set, true);
    });

    // 3) Cards / Variations
    if (isPokemon) {
      // IMPORTANT: on NE met PAS les cartes Pokémon dans "cardName" (sinon ça pollue la section hockey)
      // On se sert de ListOfIdVariation + PokemonCardTitlesJSON (même index) pour ExactCardId + ExactCardLabel

      const exactIds = json(pref?.ListOfIdVariation) || [];
      const exactTitles =
        json(pref?.PokemonCardTitlesJSON) || split(pref?.PokemonCardTitles);

      exactIds.forEach((id, idx) => {
        if (id == null) return;
        // updateFilterValues("ExactCardId", String(id), true);

        const label = exactTitles?.[idx] || "(Unknown card)";
        updateFilterValues("ExactCardLabel", label, true);
      });
    } else {
      // Hockey
      split(pref?.CardNames).forEach((card) => {
        if (card) updateFilterValues("cardName", card, true);
      });

      split(pref?.VariationNames).forEach((v) => {
        if (v) updateFilterValues("variationName", v, true);
      });
    }

    // 4) Booléens (communs)
    if (pref?.isOnlyRookie) updateFilterValues("IsRookie", "IsRookie", true);
    if (pref?.isOnlyAuto) updateFilterValues("IsAuto", "IsAuto", true);
    if (pref?.isOnlyPatch) updateFilterValues("IsPatch", "IsPatch", true);
    if (pref?.isOnlyJersey) updateFilterValues("IsJersey", "IsJersey", true);

    // 5) Champs spécifiques Pokémon
    if (isPokemon) {
      // Raretés par NOMS (déjà résolus côté API)
      split(pref?.PokemonRarityNames).forEach((rn) => {
        if (rn) updateFilterValues("variationName", rn, true);
      });

      if (pref?.PokemonRarityExclusive) {
        updateFilterValues("PokemonRarityExclusive", "1", true);
      }
    }
  };

  // Sélection dans ton select
  const handleTradePrefChange = (selectedOption) => {
    resetFilters();

    const selectedPref = tradingPreferences.find(
      (pref) => pref.TradingPreferencesId === parseInt(selectedOption?.value),
    );

    if (!selectedPref) {
      setSelectedTradePref("");
      return;
    }

    setSelectedTradePref(selectedOption);
    applyTradingPreference(selectedPref);
  };

  // const handleTradePrefChange = (prefId) => {
  //   const selectedPref = tradingPreferences.find((pref) => pref.TradingPreferencesId === prefId);
  //   if (!selectedPref) return;

  //   const newFilterValues = {};

  //   // Exemple : chaque champ dans la tradePref a la même structure que filterValues
  //   if (selectedPref.players?.length) {
  //     newFilterValues.player = {};
  //     selectedPref.players.forEach((p) => {
  //       newFilterValues.player[p] = true;
  //     });
  //   }

  //   if (selectedPref.teams?.length) {
  //     newFilterValues.team = {};
  //     selectedPref.teams.forEach((t) => {
  //       newFilterValues.team[t] = true;
  //     });
  //   }

  //   if (selectedPref.attributes?.length) {
  //     newFilterValues.attribute = {};
  //     selectedPref.attributes.forEach((a) => {
  //       newFilterValues.attribute[a] = true;
  //     });
  //   }

  //   if (selectedPref.sets?.length) {
  //     newFilterValues.set = {};
  //     selectedPref.sets.forEach((s) => {
  //       newFilterValues.set[s] = true;
  //     });
  //   }

  //   if (selectedPref.isGraded) {
  //     newFilterValues.isGraded = true;
  //   }

  //   // Si tu veux aussi update les checkboxes cochées visuellement
  //   const newChecked = {};
  //   Object.entries(newFilterValues).forEach(([category, values]) => {
  //     if (typeof values === "object") {
  //       Object.keys(values).forEach((v) => {
  //         newChecked[v] = true;
  //       });
  //     }
  //   });

  //   setCheckedCheckboxes(newChecked);
  //   setFilterValues(newFilterValues);

  //   // Re-lancer ta recherche automatiquement si tu as une fonction pour ça
  //   //fetchFilteredCards(newFilterValues);
  // };

  function resetFilters() {
    // Uncheck all checkboxes
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Clear all text inputs
    const inputs = document.querySelectorAll('input[type="text"]');
    inputs.forEach((input) => {
      input.value = "";
    });
    console.log("checkedbox", checkedCheckboxes);
    setCheckedCheckboxes({});
    if (cardGridType === "CardGrid") {
      setCheckedCheckboxes({ No: true });
      setFilterValues({ isGone: { No: true } });
      // Update the ref to indicate that the effect has run
    } else setFilterValues({});
  }
  //-----------------------------------------------End Of Filters + Prepare rendering---------------------------------------------------

  //-----------------------------------------------Counts for filters---------------------------------------------------

  useEffect(() => {
    const counts = {
      ConditionCard: {},
      Name: {},
      SetName: {},
      TeamsId: {},
      YearMade: {},
      cardName: {},
      variationName: {},
      IsRookie: {},
      IsPatch: {},
      IsJersey: {},
      IsAuto: {},
      isForSale: {},
      isPC: {},
      isForTrade: {},
      isOnEbay: {},
      isGone: {},
      Graded: {},
      GradeCompany: {},
      Grade: {},
      ShowName: {},
    };

    filteredCards.forEach((card) => {
      Object.keys(counts).forEach((key) => {
        if (!counts[key][card[key]]) {
          counts[key][card[key]] = 0;
        }
        counts[key][card[key]]++;
      });
    });
    setConditionCardCounts(counts.ConditionCard);
    setNameCounts(counts.Name);
    setSetCounts(counts.SetName);
    setTeamsIdCounts(counts.TeamsId);
    setCardNameCounts(counts.cardName);
    setVariationNameCounts(counts.variationName);
    setYearCounts(counts.YearMade);
    setIsRookieCounts(counts.IsRookie);
    setIsPatchCounts(counts.IsPatch);
    setIsJerseyCounts(counts.IsJersey);
    setIsAutoCounts(counts.IsAuto);
    setIsForSaleCounts(counts.isForSale);
    setIsPCCounts(counts.isPC);
    setIsForTradeCounts(counts.isForTrade);
    setIsOnEbayCounts(counts.isOnEbay);
    setIsGoneCounts(counts.isGone);
    setIsGradedCounts(counts.Graded);
    setGradeCompanyCounts(counts.GradeCompany);
    setGradeCounts(counts.Grade);
    setShowNameCounts(counts.ShowName);
  }, [filteredCards]);

  //-----------------------------------------------End Of Counts for filters---------------------------------------------------

  //-----------------------------------------------Handle---------------------------------------------------
  const handleFilterChange = (event) => {
    let { name, value, checked } = event.target;
    lastScrollY.current = window.scrollY;
    console.log("name, value, checked ", name, value, checked);

    console.log("checkcheckedboxlist", checkedCheckboxes);
    console.log("filtervalues", filterValues);
    /*  
     if (name === "isGone") {
          setIsGoneChecked((prevState) => ({
            ...prevState,
            [name]: checked ? true : false,
          }));
        }
      */
    if (name === "isGraded") {
      setFilterValues((prevState) => ({
        ...prevState,
        [name]: checked ? true : null,
      }));
    } else {
      // Update the checked checkboxes state
      setCheckedCheckboxes((prevState) => ({
        ...prevState,
        [value]: !prevState[value],
      }));
      // Handle checkbox change in category filters
      setFilterValues((prevState) => {
        const updatedFilters = { ...prevState[name] };

        if (checked) {
          updatedFilters[value] = true;
        } else {
          // If unchecked, remove the filter
          delete updatedFilters[value];
          // Check if the category is now empty, and if so, remove the category
          if (Object.keys(updatedFilters).length === 0) {
            const updatedState = { ...prevState };
            delete updatedState[name];
            return updatedState;
          }
        }

        return {
          ...prevState,
          [name]: updatedFilters,
        };
      });
    }
  };
  // function handleClickSearchButton(isItBlank) {
  //   if (!isItBlank) {
  //     setActiveSearchTerm(searchTermInput);
  //     updateFilterSearchBar(
  //       "SearchBar",
  //       searchTermInput,
  //       searchTermInput.length > 0 ? true : false
  //     );
  //   } else {
  //     setActiveSearchTerm("");
  //   }
  // }

  function handleClickSearchButton(isItBlank) {
    const q = searchTermInput.trim();

    if (isItBlank || q === "") {
      setActiveSearchTerm("");
      setFilterValues((prev) => {
        const { SearchBar, ...rest } = prev; // remove SearchBar filter
        return rest;
      });
      return;
    }

    setActiveSearchTerm(q);
    setFilterValues((prev) => ({ ...prev, SearchBar: { [q]: true } }));
  }

  const updateFilterSearchBar = (name, value, isChecked) => {
    if (name === "SearchBar" && value != "") {
      setFilterValues((prevState) => {
        const updatedFilters = { [value]: true };
        return {
          ...prevState,
          [name]: updatedFilters,
        };
      });
    }
  };

  // This function abstracts the core logic for updating filters
  const updateFilterValues = (name, value, isChecked) => {
    // Logic to update filter values based on provided parameters
    // Similar to your existing handleFilterChange logic
    console.log("1 name, value, isChecked", name, value, isChecked);
    if (["IsAuto", "IsPatch", "IsJersey", "IsRookie"].includes(name)) {
      console.log("name inside iswhat", name);
      name = "Attribut";
    }
    if (["isPC", "isOnEbay", "isForTrade", "isForSale"].includes(name)) {
      console.log("name inside isfor", name);
      name = "GroupBy";
    }
    if (["Graded", "Raw"].includes(name)) {
      console.log("name inside isfor", name);
      if (value === "Yes") {
        value = "Graded";
      }
      name = "Graded";
    }

    console.log("2 name, value, isChecked", name, value, isChecked);
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      [value]: isChecked,
    }));

    setFilterValues((prevState) => {
      const updatedFilters = { ...prevState[name] };

      if (isChecked) {
        updatedFilters[value] = true;
      } else {
        delete updatedFilters[value];
        if (Object.keys(updatedFilters).length === 0) {
          const updatedState = { ...prevState };
          delete updatedState[name];
          return updatedState;
        }
      }

      return {
        ...prevState,
        [name]: updatedFilters,
      };
    });
  };

  // Adjusted handleFilterChange to use the abstracted logic
  // const handleFilterChange = (event) => {
  //   const { name, value, checked } = event.target;
  //   updateFilterValues(name, value, checked);
  // };

  // // New handler for button presses
  const handleButtonFilterChange = (name, value) => {
    // Here, value is the filter value, and we toggle based on current state
    const isChecked = !checkedCheckboxes[value];
    updateFilterValues(name, value, isChecked);
  };

  const handleSearchFilterChange = (event) => {
    const { name, value, checked } = event.target;

    // Access the selected option element
    const selectedOption = event.target.options[event.target.selectedIndex];

    // Access the 'name' attribute of the selected option
    const optionName = selectedOption.getAttribute("name");

    console.log("value : ", value);
    console.log(optionName);

    // Update the checked checkboxes state
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      [value]: true,
    }));

    // Handle checkbox change in other categories
    setFilterValues((prevState) => {
      const updatedFilters = { ...prevState[optionName] };
      updatedFilters[value] = true;

      return {
        ...prevState,
        [optionName]: updatedFilters,
      };
    });
    //}
  };

  const removeFilter = (category, filter) => {
    const updatedFilters = { ...filterValues };
    const updatedCheckedCheckboxes = { ...checkedCheckboxes };

    // Remove the filter from the category in filterValues
    delete updatedFilters[category][filter];
    console.log("category,filter", [category], [filter]);
    // Remove the filter from the category in checkedCheckboxes
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      [filter]: !prevState[filter],
    }));

    // If the category is empty in filterValues, remove the entire category
    if (Object.keys(updatedFilters[category]).length === 0) {
      delete updatedFilters[category];
    }

    // If the category is empty in checkedCheckboxes, remove the entire category
    setFilterValues(updatedFilters);
    if (category === "SearchBar") {
      setSearchTermInput("");
      handleClickSearchButton(true);
    }

    console.log("Removed filter:", filter, "from category:", category);

    // Uncheck the checkbox corresponding to the filter
    /* const checkbox = document.querySelector(`input[type="checkbox"][name="${category}"][value="${filter}"]`);
      if (checkbox) {
        checkbox.checked = false;
      }*/

    // Clear the input field corresponding to the filter
    const inputField = document.querySelector(
      `input[type="text"][id="${filter}"]`,
    );
    if (inputField) {
      inputField.value = "";
    }
  };

  // Function to clear all filters in a category
  const clearCategory = (category) => {
    const updatedFilters = { ...filterValues };
    console.log("update ", updatedFilters[category]);

    const updatedCheckedCheckboxes = { ...checkedCheckboxes };
    console.log("checkbox", updatedCheckedCheckboxes);

    // Iterate through the keys (names) in updatedCheckedCheckboxes
    for (const key in updatedCheckedCheckboxes) {
      if (
        updatedFilters.hasOwnProperty(category) &&
        updatedFilters[category].hasOwnProperty(key)
      ) {
        console.log(true, "key : ", key, "category : ", category);
        // If the key matches the category, delete it from the updatedCheckedCheckboxes
        delete updatedCheckedCheckboxes[key];
      } else {
        console.log(false, "key : ", key, "category : ", category);
      }
    }

    delete updatedFilters[category];
    setFilterValues(updatedFilters);
    // Update the checkedCheckboxes state with the modified object
    setCheckedCheckboxes(updatedCheckedCheckboxes);

    const checkboxes = document.querySelectorAll(
      `input[type="checkbox"][name="${category}"]`,
    );
    console.log("checkechk", checkboxes);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Clear input fields associated with the category name
    const inputFields = document.querySelectorAll(
      `input[type="text"][id="${category}"]`,
    );
    inputFields.forEach((input) => {
      input.value = "";
    });
  };

  const handleCardClick = async (card, ifFromCheckBox, event) => {
    console.log("event", event);
    // event.preventDefault(); // Prevent default to avoid conflicts

    console.log("ifFromCheckBox", ifFromCheckBox);
    console.log("multiEditState", multiEditState);
    if (multiEditState) {
      // Add or remove the card ID from selectedCards based on its presence
      await setSelectedCards((prevSelectedCards) => {
        const isSelected = prevSelectedCards.includes(card.id);
        if (isSelected) {
          if (
            prevSelectedCards.includes(card.id) &&
            selectedCards.length === 1 &&
            ifFromCheckBox
          )
            setMultiEditState(false);
          return prevSelectedCards.filter((id) => id !== card.id);
        } else {
          console.log(selectedCards);
          return [...prevSelectedCards, card.id];
        }
      });
    } else {
      const sanitizedCardId = encodeURIComponent(card.id);
      if (event.ctrlKey || event.metaKey || event.button === 1) {
        // Open in a new tab
        window.open(`/cards/${sanitizedCardId}`, "_blank");
      } else {
        // Normal click - navigate within the app
        // Create a sanitized card without Location if user IDs don’t match
        const sanitizedCard =
          parseInt(card.UserId) !== parseInt(userId)
            ? { ...card, Location: undefined }
            : card;

        setSelectedCard(sanitizedCard);

        navigate(
          i18n.language === "fr"
            ? `/fr/cards/${sanitizedCardId}`
            : `/cards/${sanitizedCardId}`,
          {
            state: { card: sanitizedCard, viewAsGrid: viewAsGrid },
          },
        );
      }
    }
  };

  const getSelectedCards = () => {
    return selectedCards;
  };
  function handleCollectionPublicClick(newIsPublic) {
    const requestData = {
      userId: userId, // Include userId for validation
      public: selectedCollectionIsPublic,
      newIsPublic: newIsPublic,
      listId: selectedCollectionLive,
      liveCsrfToken: liveCsrfToken,
      cardGridType: cardGridType, // Include CSRF token for validation
    };
    fetch(`${process.env.REACT_APP_API_BASE}/api/list/update/public`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to update");
        }
        return response.json();
      })
      .then((data) => {
        toast.success(t("Updated"));
        setSelectedCollectionIsPublic(newIsPublic); // Update state only on success
      })
      .catch((error) => {
        console.error("Update failed:", error);
        toast.error(t("Update failed"));
      });
  }
  const handleCopyToClipboard = () => {
    let url;
    if (cardGridType === "CardGrid") {
      if (!selectedCollectionLive) {
        toast.error("No collection selected!"); // Optional error handling
        return;
      }

      url = `https://cardsfolio.ca/public/Collection/${selectedCollectionLive}`;
    }

    if (cardGridType === "CardGridSell") {
      if (!selectedCollectionLive) {
        toast.error("No wantList selected!"); // Optional error handling
        return;
      }

      url = `https://cardsfolio.ca/public/WantList/${selectedCollectionLive}`;
    }

    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success(t("LinkCopied"));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        toast.error("Failed to copy link.");
      });
  };
  function handleChangeCollectionLive(
    listIdProvided,
    listTitleProvided,
    innerText,
    isDefault,
    isPublic,
  ) {
    setSelectedCollectionIsDefault(isDefault);
    setSelectedCollectionLive(listIdProvided);
    setSelectedCollectionTitle(listTitleProvided);
    setSelectedCollectionIsPublic(isPublic === 1);
    setSelectedCollectionInnerText(innerText);
    console.log("listTitleProvided ", listTitleProvided);
    console.log("listIdProvided", listIdProvided);
    console.log("innerText", innerText);

    //console.log('collection',collection)
    // Perform any other necessary actions or validations
    if (listIdProvided && listIdProvided !== "") {
      // Filter cards based on the selected collection
      console.log("listidprovided123 : ", listIdProvided);

      filterCardBySelectedCollection(parseInt(listIdProvided));
      setIsViewCollection(true);
      setSelectedCards([]);
    } else {
      // Reset the filter and show all cards
      setSelectedCollectionCards([]);
      setIsViewCollection(false);
      setFilteredCards(cards);
      resetFilters();
      setSelectedCards([]);
    }
  }

  //-----------------------------------------------HandleUpdateStatusChange---------------------------------------------------
  const handleUpdateStatusChange = (event) => {
    const { name, checked } = event.target;
    console.log("handleUpdateStatusChange name, checked ", name, checked);
    switch (name) {
      case "isPcUpdate":
        setIsPcUpdate(checked);
        break;
      case "isForSaleUpdate":
        setIsForSaleUpdate(checked);
        break;
      case "isForTradeUpdate":
        setIsForTradeUpdate(checked);
        break;
      case "isOnEbayUpdate":
        setIsOnEbayUpdate(checked);
        break;
      default:
        break;
    }
  };

  //-------------------HandleUpdateStatusButtonClick
  const handleUpdateStatusCancelButtonClick = () => {
    setIsForSaleUpdate(false);
    setIsForTradeUpdate(false);
    setIsOnEbayUpdate(false);
    setIsPcUpdate(false);
    setSelectedAction1("Select Action null");
  };
  const handleUpdateStatusButtonClick = () => {
    // Update values in the database
    // Use the state variables (isPcUpdate, isForSaleUpdate, etc.) to send the updated values
    // Call the API endpoint and handle the response
    updateStatusForCards(true);
    // Reset the state variables
    setIsForSaleUpdate(false);
    setIsForTradeUpdate(false);
    setIsOnEbayUpdate(false);
    setIsPcUpdate(false);
    setSelectedAction1("Select Action null");
  };

  //----------------------------------------------Start of Group actions---------------------------------------------------
  const handleMultiEditButton = () => {
    // Perform the group action using the selectedCards array

    if (!MultiCardOfferSelection) {
      if (multiEditState) {
        setMultiEditState(false);
        setSelectedCards([]);
        console.log("set editState a false");
        setSelectedAction1("Select Action null");
      } else {
        setMultiEditState(true);
        console.log("set editState a true");
      }
    }
  };
  const handleSetCardsForOnGoingOffer = () => {
    console.log("2218 trying ");
    if (selectedCards.length > 0) {
      const getCardsFromSelectedId = cards.filter((card) =>
        selectedCards.includes(card.id),
      );

      SetMultiCardOfferSelection(getCardsFromSelectedId);
      toast.success(t("cardsAdded"));
      setModal();
      console.log("2221 set est fait ", getCardsFromSelectedId);
    } else {
      console.log("SetMultiCardOfferSelection(selectedCards) < 0");
      toast.error(t("noCardsToAdd"));
    }
  };

  //---------------------------------------------- actionAssignToCollection - Display collection choice to assign------------------------------------------------

  function onAssignCollection(CollectionId, cardId) {
    insertCardsIntoList("CardGrid", CollectionId, [cardId]);
    console.log("CollectionId,cardId", CollectionId, cardId);
  }

  function CreateNewCollectionForm({
    createNewCollectionTitle,
    setCreateNewCollectionTitle,
  }) {
    const [localTitle, setLocalTitle] = useState(
      createNewCollectionTitle || "",
    );

    const handleChange = (e) => {
      setLocalTitle(e.target.value); // ✅ Update local state
      setCreateNewCollectionTitle(e.target.value); // ✅ Update parent state
    };

    return (
      <input
        type="text"
        placeholder={t("Enter new collection name")}
        value={localTitle}
        onChange={handleChange}
        className="custom-input"
      />
    );
  }

  function RenameCollectionForm({
    renameCollectionTitle,
    setRenameCollectionTitle,
  }) {
    const [localTitle, setLocalTitle] = useState(renameCollectionTitle || "");
    const handleChange = (e) => {
      setLocalTitle(e.target.value); // ✅ Update local state
      setRenameCollectionTitle(e.target.value); // ✅ Update parent state
    };
    return (
      <input
        type="text"
        value={localTitle}
        onChange={handleChange}
        placeholder={t("Enter a new name for this collection")}
        className="custom-input"
      />
    );
  }

  function AssignToCollectionForm({ onSubmit }) {
    const [localSelection, setLocalSelection] = useState("");

    const handleChange = (e) => {
      setLocalSelection(e.target.value);
    };

    useEffect(() => {
      // Allow access to the current selection when modal confirms
      onSubmit.current = () => localSelection;
    }, [localSelection]);

    return (
      // <select
      //   value={localSelection}
      //   onChange={handleChange}
      //   className="custom-select"
      // >
      //   <option value="">{t("Select a collection")}</option>
      //   {collections.map((collection) => (
      //     <option key={collection.ListId} value={collection.ListId}>
      //       {`${collection.Title} (${collection.collectionCount})`}
      //     </option>
      //   ))}
      // </select>
      <Select
        className="custom-select"
        styles={stylingSelect}
        value={
          collections.find((col) => col.ListId === localSelection)
            ? {
                value: localSelection,
                label: `${collections.find((c) => c.ListId === localSelection).Title} (${
                  collections.find((c) => c.ListId === localSelection)
                    .collectionCount
                })`,
              }
            : null
        }
        onChange={(selected) => {
          handleChange({ target: { value: selected?.value } });
        }}
        options={collections.map((collection) => ({
          value: collection.ListId,
          label: `${collection.Title} (${collection.collectionCount})`,
        }))}
        placeholder={t("Select a collection")}
        isClearable
        isSearchable={false}
      />
    );
  }

  function AssignSoldPrice({ soldPriceInput, setSoldPriceInput }) {
    const [localPrice, setLocalPrice] = useState(renameCollectionTitle || "");
    const handleChange = (e) => {
      const value = e.target.value;
      setLocalPrice(value);
      setSoldPriceInput(value); // ✅ Updates external state
    };
    return (
      <input
        type="number"
        value={localPrice}
        onChange={handleChange} // ✅ Pass function correctly
        placeholder={t("Enter sold price")}
        className="custom-input"
      />
    );
  }
  //---------------------------------------------- actionUpdateStatus - Display status choice to update------------------------------------------------
  const ChangeStatusModal = ({ selectedCards, onConfirm, onClose, t }) => {
    const [isPcUpdate, setIsPcUpdate] = useState(false);
    const [isForSaleUpdate, setIsForSaleUpdate] = useState(false);
    const [isForTradeUpdate, setIsForTradeUpdate] = useState(false);
    const [isOnEbayUpdate, setIsOnEbayUpdate] = useState(false);

    const handleSubmit = () => {
      onConfirm({
        isPcUpdate,
        isForSaleUpdate,
        isForTradeUpdate,
        isOnEbayUpdate,
      });
    };

    return (
      <div className="change-status-form">
        {/* <h3>{t("Change Card Status")}</h3>
        <p>{t("Select a new status for the selected cards")} ({selectedCards.length})</p> */}

        <div className="status-button-grid">
          <button
            className={`status-toggle-btn ${isPcUpdate ? "is-active" : ""}`}
            onClick={() => setIsPcUpdate((prev) => !prev)}
          >
            {t("PC")}
          </button>
          <button
            className={`status-toggle-btn ${isForSaleUpdate ? "is-active" : ""}`}
            onClick={() => setIsForSaleUpdate((prev) => !prev)}
          >
            {t("ForSale")}
          </button>
          <button
            className={`status-toggle-btn ${isForTradeUpdate ? "is-active" : ""}`}
            onClick={() => setIsForTradeUpdate((prev) => !prev)}
          >
            {t("ForTrade")}
          </button>
          <button
            className={`status-toggle-btn ${isOnEbayUpdate ? "is-active" : ""}`}
            onClick={() => setIsOnEbayUpdate((prev) => !prev)}
          >
            {t("OnEbay")}
          </button>
        </div>

        {/* <div className="modal-actions">
          <button onClick={onClose}>{t("Cancel")}</button>
          <button onClick={handleSubmit}>{t("Confirm")}</button>
        </div> */}
        <div className="btns-custom">
          <button className="confirm-btn" onClick={handleSubmit}>
            {t("Confirm")}
          </button>
          <button className="cancel-btn" onClick={onClose}>
            {t("Cancel")}
          </button>
        </div>
      </div>
    );
  };

  //---------------------------------------------- actionAssignToCollection - Insert into collection------------------------------------------------
  function handleAssignToCollection() {
    const selectedCollection = collectionSubmitRef.current?.();
    if (!selectedCollection) {
      toast.error(t("Please select a collection"));
      return;
    }

    if (cardGridType === "CardGrid") {
      insertCardsIntoList("CardGrid", selectedCollection);
    } else if (cardGridType === "CardGridSell") {
      insertCardsIntoList("CardGridSell", selectedCollection);
    }
    setSelectedAction1("");
  }
  //---------------------------------------------- actionChangeStatus - Change status------------------------------------------------
  function performAction3() {
    console.log("Performing Action 3");
    // Add your code for Action 3 here
  }

  function premadeExport() {
    console.log("export");
    console.log("im exporting selectedCards", selectedCards);
    const ExportingCards = selectedCards;
    navigate(i18n.language === "fr" ? `/fr/MainExport` : `/MainExport`, {
      state: {
        userCardIds: ExportingCards,
        userId: userId,
      },
    });
  }

  //---------------------------------------------- Groupe actions - Handle------------------------------------------------

  // function handleGroupAction(event) {
  //   const selectedAction = event.target.value;
  //   setSelectedAction1(selectedAction);
  //   event.target.selectedIndex = 0;
  //   // Execute the associated function based on the selected action

  //   if (cardGridType === "CardGrid") {
  //     switch (selectedAction) {
  //       case "actionAssignToCollection":
  //         //  AssignToCollection();
  //         console.log("999999actionAssignToCollection");
  //         displayAssignToCollectionForm();
  //         break;
  //       case "actionCreateNewCollection":
  //         console.log("999999actionCreateNewCollection");
  //         displayCreateCollectionForm();
  //         break;
  //       case "actionChangeStatus":
  //         performAction3();
  //         break;
  //       case "export":
  //         premadeExport();

  //       case "actionDeleteFromCollection":
  //         //removeFromCardsCardsList(selectedCollectionLive);
  //         setConfirmationVisibleForDeleteFromCollectionOnly(true);
  //         break;
  //       case "actionDeleteFromAll":
  //         setConfirmationVisibleForDeleteCards(true);
  //         break;
  //       default:
  //         // Handle default case or do nothing
  //         break;
  //     }
  //   } else if (cardGridType === "CardGridSell") {
  //     switch (selectedAction) {
  //       case "actionAssignToCollection":
  //         //  AssignToCollection();
  //         console.log("999998displayAssignToCollectionForm");
  //         displayAssignToCollectionForm();
  //         break;
  //       case "actionCreateNewCollection":
  //         console.log("999998actionCreateNewCollection");
  //         displayCreateCollectionForm();
  //         break;
  //       case "actionSendToCart":
  //         //  displayCreateCollectionForm();
  //         break;
  //       case "actionDeleteFromCollection":
  //         setConfirmationVisibleForDeleteFromCollectionOnly(true);
  //         break;
  //       case "actionNotForSale":
  //         setConfirmationVisibleNotForSale(true);
  //         break;

  //       default:
  //         // Handle default case or do nothing
  //         break;
  //     }
  //   }
  //   console.log("Selected cards:", selectedCards);
  //   console.log(selectedAction);
  //   console.log(confirmationVisibleForDeleteFromCollectionOnly);
  // }
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(null);

  const groupActionOptions = [
    {
      value: "actionAssignToCollection",
      label: t("Assign to an existing collection"),
    },
    {
      value: "actionCreateNewCollection",
      label: t("Create a new collection"),
    },
    {
      label: "", // Empty string so it's not selectable
      value: "divider-1",
      isDisabled: true,
      isDivider: true,
    },
    {
      value: "actionChangeStatus",
      label: t("Change the status (PC-ForTrade-ForSale)"),
    },
    {
      label: "", // Empty string so it's not selectable
      value: "divider-1",
      isDisabled: true,
      isDivider: true,
    },
    {
      value: "export",
      label: t("Export those cards"),
    },
    {
      label: "", // Empty string so it's not selectable
      value: "divider-1",
      isDisabled: true,
      isDivider: true,
    },
    ...(isViewCollection
      ? [
          {
            value: "actionDeleteFromCollection",
            label: `${t("Delete those cards")} (${selectedCards.length}) ${t(
              "from this collection",
            )} (${selectedCollectionTitle}) ${t("only")}`,
          },
        ]
      : []),

    {
      value: "actionDeleteFromAll",
      label: `${t("Delete those cards")} (${selectedCards.length}) ${t(
        "from your entire portfolio.",
      )}`,
    },
  ];

  function handleGroupAction(event) {
    const selectedAction = event.target.value;
    //setSelectedAction1(selectedAction);
    const userCardId = event.target.userCardId || null; // Extract userCardId

    event.target.selectedIndex = 0;

    switch (selectedAction) {
      case "actionAssignToCollection":
        openModal(
          t("Assign to an existing collection"),
          t("Select a collection to move the selected cards to."),
          <AssignToCollectionForm onSubmit={collectionSubmitRef} />,
          () => handleAssignToCollection(), // ✅ Correctly pass function reference
        );
        break;

      case "actionCreateNewCollection":
        openModal(
          t("Create a new collection"),
          t("Enter a name for the new collection."),
          <CreateNewCollectionForm
            createNewCollectionTitle={createNewCollectionTitle}
            setCreateNewCollectionTitle={setCreateNewCollectionTitle} // ✅ Pass state updater
          />,
          () => handleCreateNewCollection(), // ✅ Pass reference, not execution
        );
        break;

      case "actionChangeStatus":
        openModal(
          t("Change Card Status"),
          t("Select a new status for the selected cards."),
          () => (
            <ChangeStatusModal
              selectedCards={selectedCards}
              t={t}
              onClose={() => setModalVisible(false)}
              onConfirm={(statuses) => {
                updateStatusForCards(statuses);
                setModalVisible(false);
              }}
            />
          ),
        );
        break;

      case "export":
        premadeExport();
        break;

      case "actionDeleteFromCollection":
        openModal(
          t("Remove Cards"),
          `${t("Are you sure you want to remove")} ${selectedCards.length} ${t(
            "cards from this collection?",
          )}`,
          null,
          () => removeFromCardsCardsList(),
        );
        break;

      case "actionDeleteFromAll":
        let cardIds = [...selectedCards];
        if (singleCardOperationId !== 0) cardIds = [singleCardOperationId];
        console.log("CardIds to delete", cardIds);

        // ✅ Open a confirmation modal instead of immediately executing
        openModal(
          t("Confirm Deletion"),
          `${t("Are you sure you want to delete")} ${cardIds.length} ${t(
            "cards permanently?",
          )}`,
          null, // No input needed
          () => executeDeleteCards(cardIds), // ✅ Wait until user confirms
        );
        break;
      case "actionRenameCollection":
        openModal(
          t("Rename Collection"),
          t("Enter a new name for this collection."),
          <RenameCollectionForm
            renameCollectionTitle={renameCollectionTitle}
            setRenameCollectionTitle={setRenameCollectionTitle} // ✅ Pass state updater
          />,
          () => handleRenameCollection(), // ✅ Ensure correct function execution
        );
        break;
      case "actionDeleteCollectionOrWatchList":
        openModal(
          t("Delete Collection or Watchlist"),
          `${t(
            "Are you sure you want to delete this list?",
          )} '${selectedCollectionTitle}'`,
          null, // No input needed
          () => deleteCollectionOrWatchlist(), // ✅ Execute delete on confirm
        );
        break;
      case "actionMarkAsSold":
        openModal(
          t("Mark as Sold"),
          t("Enter the sold price for this card."),
          <AssignSoldPrice
            soldPriceInput={soldPriceInput}
            setSoldPriceInput={setSoldPriceInput}
          />,
          () => removeFromMarketplaceMarkAsSold(userCardId), // ✅ Call function on confirm
        );
        break;
      default:
        break;
    }
  }

  function openModal(title, message, content, confirmAction) {
    setModalTitle(title);
    setModalMessage(message);
    setModalContent(() => content);
    setModalConfirmAction(() => confirmAction);
    setModalVisible(true);
  }

  //----------------------------------------------End of Group actions---------------------------------------------------
  //----------------------------------------------End of Handle---------------------------------------------------

  //----------------------------------------------Start of Filter Unique---------------------------------------------------
  let uniqueNames = [];
  let uniqueSets = [];
  let uniqueTeamsId = [];
  let uniqueCardName = [];
  let uniqueVariationName = [];
  let uniqueYear = [];
  let uniqueIsRookie = [];
  let uniqueIsPatch = [];
  let uniqueIsJersey = [];
  let uniqueIsAuto = [];
  let uniqueIsForSale = [];
  let uniqueIsPC = [];
  let uniqueIsForTrade = [];
  let uniqueIsOnEbay = [];
  let uniqueIsGone = [];
  let uniqueIsGraded = [];
  let uniqueGradeCompany = [];
  let uniqueGrade = [];
  let uniqueShowName = [];
  let uniqueConditionCard =
    state.sport === "Hockey"
      ? ["Near Mint or Better", "Excellent", "Very Good", "Poor"]
      : ["NM", "LP", "MP", "HP", "DMG"];
  if (cards.length > 0) {
    uniqueNames = [...new Set(cards.map((card) => card.Name))].sort();
    uniqueSets = [...new Set(cards.map((card) => card.SetName))].sort();
    uniqueTeamsId = [...new Set(cards.map((card) => card.TeamsId))].sort();
    uniqueCardName = [...new Set(cards.map((card) => card.cardName))].sort();
    uniqueVariationName = [
      ...new Set(cards.map((card) => card.variationName)),
    ].sort();
    uniqueYear = [...new Set(cards.map((card) => card.YearMade))].sort();
    uniqueIsRookie = [...new Set(cards.map((card) => card.IsRookie))].sort();
    uniqueIsPatch = [...new Set(cards.map((card) => card.IsPatch))].sort();
    uniqueIsJersey = [...new Set(cards.map((card) => card.IsJersey))].sort();
    uniqueIsAuto = [...new Set(cards.map((card) => card.IsAuto))].sort();
    uniqueIsForSale = [...new Set(cards.map((card) => card.isForSale))].sort();
    uniqueIsPC = [...new Set(cards.map((card) => card.isPC))].sort();
    uniqueIsForTrade = [
      ...new Set(cards.map((card) => card.isForTrade)),
    ].sort();
    uniqueIsOnEbay = [...new Set(cards.map((card) => card.isOnEbay))].sort();
    uniqueIsGone = [...new Set(cards.map((card) => card.isGone))].sort();
    uniqueIsGraded = [...new Set(cards.map((card) => card.Graded))].sort();
    uniqueGradeCompany = [...new Set(cards.map((card) => card.GradeCompany))]
      .filter((gradeCompany) => gradeCompany !== "")
      .sort();
    uniqueGrade = [
      ...new Set(
        cards
          .map((card) => parseFloat(card.Grade)) // ✅ Apply toFixed(1) and ensure it's a number
          .filter((grade) => grade !== 0), // ✅ Remove 0 values
      ),
    ].sort((a, b) => a - b); // ✅ Ensure numeric sorting
    uniqueShowName = [...new Set(cards.map((card) => card.ShowName))]
      .filter((grade) => grade !== 0)
      .sort();
  }
  // } else {
  //   // Handle the case when cards is empty or null
  //   //console.error("Error: cards is empty or null");
  // }

  //----------------------------------------------End of Filter Unique---------------------------------------------------
  const handleSavedSellerFilter = () => {
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      SavedSeller: !prevState.SavedSeller,
    }));

    setFilterValues((prevState) => {
      const updatedFilters = { ...prevState["ShowName"] };

      // If "Saved Seller" is being checked, apply the filter; otherwise, remove it
      if (!checkedCheckboxes.SavedSeller) {
        updatedFilters["SavedSeller"] = true;
      } else {
        delete updatedFilters["SavedSeller"];
        if (Object.keys(updatedFilters).length === 0) {
          const updatedState = { ...prevState };
          delete updatedState["ShowName"];
          return updatedState;
        }
      }

      return {
        ...prevState,
        ShowName: updatedFilters,
      };
    });
  };

  const FilterSection = ({
    label,
    openKey,
    openSections,
    setOpenSections,
    children,
  }) => {
    const isOpen = !!openSections[openKey];

    return (
      <section className="filter-section-card">
        <p
          type="button"
          className="filter-section-header"
          aria-expanded={isOpen}
          onClick={() =>
            setOpenSections((prev) => ({ ...prev, [openKey]: !isOpen }))
          }
        >
          <h3 className="filter-section-label">{label}</h3>
          <svg
            className={`chev ${isOpen ? "open" : ""}`}
            width="12"
            height="8"
            viewBox="0 0 12 8"
          >
            <path
              d="M1 1.5L6 6.5L11 1.5"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </p>

        <div className={`filter-section-body ${isOpen ? "open" : "closed"}`}>
          {children}
        </div>
      </section>
    );
  };

  //Filter Order by
  //   const FilterGroup = ({
  //     title,
  //     items,
  //     counts,
  //     checkedCheckboxes,
  //     handleFilterChange,
  //     isListOpen,
  //     toggleListOpen,
  //     isLast,
  //   }) => {
  //     // Create two arrays: one for checked items and one for unchecked items

  //     const [showMoreFilter, setShowMoreFilter] = useState(false);
  //     const [searchTerm, setSearchTerm] = useState(""); // State for search filtering
  //     // ✅ Optimize Filtering (Runs only when `items` or `searchTerm` changes)
  //     // **Filter items dynamically only for certain categories**

  //     const filteredItems = useMemo(() => {
  //       if (
  //         [
  //           "Name",
  //           "TeamsId",
  //           "SetName",
  //           "cardName",
  //           "variationName",
  //           "YearMade",
  //         ].includes(title)
  //       ) {
  //         return items.filter((item) =>
  //           String(item).toLowerCase().includes(searchTerm.toLowerCase())
  //         );
  //       }
  //       return items;
  //     }, [items, searchTerm, title]);

  //     // **Separate checked and unchecked items AFTER filtering**
  //     const checkedItems = useMemo(() => {
  //       return filteredItems.filter((item) => checkedCheckboxes[item]);
  //     }, [filteredItems, checkedCheckboxes]);

  //     const uncheckedItems = useMemo(() => {
  //       return filteredItems.filter((item) => !checkedCheckboxes[item]);
  //     }, [filteredItems, checkedCheckboxes]);

  //     // Fonction pour basculer l'état de la liste
  //     const toggleList = () => {
  //       toggleListOpen();
  //     };
  //     const toggleShowMoreFilter = () => {
  //       setShowMoreFilter(!showMoreFilter);
  //     };

  //     function FindTheTeamNameById(teamId) {
  //       const team = teams[teamId];
  //       return team ? team.name : "Unknown Team";
  //     }
  //     const handleAttributeToggle = (attribut) => {
  //       console.log("handleAttributeToggle", attribut);
  //     };

  //     // const handleFilterBySavedSellers = () => {
  //     //   handleSavedSellerFilter(favorites);
  //     // };

  //     const modifyLabel = (label) => {
  //       if (label === "NotisPC") {
  //         return "NotPC";
  //       } else if (label === "isPC") {
  //         return t("PC");
  //       } else if (label === "NotisOnEbay") {
  //         return "NotOnEbay";
  //       } else if (label === "isOnEbay") {
  //         return t("OnEbay");
  //       } else if (label === "NotisForTrade") {
  //         return "NotForTrade";
  //       } else if (label === "isForTrade") {
  //         return t("ForTrade");
  //       } else if (label === "NotisForSale") {
  //         return "NotForSale";
  //       } else if (label === "isForSale") {
  //         return t("ForSale");
  //       } else if (label === "Name") {
  //         return t("Player");
  //       } else if (label === "TeamsId") {
  //         return t("Team(Uniform)");
  //       } else if (label === "SetName") {
  //         return "Set";
  //       } else if (label === "cardName") {
  //         return t("cardName");
  //       } else if (label === "variationName") {
  //         return t("variation");
  //       } else if (label === "YearMade") {
  //         return t("year");
  //       } else if (label === "IsAuto") {
  //         return t("auto");
  //       } else if (label === "IsRookie") {
  //         return t("Rookie");
  //       } else if (label === "IsPatch") {
  //         return "Patch";
  //       } else if (label === "IsJersey") {
  //         return "Jersey";
  //       } else if (label === "GradeCompany") {
  //         return t("GradingCompany");
  //       } else if (label === "ConditionCard") {
  //         return t("Card Condition");
  //       } else if (label === "GroupBy") {
  //         return t("GroupBy");
  //       } else if (label === "Filter Attribut") {
  //         return t("Filter Attribut");
  //       } else if (label === "Filter Graded") {
  //         return t("Filter Graded");
  //       } else if (label === "ShowName") {
  //         return t("ShowName");
  //       } else if (label === "SavedSeller") {
  //         return t("SavedSeller");
  //       } else {
  //         return label;
  //       }
  //     };

  //     ////////////
  //     const renderGradedButtons = () => {
  //       // Define your attributes in groups
  //       const firstGroupAttributes = [["Graded"], ["Raw"]];
  //       // , ['IsTribute', 'Tribute']

  //       // Function to render buttons for a given group of attributes
  //       const renderButtonsForGroup = (attributes) =>
  //         attributes.map((attribute) => (
  //           <button
  //             key={attribute[0]}
  //             className={`toggle-button ${
  //               checkedCheckboxes[attribute[0]] ? "active" : ""
  //             }`}
  //             onClick={() => handleButtonFilterChange(attribute[0], attribute[0])} // Adjusting method to toggle attributes
  //           >
  //             {modifyLabel(attribute[0])}
  //           </button>
  //         ));

  //       return (
  //         <>
  //           <div className="flex-h grid" >
  //             {renderButtonsForGroup(firstGroupAttributes)}
  //           </div>
  //         </>
  //       );
  //     };

  //     //////////
  //     const renderAttributeButtons = () => {
  //       // Define your attributes in groups
  //       const firstGroupAttributes = [
  //         ["IsRookie", "Rookie(RC)"],
  //         ["IsPatch", "Patch"],
  //       ];
  //       const secondGroupAttributes = [
  //         ["IsJersey", "Jersey"],
  //         ["IsAuto", "Auto"],
  //       ];
  //       // , ['IsTribute', 'Tribute']

  //       // Function to render buttons for a given group of attributes
  //       const renderButtonsForGroup = (attributes) =>
  //         attributes.map((attribute) => (
  //           <button
  //             key={attribute[0]}
  //             className={`toggle-button ${
  //               checkedCheckboxes[attribute[0]] ? "active" : ""
  //             }`}
  //             onClick={() => handleButtonFilterChange(attribute[0], attribute[0])} // Adjusting method to toggle attributes
  //           >
  //             {modifyLabel(attribute[0])}
  //           </button>
  //         ));

  //       return (
  //         <>
  //           <div className="flex-h grid">
  //             {renderButtonsForGroup(firstGroupAttributes)}
  //           </div>
  //           <div className="flex-h grid" >
  //             {renderButtonsForGroup(secondGroupAttributes)}
  //           </div>
  //         </>
  //       );
  //     };

  //     const renderIsWhatButtons = () => {
  //       // Define your attributes in groups
  //       const firstGroupIsWhat = [
  //         ["isForSale", "isForSale"],
  //         ["isForTrade", "isForTrade"],
  //       ];
  //       const secondGroupIsWhat = [
  //         ["isOnEbay", "isOnEbay"],
  //         ["isPC", "isPC"],
  //       ];

  //       // Function to render buttons for a given group of attributes
  //       const renderButtonsForGroup = (IsWhats) =>
  //         IsWhats.map((IsWhat) => (
  //           <button
  //             key={IsWhat[0]}
  //             className={`toggle-button ${
  //               checkedCheckboxes[IsWhat[0]] ? "active" : ""
  //             }`}
  //             onClick={() => handleButtonFilterChange(IsWhat[0], IsWhat[0])} // Adjusting method to toggle attributes
  //           >
  //             {modifyLabel(IsWhat[0])}
  //           </button>
  //         ));

  //       return (
  //         <>
  //           <div className="flex-h grid">
  //             {renderButtonsForGroup(firstGroupIsWhat)}
  //           </div>
  //           <div className="flex-h grid">
  //             {renderButtonsForGroup(secondGroupIsWhat)}
  //           </div>
  //         </>
  //       );
  //     };

  //    // Sort both arrays based on the counts (descending order)
  // const sortByCountDesc = (a, b) => (counts[b] || 0) - (counts[a] || 0);

  // const sortedCheckedItems = [...checkedItems].sort(sortByCountDesc);
  // const sortedUncheckedItems = [...uncheckedItems].sort(sortByCountDesc);

  //     return (
  //     <div className={`filter-group ${isListOpen ? "open" : "closed"} ${isLast ? "filterNoBotterBottom" : ""}`}>

  //         <div className="title" onClick={toggleList}>
  //           <h5>
  //             {title === "isGone" ? t("RecentlyDeleted") : modifyLabel(title)}
  //           </h5>
  //           {/* <svg
  //             className={isListOpen ? "icon open" : "icon"}
  //             viewBox="0 0 7 4"
  //             fill="none"
  //             xmlns="http://www.w3.org/2000/svg"
  //           >
  //             <path
  //               d="M3.5 -6.11959e-07L6.53109 3.75L0.468912 3.75L3.5 -6.11959e-07Z"
  //               fill="#F5DAFF"
  //             />
  //           </svg> */}
  //         </div>

  //         <div className="list open">
  //           {/* ✅ **Search Input (Only for specified filters)** */}
  //           {[
  //             "Name",
  //             "TeamsId",
  //             "SetName",
  //             "cardName",
  //             "variationName",
  //             "YearMade",
  //           ].includes(title) && (
  //             <input
  //               type="text"
  //               placeholder={`Search ${modifyLabel(title)}...`}
  //               value={searchTerm}
  //               onChange={(e) => setSearchTerm(e.target.value)}
  //               className="filter-search-input"
  //               hidden={!isListOpen}
  //             />
  //           )}
  //           {sortedCheckedItems.map((item, index) => (
  //             <div
  //               className={
  //                 index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"
  //               }
  //               key={item}
  //             >
  //               {/* Ensure this is not the 'Filter Attribut' section to avoid duplicating the condition */}
  //               {title !== "Filter Attribut" && title !== "Filter Graded" && (
  //                 <>
  //                   <input
  //                     type="checkbox"
  //                     name={title}
  //                     value={item}
  //                     checked={checkedCheckboxes[item] || false}
  //                     onChange={handleFilterChange}
  //                   />
  //                   <label>
  //                     {title === "TeamsId"
  //                       ? FindTheTeamNameById(item)
  //                       : modifyLabel(item)}
  //                   </label>
  //                   <p style={{ marginLeft: "5px", color: "#0066FFED" }}>
  //                     ({counts[item] || 0})
  //                   </p>
  //                 </>
  //               )}
  //             </div>
  //           ))}

  //           {sortedCheckedItems.length > 5 && (
  //             <button
  //               onClick={() => toggleShowMoreFilter()}
  //               style={{ marginTop: "10px" }}
  //             >
  //               {showMoreFilter ? "Less" : "More"}
  //             </button>
  //           )}
  //         </div>

  //         <div
  //   className={`list ${isListOpen ? "open" : ""} ${
  //     ["Filter Attribut", "GroupBy", "Filter Graded"].includes(title) ? "onlyButton" : ""
  //   }`}
  // >
  //           {title === "Filter Attribut" && (
  //             <div>
  //               {" "}
  //               <AttributeFilterToggle
  //                 currentLogic={attributeFilterLogic}
  //                 setLogic={setAttributeFilterLogic}
  //               />
  //               <div>{renderAttributeButtons()}</div>
  //             </div>
  //           )}

  //           {title === "GroupBy" && (
  //             <div>
  //               {" "}
  //               <AttributeFilterToggle
  //                 currentLogic={isWhatFilterLogic}
  //                 setLogic={setIsWhatFilterLogic}
  //               />
  //               <div>{renderIsWhatButtons()}</div>
  //             </div>
  //           )}

  //           {title === "Filter Graded" && (
  //             <div>
  //               {" "}
  //               <div>{renderGradedButtons()}</div>
  //             </div>
  //           )}

  //           {sortedUncheckedItems.map((item, index) => (
  //             <div
  //               className={
  //                 index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"
  //               }
  //               key={item}
  //             >
  //               {title !== "Filter Attribut" &&
  //                 title !== "GroupBy" &&
  //                 title !== "Filter Graded" && (
  //                   <>
  //                     <input
  //                       type="checkbox"
  //                       name={title}
  //                       value={item}
  //                       checked={checkedCheckboxes[item] || false}
  //                       onChange={handleFilterChange}
  //                     />
  //                     <label>
  //                       {title === "TeamsId"
  //                         ? FindTheTeamNameById(item)
  //                         : modifyLabel(item)}
  //                     </label>
  //                     <p style={{ marginLeft: "5px", color: "lightgray" }}>
  //                       ({counts[item] || 0})
  //                     </p>
  //                   </>
  //                 )}
  //             </div>
  //           ))}
  //           {sortedUncheckedItems.length > 5 && (
  //             <button
  //               onClick={() => toggleShowMoreFilter()}
  //               style={{ marginTop: "10px" }}
  //             >
  //               {showMoreFilter ? "Less" : "More"}
  //             </button>
  //           )}
  //         </div>
  //         {/* Render the "Filter by Saved Sellers" button only when there are saved sellers */}
  //         {title === "ShowName" && favoriteSellers.length > 0 && userId && (
  //           <button onClick={handleSavedSellerFilter}>
  //             {checkedCheckboxes.SavedSeller
  //               ? "Show All Sellers"
  //               : "Show Saved Sellers"}
  //           </button>
  //         )}
  //       </div>
  //     );
  //   };

  // const FilterGroup = ({
  //   title,
  //   items,
  //   counts,
  //   checkedCheckboxes,
  //   handleFilterChange,
  //   isListOpen,
  //   toggleListOpen,
  //   isLast,
  // }) => {
  //   const [showMoreFilter, setShowMoreFilter] = useState(false);
  //   const [searchTerm, setSearchTerm] = useState("");

  //   // --- helpers ---
  //   const toggleList = () => toggleListOpen();
  //   const toggleShowMoreFilter = () => setShowMoreFilter((s) => !s);

  //   function FindTheTeamNameById(teamId) {
  //     const team = teams[teamId];
  //     return team ? team.name : "Unknown Team";
  //   }

  //   const renderFilterItem = (item, index, countColor) => {
  //     const safeItem = String(item).replace(/[^a-zA-Z0-9_-]/g, "-");
  //     const inputId = `${title}-${safeItem}`;
  //     const labelText =
  //       title === "TeamsId" ? FindTheTeamNameById(item) : modifyLabel(item);

  //     return (
  //       <div
  //         className={index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"}
  //         key={`${title}-${item}`}
  //       >
  //         <input
  //           id={inputId}
  //           type="checkbox"
  //           name={title}
  //           value={item}
  //           checked={!!checkedCheckboxes[item]}
  //           onChange={handleFilterChange}
  //         />

  //         <label htmlFor={inputId}>
  //           <span>{labelText}</span>
  //         </label>

  //         <p style={{ marginLeft: 5, color: countColor }}>
  //           ({counts[item] || 0})
  //         </p>
  //       </div>
  //     );
  //   };

  //   const modifyLabel = (label) => {
  //     if (label === "NotisPC") return "NotPC";
  //     if (label === "isPC") return t("PC");
  //     if (label === "NotisOnEbay") return "NotOnEbay";
  //     if (label === "isOnEbay") return t("OnEbay");
  //     if (label === "NotisForTrade") return "NotForTrade";
  //     if (label === "isForTrade") return t("ForTrade");
  //     if (label === "NotisForSale") return "NotForSale";
  //     if (label === "isForSale") return t("ForSale");
  //     if (label === "Name")
  //       return state.sport === "Hockey" ? t("Player") : "Pokemon";
  //     if (label === "TeamsId") return t("Team(Uniform)");
  //     if (label === "SetName") return "Set";
  //     if (label === "cardName") return t("cardName");
  //     if (label === "variationName") return t("variation");
  //     if (label === "YearMade") return t("year");
  //     if (label === "IsAuto") return t("auto");
  //     if (label === "IsRookie") return t("Rookie"); // or "Rookie (Rc)" if you prefer
  //     if (label === "IsPatch") return sport === "Hockey" ? "Patch" : "Holo";
  //     if (label === "IsJersey") return "Jersey";
  //     if (label === "GradeCompany") return t("GradingCompany");
  //     if (label === "ConditionCard") return t("Card Condition");
  //     if (label === "GroupBy") return t("GroupBy");
  //     if (label === "Filter Attribut") return t("Filter Attribut");
  //     if (label === "Filter Graded") return t("Filter Graded");
  //     if (label === "ShowName") return t("ShowName");
  //     if (label === "SavedSeller") return t("SavedSeller");
  //     return label;
  //   };

  //   // special groups (checkbox versions)
  //   const GROUPBY_KEYS = ["isForSale", "isForTrade", "isOnEbay", "isPC"];
  //   const ATTR_KEYS = ["IsRookie", "IsPatch", "IsJersey", "IsAuto"];
  //   const GRADED_KEYS = ["Graded", "Raw"];

  //   const isSpecial =
  //     title === "GroupBy" ||
  //     title === "Filter Attribut" ||
  //     title === "Filter Graded";

  //   // ===== generic searchable list (unchanged for the other groups) =====
  //   const filteredItems = useMemo(() => {
  //     if (
  //       [
  //         "Name",
  //         "TeamsId",
  //         "SetName",
  //         "cardName",
  //         "variationName",
  //         "YearMade",
  //       ].includes(title)
  //     ) {
  //       return items.filter((item) =>
  //         String(item).toLowerCase().includes(searchTerm.toLowerCase()),
  //       );
  //     }
  //     return items;
  //   }, [items, searchTerm, title]);

  //   const checkedItems = useMemo(
  //     () => filteredItems.filter((item) => checkedCheckboxes[item]),
  //     [filteredItems, checkedCheckboxes],
  //   );
  //   const uncheckedItems = useMemo(
  //     () => filteredItems.filter((item) => !checkedCheckboxes[item]),
  //     [filteredItems, checkedCheckboxes],
  //   );

  //   const sortByCountDesc = (a, b) => (counts[b] || 0) - (counts[a] || 0);
  //   const sortedCheckedItems = [...checkedItems].sort(sortByCountDesc);
  //   const sortedUncheckedItems = [...uncheckedItems].sort(sortByCountDesc);

  //   const totalItemsCount = checkedItems.length + uncheckedItems.length;
  //   return (
  //     <div
  //       className={`filter-group ${isListOpen ? "open" : "closed"} ${isLast ? "filterNoBotterBottom" : ""}`}
  //     >
  //       {/* header */}
  //       <div className="title">
  //         {/* onClick={toggleList} */}
  //         <h5>
  //           {title === "isGone" ? t("RecentlyDeleted") : modifyLabel(title)}
  //         </h5>
  //       </div>

  //       {/* ===== SPECIAL CASES: checkbox UI for GroupBy / Filter Attribut / Graded ===== */}
  //       {isSpecial ? (
  //         <div className={`list ${isListOpen ? "open" : ""}`}>
  //           {title === "GroupBy" && (
  //             <>
  //               <AttributeFilterToggle
  //                 currentLogic={isWhatFilterLogic}
  //                 setLogic={setIsWhatFilterLogic}
  //               />

  //               {GROUPBY_KEYS.map((key) => (
  //                 <div className="checkb" key={key}>
  //                   <input
  //                     id={`groupby-${key}`}
  //                     type="checkbox"
  //                     checked={!!checkedCheckboxes[key]}
  //                     onChange={() => handleButtonFilterChange(key, key)}
  //                   />
  //                   <label htmlFor={`groupby-${key}`}>
  //                     <span>{modifyLabel(key)}</span>
  //                   </label>
  //                 </div>
  //               ))}
  //             </>
  //           )}

  //           {title === "Filter Attribut" && (
  //             <>
  //               <AttributeFilterToggle
  //                 currentLogic={attributeFilterLogic}
  //                 setLogic={setAttributeFilterLogic}
  //               />

  //               {ATTR_KEYS.map((key) => (
  //                 <div className="checkb">
  //                   <input
  //                     type="checkbox"
  //                     checked={!!checkedCheckboxes[key]}
  //                     onChange={() => handleButtonFilterChange(key, key)}
  //                   />
  //                   <label className="" key={key}>
  //                     <span>{modifyLabel(key)}</span>
  //                   </label>
  //                 </div>
  //               ))}
  //             </>
  //           )}

  //           {title === "Filter Graded" &&
  //             GRADED_KEYS.map((key) => (
  //               <div className="checkb">
  //                 <input
  //                   type="checkbox"
  //                   checked={!!checkedCheckboxes[key]}
  //                   onChange={() => handleButtonFilterChange(key, key)}
  //                 />
  //                 <label className="checkb" key={key}>
  //                   <span>{modifyLabel(key)}</span>
  //                 </label>
  //               </div>
  //             ))}
  //         </div>
  //       ) : (
  //         /* ===== GENERIC GROUPS ===== */
  //         <>
  //           <div className="list open">
  //             {[
  //               "Name",
  //               "TeamsId",
  //               "SetName",
  //               "cardName",
  //               "variationName",
  //               "YearMade",
  //             ].includes(title) &&
  //               totalItemsCount > 10 && (
  //                 <input
  //                   type="text"
  //                   placeholder={`Search ${modifyLabel(title)}...`}
  //                   value={searchTerm}
  //                   onChange={(e) => setSearchTerm(e.target.value)}
  //                   className="filter-search-input"
  //                   hidden={!isListOpen}
  //                 />
  //               )}

  //             {sortedCheckedItems.map((item, index) => (
  //               <div
  //                 className={
  //                   index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"
  //                 }
  //                 key={item}
  //               >
  //                 <input
  //                   type="checkbox"
  //                   name={title}
  //                   value={item}
  //                   checked={checkedCheckboxes[item] || false}
  //                   onChange={handleFilterChange}
  //                 />
  //                 <label>
  //                   {title === "TeamsId"
  //                     ? FindTheTeamNameById(item)
  //                     : modifyLabel(item)}
  //                 </label>
  //                 <p style={{ marginLeft: 5, color: "#0066FFED" }}>
  //                   ({counts[item] || 0})
  //                 </p>
  //               </div>
  //             ))}

  //             {sortedCheckedItems.length > 5 && (
  //               <p onClick={toggleShowMoreFilter} className="text-color-blue">
  //                 {showMoreFilter ? "Less" : "More"}
  //               </p>
  //             )}
  //           </div>

  //           <div className={`list ${isListOpen ? "open" : ""}`}>
  //             {sortedUncheckedItems.map((item, index) => (
  //               <div
  //                 className={
  //                   index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"
  //                 }
  //                 key={item}
  //               >
  //                 <input
  //                   type="checkbox"
  //                   name={title}
  //                   value={item}
  //                   checked={checkedCheckboxes[item] || false}
  //                   onChange={handleFilterChange}
  //                 />
  //                 <label>
  //                   {title === "TeamsId"
  //                     ? FindTheTeamNameById(item)
  //                     : modifyLabel(item)}
  //                 </label>
  //                 <p style={{ marginLeft: "5px", color: "lightgray" }}>
  //                   ({counts[item] || 0})
  //                 </p>
  //               </div>
  //             ))}

  //             {sortedUncheckedItems.length > 5 && (
  //               <p onClick={toggleShowMoreFilter} className="text-color-blue">
  //                 {showMoreFilter ? "Less" : "More"}
  //               </p>
  //             )}
  //           </div>
  //         </>
  //       )}

  //       {/* Saved sellers CTA unchanged */}
  //       {title === "ShowName" && favoriteSellers.length > 0 && userId && (
  //         <button onClick={handleSavedSellerFilter}>
  //           {checkedCheckboxes.SavedSeller
  //             ? "Show All Sellers"
  //             : "Show Saved Sellers"}
  //         </button>
  //       )}
  //     </div>
  //   );
  // };
  const FilterGroup = ({
  title,
  items,
  counts,
  checkedCheckboxes,
  handleFilterChange,
  isListOpen,
  toggleListOpen,
  isLast,
}) => {
  const [showMoreFilter, setShowMoreFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleList = () => toggleListOpen();
  const toggleShowMoreFilter = () => setShowMoreFilter((s) => !s);

  function FindTheTeamNameById(teamId) {
    const team = teams[teamId];
    return team ? team.name : "Unknown Team";
  }

  const modifyLabel = (label) => {
    if (label === "NotisPC") return "NotPC";
    if (label === "isPC") return t("PC");
    if (label === "NotisOnEbay") return "NotOnEbay";
    if (label === "isOnEbay") return t("OnEbay");
    if (label === "NotisForTrade") return "NotForTrade";
    if (label === "isForTrade") return t("ForTrade");
    if (label === "NotisForSale") return "NotForSale";
    if (label === "isForSale") return t("ForSale");
    if (label === "Name")
      return state.sport === "Hockey" ? t("Player") : "Pokemon";
    if (label === "TeamsId") return t("Team(Uniform)");
    if (label === "SetName") return "Set";
    if (label === "cardName") return t("cardName");
    if (label === "variationName") return t("variation");
    if (label === "YearMade") return t("year");
    if (label === "IsAuto") return t("auto");
    if (label === "IsRookie") return t("Rookie");
    if (label === "IsPatch") return state.sport === "Hockey" ? "Patch" : "Holo";
    if (label === "IsJersey") return "Jersey";
    if (label === "GradeCompany") return t("GradingCompany");
    if (label === "ConditionCard") return t("Card Condition");
    if (label === "GroupBy") return t("GroupBy");
    if (label === "Filter Attribut") return t("Filter Attribut");
    if (label === "Filter Graded") return t("Filter Graded");
    if (label === "ShowName") return t("ShowName");
    if (label === "SavedSeller") return t("SavedSeller");
    return label;
  };

  const renderFilterItem = (item, index, countColor) => {
    const safeItem = String(item).replace(/[^a-zA-Z0-9_-]/g, "-");
    const inputId = `${title}-${safeItem}`;
    const labelText =
      title === "TeamsId" ? FindTheTeamNameById(item) : modifyLabel(item);

    return (
      <div
        className={index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"}
        key={`${title}-${item}`}
      >
        <input
          id={inputId}
          type="checkbox"
          name={title}
          value={item}
          checked={!!checkedCheckboxes[item]}
          onChange={handleFilterChange}
        />

        <label htmlFor={inputId}>
          <span>{labelText}</span>
        </label>

        <p style={{ marginLeft: 5, color: countColor }}>
          ({counts[item] || 0})
        </p>
      </div>
    );
  };

  const GROUPBY_KEYS = ["isForSale", "isForTrade", "isOnEbay", "isPC"];
  const ATTR_KEYS = ["IsRookie", "IsPatch", "IsJersey", "IsAuto"];
  const GRADED_KEYS = ["Graded", "Raw"];

  const isSpecial =
    title === "GroupBy" ||
    title === "Filter Attribut" ||
    title === "Filter Graded";

  const filteredItems = useMemo(() => {
    if (
      [
        "Name",
        "TeamsId",
        "SetName",
        "cardName",
        "variationName",
        "YearMade",
      ].includes(title)
    ) {
      return items.filter((item) =>
        String(item).toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    return items;
  }, [items, searchTerm, title]);

  const checkedItems = useMemo(
    () => filteredItems.filter((item) => checkedCheckboxes[item]),
    [filteredItems, checkedCheckboxes]
  );

  const uncheckedItems = useMemo(
    () => filteredItems.filter((item) => !checkedCheckboxes[item]),
    [filteredItems, checkedCheckboxes]
  );

  const sortByCountDesc = (a, b) => (counts[b] || 0) - (counts[a] || 0);
  const sortedCheckedItems = [...checkedItems].sort(sortByCountDesc);
  const sortedUncheckedItems = [...uncheckedItems].sort(sortByCountDesc);

  const totalItemsCount = checkedItems.length + uncheckedItems.length;

  return (
    <div
      className={`filter-group ${isListOpen ? "open" : "closed"} ${
        isLast ? "filterNoBotterBottom" : ""
      }`}
    >
      <div className="title">
        {/* Remets onClick={toggleList} ici si tu veux réouvrir/fermer au clic sur le header */}
        {/* onClick={toggleList} */}
        <h5>
          {title === "isGone" ? t("RecentlyDeleted") : modifyLabel(title)}
        </h5>
      </div>

      {isSpecial ? (
        <div className={`list ${isListOpen ? "open" : ""}`}>
          {title === "GroupBy" && (
            <>
              <AttributeFilterToggle
                currentLogic={isWhatFilterLogic}
                setLogic={setIsWhatFilterLogic}
              />

              {GROUPBY_KEYS.map((key) => {
                const inputId = `groupby-${key}`;

                return (
                  <div className="checkb" key={key}>
                    <input
                      id={inputId}
                      type="checkbox"
                      checked={!!checkedCheckboxes[key]}
                      onChange={() => handleButtonFilterChange(key, key)}
                    />
                    <label htmlFor={inputId}>
                      <span>{modifyLabel(key)}</span>
                    </label>
                  </div>
                );
              })}
            </>
          )}

          {title === "Filter Attribut" && (
            <>
              <AttributeFilterToggle
                currentLogic={attributeFilterLogic}
                setLogic={setAttributeFilterLogic}
              />

              {ATTR_KEYS.map((key) => {
                const inputId = `attribute-${key}`;

                return (
                  <div className="checkb" key={key}>
                    <input
                      id={inputId}
                      type="checkbox"
                      checked={!!checkedCheckboxes[key]}
                      onChange={() => handleButtonFilterChange(key, key)}
                    />
                    <label htmlFor={inputId}>
                      <span>{modifyLabel(key)}</span>
                    </label>
                  </div>
                );
              })}
            </>
          )}

          {title === "Filter Graded" &&
            GRADED_KEYS.map((key) => {
              const inputId = `graded-${key}`;

              return (
                <div className="checkb" key={key}>
                  <input
                    id={inputId}
                    type="checkbox"
                    checked={!!checkedCheckboxes[key]}
                    onChange={() => handleButtonFilterChange(key, key)}
                  />
                  <label htmlFor={inputId}>
                    <span>{modifyLabel(key)}</span>
                  </label>
                </div>
              );
            })}
        </div>
      ) : (
        <>
          <div className="list open">
            {[
              "Name",
              "TeamsId",
              "SetName",
              "cardName",
              "variationName",
              "YearMade",
            ].includes(title) &&
              totalItemsCount > 10 && (
                <input
                  type="text"
                  placeholder={`Search ${modifyLabel(title)}...`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="filter-search-input"
                  hidden={!isListOpen}
                />
              )}

            {sortedCheckedItems.map((item, index) =>
              renderFilterItem(item, index, "#0066FFED")
            )}

            {sortedCheckedItems.length > 5 && (
              <p onClick={toggleShowMoreFilter} className="text-color-blue">
                {showMoreFilter ? "Less" : "More"}
              </p>
            )}
          </div>

          <div className={`list ${isListOpen ? "open" : ""}`}>
            {sortedUncheckedItems.map((item, index) =>
              renderFilterItem(item, index, "lightgray")
            )}

            {sortedUncheckedItems.length > 5 && (
              <p onClick={toggleShowMoreFilter} className="text-color-blue">
                {showMoreFilter ? "Less" : "More"}
              </p>
            )}
          </div>
        </>
      )}

      {title === "ShowName" && favoriteSellers.length > 0 && userId && (
        <button onClick={handleSavedSellerFilter}>
          {checkedCheckboxes.SavedSeller
            ? "Show All Sellers"
            : "Show Saved Sellers"}
        </button>
      )}
    </div>
  );
};
  // PriceRange.jsx

  const toNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : NaN;
  };

  const PriceRange = ({
    label = "Price range",
    min = 0,
    defaultMax = 1000,
    step = 1,
    values = {}, // { minPrice, maxPrice }
    onChange, // callback from parent (memoized in parent!)
    currency = "$",
    debounce = 750,
  }) => {
    const [isActive, setIsActive] = useState(
      values.minPrice != null || values.maxPrice != null,
    );
    const [minStr, setMinStr] = useState(values.minPrice ?? String(min));
    const [maxStr, setMaxStr] = useState(values.maxPrice ?? String(defaultMax));

    const [lastValid, setLastValid] = useState({
      min: toNumber(values.minPrice ?? min),
      max: toNumber(values.maxPrice ?? defaultMax),
    });

    const [dynamicMax, setDynamicMax] = useState(
      Math.max(toNumber(values.maxPrice ?? defaultMax), defaultMax),
    );

    // sync from parent
    useEffect(() => {
      const vMin = values.minPrice ?? min;
      const vMax = values.maxPrice ?? defaultMax;
      const activeFromParent =
        values.minPrice != null || values.maxPrice != null;
      if (activeFromParent !== isActive) setIsActive(activeFromParent);

      // only set when actually different (avoids pointless renders)
      const sMin = String(vMin);
      const sMax = String(vMax);
      if (minStr !== sMin) setMinStr(sMin);
      if (maxStr !== sMax) setMaxStr(sMax);

      const nMin = toNumber(vMin);
      const nMax = toNumber(vMax);
      if (Number.isFinite(nMin) && Number.isFinite(nMax) && nMin < nMax) {
        if (nMin !== lastValid.min || nMax !== lastValid.max) {
          setLastValid({ min: nMin, max: nMax });
        }
        const nextDyn = Math.max(nMax, defaultMax);
        if (nextDyn !== dynamicMax) setDynamicMax(nextDyn);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.minPrice, values.maxPrice, min, defaultMax]);

    const curMin = toNumber(minStr);
    const curMax = toNumber(maxStr);
    const isValid =
      Number.isFinite(curMin) && Number.isFinite(curMax) && curMin < curMax;

    // keep UI responsive immediately
    useEffect(() => {
      if (!isValid || !isActive) return;
      const nextDynMax = Math.max(curMax, defaultMax);
      if (nextDynMax !== dynamicMax) setDynamicMax(nextDynMax);
      if (curMin !== lastValid.min || curMax !== lastValid.max) {
        setLastValid({ min: curMin, max: curMax });
      }
    }, [
      isValid,
      curMin,
      curMax,
      defaultMax,
      dynamicMax,
      lastValid.min,
      lastValid.max,
    ]);

    const pct = (v) => ((v - min) / (dynamicMax - min)) * 100;
    const left = useMemo(
      () => pct(lastValid.min),
      [lastValid.min, dynamicMax, min],
    );
    const right = useMemo(
      () => pct(lastValid.max),
      [lastValid.max, dynamicMax, min],
    );

    const clampMin = (v) =>
      Math.min(Math.max(v, min), (isValid ? curMax : lastValid.max) - step);
    const clampMax = (v) =>
      Math.max(
        Math.min(v, dynamicMax),
        (isValid ? curMin : lastValid.min) + step,
      );

    const normalizeMinOnBlur = () => {
      const n = toNumber(minStr);
      const baseMax = isValid ? curMax : lastValid.max;
      let next = Number.isFinite(n) ? n : min;
      next = Math.min(Math.max(next, min), baseMax - step);
      setMinStr(String(next));
    };

    const normalizeMaxOnBlur = () => {
      const n = toNumber(maxStr);
      const baseMin = isValid ? curMin : lastValid.min;
      let next = Number.isFinite(n) ? n : Math.max(defaultMax, baseMin + step);
      next = Math.max(next, baseMin + step);
      if (next > dynamicMax) setDynamicMax(next);
      setMaxStr(String(next));
    };

    // ✅ single, guarded debounced emit
    const lastSentRef = useRef({ min: undefined, max: undefined });
    useEffect(() => {
      if (!isValid || !isActive) return;

      // already same as parent? skip
      if (curMin === values.minPrice && curMax === values.maxPrice) return;
      // same as last emission? skip
      if (
        curMin === lastSentRef.current.min &&
        curMax === lastSentRef.current.max
      )
        return;

      const timer = setTimeout(() => {
        // re-check before firing
        if (curMin === values.minPrice && curMax === values.maxPrice) return;
        lastSentRef.current = { min: curMin, max: curMax };
        onChange?.({ minPrice: curMin, maxPrice: curMax });
      }, debounce);

      return () => clearTimeout(timer);
    }, [
      isValid,
      curMin,
      curMax,
      debounce,
      onChange,
      values.minPrice,
      values.maxPrice,
    ]);
    const minInputRef = useRef(null);
    const maxInputRef = useRef(null);
    return (
      <div className="price-range">
        <div className="price-range__inputs">
          <div className="price-field">
            <input
              type="number"
              inputMode="numeric"
              className={`pill ${!isValid && !Number.isFinite(curMin) ? "invalid" : ""}`}
              value={minStr}
              onChange={(e) => setMinStr(e.target.value)}
              onBlur={normalizeMinOnBlur}
              disabled={!isActive}
              aria-disabled={!isActive}
              onClick={() => {
                if (!isActive) {
                  setIsActive(true);
                  // focus after enabling so the caret appears right away
                  requestAnimationFrame(() => minInputRef.current?.focus());
                }
              }}
            />
          </div>
          <div className="price-field">
            <input
              type="number"
              inputMode="numeric"
              className={`pill ${!isValid && !Number.isFinite(curMax) ? "invalid" : ""}`}
              value={maxStr}
              onChange={(e) => setMaxStr(e.target.value)}
              onBlur={normalizeMaxOnBlur}
              disabled={!isActive}
              aria-disabled={!isActive}
              onClick={() => {
                if (!isActive) {
                  setIsActive(true);
                  // focus after enabling so the caret appears right away
                  requestAnimationFrame(() => minInputRef.current?.focus());
                }
              }}
            />
          </div>
        </div>

        <div
          className={`price-range__slider ${!isValid || !isActive ? "disabled" : ""}`}
          aria-label={label}
        >
          <div className="track" />
          <div
            className="progress"
            style={{ left: `${left}%`, width: `${right - left}%` }}
          />

          <input
            aria-label="Minimum price"
            type="range"
            min={min}
            max={dynamicMax}
            step={step}
            value={lastValid.min}
            onChange={(e) =>
              setMinStr(String(clampMin(toNumber(e.target.value))))
            }
            className="thumb thumb--left"
            disabled={!isValid || !isActive}
            onPointerDown={() => setIsActive(true)}
          />
          <input
            aria-label="Maximum price"
            type="range"
            min={min}
            max={dynamicMax}
            step={step}
            value={lastValid.max}
            onChange={(e) => {
              const raw = toNumber(e.target.value);
              const next = clampMax(raw);
              if (next > dynamicMax) setDynamicMax(next);
              setMaxStr(String(next));
            }}
            className="thumb thumb--right"
            disabled={!isValid || !isActive}
            onPointerDown={() => setIsActive(true)}
          />
        </div>

        {!isValid && (
          <div className="price-range__hint">
            {t("Price range invalid hint")}
          </div>
        )}
        <div className="enable-row">
          {!isActive ? (
            <button className="btn-ghost" onClick={() => setIsActive(true)}>
              {t("Enable")}
            </button>
          ) : (
            <button
              className="btn-ghost"
              onClick={() => {
                setIsActive(false);
                onChange?.({ minPrice: undefined, maxPrice: undefined });
              }}
            >
              {t("Disable")}
            </button>
          )}
        </div>
      </div>
    );
  };
  const onPriceChange = useCallback((next) => {
    setFilterValues((prev) => {
      // short-circuit if identical (prevents wasted renders)
      if (prev.minPrice === next.minPrice && prev.maxPrice === next.maxPrice)
        return prev;
      return { ...prev, ...next };
    });
  }, []);

  //-----------------------------------Test

  function deleteCardsFromAll(singleCardsId) {
    let cardId = singleCardsId;

    console.log("CardId to delete", cardId);

    // ✅ Open a confirmation modal instead of immediately executing
    openModal(
      t("Confirm Deletion"),
      `${t("Are you sure you want to delete")} 1 ${t("cards permanently?")}`,
      null, // No input needed
      () => executeDeleteCards([cardId]), // ✅ Wait until user confirms
    );
  }

  function openModal(title, message, content, confirmAction) {
    setModalTitle(title);
    setModalMessage(message);
    setModalContent(content);
    setModalConfirmAction(() => confirmAction);
    setModalVisible(true);
  }
  // ✅ Move actual deletion logic to a separate function
  function executeDeleteCards(cardIds) {
    fetch(`${process.env.REACT_APP_API_BASE}/api/remove/card`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // Include credentials (cookies)
      body: JSON.stringify({
        cardIds,
        liveCsrfToken: liveCsrfToken,
        userId: userId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete cards");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data.message);
        toast.success(t("toast_card_deleted"));
        setFilteredCards((prevCards) =>
          prevCards.filter((card) => !cardIds.includes(card.id)),
        );
        setSingleCardOperationId(0);
        setSelectedCards([]);
      })
      .catch((error) => {
        console.error("Error deleting cards:", error);
        toast.error(t("toast_card_delete_error"));
      });

    console.log("Cards deletion initiated");
  }

  let currentCard;

  function handleSingleCardEditClick(card) {
    console.log(card);
    navigate(
      i18n.language === "fr"
        ? `/fr/EditCard/${card.id}`
        : `/EditCard/${card.id}`,
      {
        state: { card },
      },
    );

    nextOperation("Edit");
  }

  function handleSingleCardDeleteClick(userCardId) {
    setSingleCardOperationId(userCardId);
    nextOperation("DeleteFromAll");
  }

  function handleSingleCardRemoveFromWatchlistClick(userCardId) {
    setSingleCardOperationId(userCardId);

    nextOperation("DeleteFromWatchlist");
  }
  function handleSingleCardMarkAsSold(userCardId) {
    handleGroupAction({ target: { value: "actionMarkAsSold", userCardId } });
  }
  function nextOperation(operation) {
    switch (operation) {
      case "Edit":
        console.log("Editing...");
        break;
      case "DeleteFromAll":
        console.log("Deleting...");
        break;
      case "DeleteFromWatchlist":
        setConfirmationVisibleForDeleteFromCollectionOnly(true);
        console.log("Removing from watchlist...");
        break;
      case "MarkAsSold":
        setConfirmationVisibleForMarkAsSold(true);

        console.log("Mark as solded...");
        break;
      default:
        console.log("Invalid operation");
        break;
    }
  }

  // const AttributeFilterToggle = ({ currentLogic, setLogic }) => {
  //   // Determine checkbox states based on current logic
  //   const isOrChecked = currentLogic === "Or";
  //   const isAndChecked = currentLogic === "And";

  //   // Handle logic change
  //   const handleLogicChange = (logic) => {
  //     setLogic(logic);
  //   };

  //   return (
  //     <div className="logic-option flex-h grid">
  //       <label htmlFor="orLogic">{t("Or")}</label>
  //       <input
  //         type="checkbox"
  //         id="orLogic"
  //         checked={isOrChecked}
  //         onChange={() => handleLogicChange("Or")}
  //         disabled={isOrChecked} // Disable checkbox if already selected
  //       />

  //       <label htmlFor="andLogic">{t("And")}</label>
  //       <input
  //         type="checkbox"
  //         id="andLogic"
  //         checked={isAndChecked}
  //         onChange={() => handleLogicChange("And")}
  //         disabled={isAndChecked} // Disable checkbox if already selected
  //       />
  //     </div>
  //   );
  // };

  //   const AttributeFilterToggle = ({ currentLogic, setLogic }) => {
  //   const isOrChecked = currentLogic === "Or";
  //   const isAndChecked = currentLogic === "And";

  //   return (
  //    <>
  //    <div className="logic-toggle-wrapper">
  //       <label>
  //         <input
  //           type="radio"
  //           id="logicToggle"
  //           className="logic-toggle"
  //           checked={isOrChecked}
  //           onChange={() => setLogic("Or")}
  //         />
  //         {t("Or")}
  //       </label>
  //       <label>
  //         <input
  //           type="radio"
  //           id="logicToggle"
  //           className="logic-toggle"
  //           checked={isAndChecked}
  //           onChange={() => setLogic("And")}
  //         />
  //         {t("And")}
  //       </label>

  //     </div>
  //     <div className="logic-wrapper">
  //   <div className="logic-option"></div>
  // </div>
  // </>
  //   );
  // };

  // AttributeFilterToggle.jsx

  const AttributeFilterToggle = ({ currentLogic, setLogic, name }) => {
    // auto-fallback if no name is provided
    const auto = useId();
    const groupName = name || `logic-${auto}`;

    return (
      <div className="logic">
        <label className="logic__option">
          <input
            type="radio"
            name={groupName}
            value="And"
            checked={currentLogic === "And"}
            onChange={() => setLogic("And")}
          />
          {/* <span className="logic__dot" aria-hidden="true" /> */}
          {t("And")}
        </label>

        <label className="logic__option">
          <input
            type="radio"
            name={groupName}
            value="Or"
            checked={currentLogic === "Or"}
            onChange={() => setLogic("Or")}
          />
          {/* <span className="logic__dot" aria-hidden="true" /> */}
          {t("Or")}
        </label>
      </div>
    );
  };

  function isValidStringForDeleteCollection(str) {
    return str !== "" && str !== "0" && str !== "MyListings";
  }

  const renderSelectMenu = () => {
    if (!multiEditState || selectedCards.length === 0) return null;

    switch (cardGridType) {
      case "CardGrid":
        return (
          <div className="trade-pref-wrapper small">
            {/* <Select
          
          className="trade-pref-select"
          styles={stylingSelect}
          options={groupActionOptions}
          isSearchable={false}
          isDisabled={!multiEditState || selectedCards.length === 0}
          onChange={(selected) => handleGroupAction({ target: { value: selected?.value } })}
        /> */}
            <Select
              className="trade-pref-select small"
              styles={stylingSelect}
              options={groupActionOptions}
              isSearchable={false}
              isDisabled={!multiEditState || selectedCards.length === 0}
              //value={selectedGroupAction}
              onChange={(selected) => {
                //setSelectedGroupAction(selected); // update selected state
                handleGroupAction({ target: { value: selected?.value } }); // forward value
              }}
              placeholder={t("Select an action for the selected cards")} // optional, if not using the first disabled option
              formatOptionLabel={(option) => {
                if (option.isDivider) {
                  return (
                    <div
                      style={{ borderTop: "1px solid #666", margin: "6px 0" }}
                    />
                  );
                }
                return <div style={{ paddingLeft: "8px" }}>{option.label}</div>;
              }}
            />
          </div>
        );
      case "CardGridSell":
        return (
          <Select
            className="custom-select"
            styles={stylingSelect}
            isSearchable={false}
            isDisabled={!multiEditState || selectedCards.length === 0}
            placeholder={t("Select an action for the selected cards")}
            onChange={(selected) => {
              handleGroupAction({ target: { value: selected?.value } });
            }}
            options={[
              {
                value: "actionAssignToCollection",
                label: t("Assign to an existing WantList"),
              },
              {
                value: "actionCreateNewCollection",
                label: t("Create a new WantList"),
              },
              {
                value: "divider-1",
                label: "",
                isDisabled: true,
                isDivider: true,
              },
              {
                value: "actionSendToCart",
                label: t("Send To Cart"),
              },
              {
                value: "divider-1",
                label: "",
                isDisabled: true,
                isDivider: true,
              },
              ...(selectedCollectionLive !== "My listing" &&
              selectedCollectionLive !== ""
                ? [
                    {
                      value: "actionDeleteFromCollection",
                      label: `${t("Delete those cards")} (${selectedCards.length}) ${t(
                        "from your WantList",
                      )} (${selectedCollectionTitle}) ${t("only")}`,
                    },
                  ]
                : []),
              ...(selectedCollectionLive === "My listing"
                ? [
                    {
                      value: "actionNotForSale",
                      label: `${t("Not for Sale anymore")} (${selectedCards.length})`,
                    },
                  ]
                : []),
            ]}
            formatOptionLabel={(option) =>
              option.isDivider ? (
                <div style={{ borderTop: "1px solid #666", margin: "6px 0" }} />
              ) : (
                <div style={{ paddingLeft: "8px" }}>{option.label}</div>
              )
            }
          />
        );
      default:
        return null;
    }
  };

  const addToWatchlist = (cardUserCardId) => {
    const apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/watchlist/add/cards`;

    const requestData = {
      WatchListId: defaultWatchlist.WatchListId,
      cardIds: [cardUserCardId],
      liveCsrfToken: liveCsrfToken,
      userId: userId,
    };

    return fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": liveCsrfToken,
      },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          toast.success(
            `${t("Added to watchlist")} (${defaultWatchlist.Title})`,
          );
          return { WatchListId: defaultWatchlist.WatchListId }; // Return WatchListId
        } else {
          toast.warning(data.message);
          throw new Error("Failed to add to watchlist");
        }
      })
      .catch((error) => {
        console.error("Error adding card to watchlist:", error);
        toast.error(t("Failed to add card to watchlist."));
        throw error;
      });
  };

  const removeFromWatchlist = (cardUserCardId, watchListId) => {
    const apiEndpoint = `${process.env.REACT_APP_API_BASE}/api/marketplace/remove/card`;
    console.log(
      "Removing from watchlist,",
      watchListId,
      "cardUserCardId",
      cardUserCardId,
    );

    const requestData = {
      WatchListId: watchListId,
      cardIds: [cardUserCardId],
      liveCsrfToken,
      userId: userId,
    };

    return fetch(apiEndpoint, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": liveCsrfToken,
      },
      credentials: "include",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Successfully removed from watchlist
          return data;
        } else {
          toast.warning(data.message);
          throw new Error("Failed to remove from watchlist");
        }
      })
      .catch((error) => {
        console.error("Error removing card from watchlist:", error);
        toast.error(t("Failed to remove card from watchlist."));
        throw error;
      });
  };

  // const toggleFavorite = async (cardUserCardId) => {

  //   if (userId === null) navigate(`/login`);

  //   const favoriteCardInfo = favoriteCards[cardUserCardId];

  //   const isCurrentlyFavorite = favoriteCardInfo?.isFavorite;
  //   let newWatchListId;

  //   try {
  //     if (isCurrentlyFavorite) {
  //       // Remove from watchlist
  //       await removeFromWatchlist(cardUserCardId, favoriteCardInfo.WatchListId);
  //       newWatchListId = null;
  //     } else {
  //       // Add to watchlist
  //       const addedCard = await addToWatchlist(cardUserCardId);
  //       console.log('watchlist addedCard',addedCard)
  //       newWatchListId = addedCard?.WatchListId; // Assuming `addToWatchlist` returns the new WatchListId
  //     }

  //     // Update the state after successful API response
  //     setFavoriteCards((prevFavorites) => ({
  //       ...prevFavorites,
  //       [cardUserCardId]: {
  //         isFavorite: !isCurrentlyFavorite,
  //         WatchListId: newWatchListId,
  //       },
  //     }));
  //     console.log('Removing from watchlist apres tout',!isCurrentlyFavorite,newWatchListId)
  //   } catch (error) {
  //     console.error('Error toggling favorite:', error);
  //   }
  // };
  const variationRefs = useRef({});
  const [truncatedMap, setTruncatedMap] = useState({});
  useEffect(() => {
    const newTruncatedMap = {};
    cards.forEach((card) => {
      const el = variationRefs.current[card.id];
      if (el) {
        const isTruncated = el.scrollHeight > el.clientHeight;
        console.log("istruncatedMap", isTruncated);
        newTruncatedMap[card.id] = isTruncated;
      }
    });
    setTruncatedMap(newTruncatedMap);
    console.log("truncatedMap", truncatedMap);
  }, [cards]); // You can also listen for language changes here

  useEffect(() => {
    if (
      (cardGridType === "CardGridSell" || cardGridType === "CardGrid") &&
      userId &&
      liveCsrfToken
    ) {
      fetchCollections();
      fetchCollectionsCards();
      console.log(allCollectionCards);
    }
  }, [favoriteCards, userId, liveCsrfToken]);

  const toggleFavorite = async (cardUserCardId, cardId) => {
    // Prevent triggering the card's main onClick
    if (!userId) {
      // Save the intended path to local storage

      if (hasConsent()) {
        localStorage.setItem(
          "intendedPath",
          window.location.pathname + window.location.search,
        );
      }

      navigate(i18n.language === "fr" ? `/fr/login` : `/login`);
      return;
    }
    //fetchCollectionsCards()
    // Check if the card is currently in favoriteCards
    console.log(
      "favorite favoriteCards  cardUserCardId,cardId",
      favoriteCards,
      cardUserCardId,
      cardId,
    );
    const favoriteCardInfo = favoriteCards.find(
      (card) => card.userCardId === cardUserCardId,
    );
    const isCurrentlyFavorite = Boolean(favoriteCardInfo);
    let newWatchListId;

    try {
      if (isCurrentlyFavorite) {
        // Remove from watchlist
        await removeFavoriteCard(cardUserCardId);

        newWatchListId = null;
      } else {
        // Add to watchlist
        await addFavoriteCard(cardUserCardId, cardId);
        newWatchListId = favoriteCardInfo?.WatchListId || null;
      }

      // Update the state after successful API response
      setFavoriteCards(
        (prevFavorites) =>
          isCurrentlyFavorite
            ? prevFavorites.filter((card) => card.userCardId !== cardUserCardId) // Remove the card
            : [
                ...prevFavorites,
                { userCardId: cardUserCardId, WatchListId: newWatchListId },
              ], // Add the card
      );

      console.log(
        "Favorite status updated for card:",
        cardUserCardId,
        "New WatchListId:",
        newWatchListId,
      );
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  // const FavoriteIcon = ({
  //   cardUserCardId,
  //   cardId,
  //   isFavorite,
  //   cardUserId,
  //   userId,
  //   toggleFavorite,
  // }) => {
  //   const [isProcessing, setIsProcessing] = useState(false);

  //   const handleFavoriteToggle = async (event) => {
  //     event.stopPropagation(); // Prevent triggering the card's main onClick

  //     if (isProcessing) return; // Prevent multiple requests during processing

  //     setIsProcessing(true); // Set processing state to true

  //     const MIN_PROCESSING_TIME = 1000; // Minimum time to show the spinner in milliseconds (1 second)

  //     const startTime = Date.now(); // Record the start time

  //     try {
  //       await toggleFavorite(cardUserCardId, cardId); // Await the favorite toggle action
  //       // Update state optimistically for immediate UI feedback
  //     } catch (error) {
  //       console.error("Error toggling favorite:", error);
  //       toast.error("Failed to update favorite status.");
  //     } finally {
  //       const elapsedTime = Date.now() - startTime;
  //       const remainingTime = MIN_PROCESSING_TIME - elapsedTime;

  //       // Ensure the spinner shows for at least the minimum time
  //       if (remainingTime > 0) {
  //         setTimeout(() => {
  //           setIsProcessing(false);
  //         }, remainingTime);
  //       } else {
  //         setIsProcessing(false);
  //       }
  //     }
  //   };

  //   return (
  //     parseInt(cardUserId) !== parseInt(userId) && (
  //       <div className="favorite-icon-wrapper" onClick={handleFavoriteToggle}>
  //         {isProcessing ? (
  //           <SpinnerIcon />
  //         ) : isFavorite ? (
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="24"
  //             height="24"
  //             fill="#0066FFED"
  //             viewBox="0 0 24 24"
  //           >
  //             <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  //           </svg>
  //         ) : (
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="24"
  //             height="24"
  //             fill="grey"
  //             viewBox="0 0 24 24"
  //           >
  //             <path d="M16.5 3c-1.74 0-3.41 0.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55L12 19.1l-0.1-0.09C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04 0.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" />
  //           </svg>
  //         )}
  //       </div>
  //     )
  //   );
  // };

  //-----------------------------------EndTest
  //----------------------------------------------RenderJSX---------------------------------------------------
  // if (userId === null) navigate(`/login`);
  // else

  const triggerLogin = () => {
    if (!userId) {
      // Save the intended path to local storage
      if (hasConsent()) {
        localStorage.setItem(
          "intendedPath",
          window.location.pathname + window.location.search,
        );
      }

      navigate(i18n.language === "fr" ? `/fr/login` : `/login`);
      return;
    }
  };

  // WatchlistActions.jsx

  return (
    <>
      <div className="top-controls">
        <button
          className={
            isFilterVisible ? "toggle-filters-btn red" : "toggle-filters-btn "
          }
          onClick={handleToggleFilters}
        >
          {isFilterVisible ? "Close" : "☰ Filters"}
        </button>
      </div>

      <div className="card-container">
        {isFilterVisible && (
          <div className="filter-container">
            <div className="card-grid-container">
              <button
                className="mobile-close-button"
                onClick={handleToggleFilters}
              >
                X {t("Close")}
              </button>

              {/* 
              <button
                className="mobile-close-button"
                onClick={handleToggleFilters}
              >
                X {t("Close")}
              </button> */}

              <div className="filter-header">
                <div className="filter-actions">
                  <span className="filter-label">{t("Filter")}</span>
                  <button className="filter-clear" onClick={resetFilters}>
                    {t("resetfilter")}
                  </button>
                </div>
              </div>
              {cardGridType === "CardGrid" &&
                !viewOnly &&
                (totalCardValue > 0 || totalSellingValue > 0) && (
                  <div className="total-summary">
                    <div className="summary-box">
                      {t("totalTV")}
                      <span>{totalCardValue.toFixed(2)} $</span>
                    </div>
                    <div className="summary-box">
                      {t("totalPrice")}
                      <span>{totalSellingValue.toFixed(2)} $</span>
                    </div>
                  </div>
                )}

              {/*Confirmation dialog end*/}
              {/* Render the form elements conditionally */}

              {/* <div className="search-control">
                <input
                  placeholder={t("Search")}
                  value={searchTermInput}
                  onChange={(e) => setSearchTermInput(e.target.value)}
                  
                />
               <img src={search}/>
                <button
                  className={"button-secondary"}
              
                  onClick={() => handleClickSearchButton(false)}
                >
                  {t("Search")}
                </button>
              </div> */}

              <FilterComponent
                filterValues={filterValues}
                removeFilter={removeFilter}
                clearCategory={clearCategory}
                handleClearFilters={resetFilters}
                sport={state.sport}
              />

              {userId && (
                <div className="trade-pref-wrapper">
                  <label htmlFor="tradePrefSelect" className="reference-label">
                    {/* className="trade-pref-label" */}⭐{" "}
                    {t("Apply Trade Preference")}:
                  </label>
                  <Select
                    id="tradePrefSelect"
                    className="trade-pref-select"
                    value={selectedTradePref}
                    onChange={handleTradePrefChange}
                    options={tradingPreferences.map((pref) => ({
                      value: pref.TradingPreferencesId,
                      label: pref.TemplateTitle,
                    }))}
                    styles={stylingSelect}
                    placeholder={t("Select a preference")}
                    isClearable
                    isSearchable={false}
                    formatOptionLabel={(option) => {
                      if (option.isDivider) {
                        return (
                          <div
                            style={{
                              borderTop: "1px solid #666",
                              margin: "1px 0",
                            }}
                          />
                        );
                      }
                      return (
                        <div
                          style={{
                            paddingLeft: "8px",
                            backgroundColor: "#0E1D30",
                          }}
                        >
                          {option.label}
                        </div>
                      );
                    }}
                    isOpen={true}
                  />
                </div>
              )}

              {/* <button className="button-secondary" onClick={resetFilters} style={{marginLeft:'auto', marginRight:'0.6rem'}}>
                  {t("resetfilter")}🔄
                </button> */}

              <div className="filters-container">
                {/* --- Price --- */}
                <FilterSection
                  label={t("Price Filter")}
                  openKey="Price"
                  openSections={openSections}
                  setOpenSections={setOpenSections}
                >
                  <PriceRange values={filterValues} onChange={onPriceChange} />
                </FilterSection>
                {/* --- Tags & Attributes --- */}
                <FilterSection
                  label={t("TagsAndAttributes")}
                  openKey="TagsAndAttributes"
                  openSections={openSections}
                  setOpenSections={setOpenSections}
                >
                  <FilterGroup
                    title="GroupBy"
                    logicName="logic-groupby"
                    items={uniqueIsRookie}
                    counts={isRookieCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["GroupBy"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({ ...p, GroupBy: !p["GroupBy"] }))
                    }
                  />

                  {state.sport === "Hockey" && (
                    <FilterGroup
                      title="Filter Attribut"
                      logicName="logic-attribute"
                      items={uniqueIsRookie}
                      counts={isRookieCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                      isListOpen={openFilters["Filter Attribut"]}
                      toggleListOpen={() =>
                        setOpenFilters((p) => ({
                          ...p,
                          "Filter Attribut": !p["Filter Attribut"],
                        }))
                      }
                      isLast={false}
                    />
                  )}
                </FilterSection>

                {/* --- Condition --- */}
                <FilterSection
                  label={t("Condition")}
                  openKey="Condition"
                  openSections={openSections}
                  setOpenSections={setOpenSections}
                >
                  <FilterGroup
                    title="Filter Graded"
                    items={uniqueIsGraded}
                    counts={isGradedCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["Filter Graded"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({
                        ...p,
                        "Filter Graded": !p["Filter Graded"],
                      }))
                    }
                  />
                  <FilterGroup
                    title="GradeCompany"
                    items={uniqueGradeCompany}
                    counts={gradeCompanyCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["GradeCompany"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({
                        ...p,
                        GradeCompany: !p["GradeCompany"],
                      }))
                    }
                  />
                  <FilterGroup
                    title="Grade"
                    items={uniqueGrade}
                    counts={gradeCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["Grade"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({ ...p, Grade: !p["Grade"] }))
                    }
                  />
                  <FilterGroup
                    title="ConditionCard"
                    items={uniqueConditionCard}
                    counts={conditionCardCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["ConditionCard"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({
                        ...p,
                        ConditionCard: !p["ConditionCard"],
                      }))
                    }
                    isLast={false}
                  />
                </FilterSection>

                {/* --- Player --- */}
                {state.sport === "Hockey" && (
                  <FilterSection
                    label={t("Player")}
                    openKey="Player"
                    openSections={openSections}
                    setOpenSections={setOpenSections}
                  >
                    <FilterGroup
                      title="Name"
                      items={uniqueNames}
                      counts={nameCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                      isListOpen={openFilters["Name"]}
                      toggleListOpen={() =>
                        setOpenFilters((p) => ({ ...p, Name: !p["Name"] }))
                      }
                    />
                    <FilterGroup
                      title="TeamsId"
                      items={uniqueTeamsId}
                      counts={teamsIdCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                      isListOpen={openFilters["TeamsId"]}
                      toggleListOpen={() =>
                        setOpenFilters((p) => ({
                          ...p,
                          TeamsId: !p["TeamsId"],
                        }))
                      }
                      isLast={false}
                    />
                  </FilterSection>
                )}
                {/* --- Year & Set --- */}
                <FilterSection
                  label={t("YearAndSet")}
                  openKey="YearAndSet"
                  openSections={openSections}
                  setOpenSections={setOpenSections}
                >
                  {state.sport === "Hockey" && (
                    <FilterGroup
                      title="YearMade"
                      items={uniqueYear}
                      counts={yearCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                      isListOpen={openFilters["YearMade"]}
                      toggleListOpen={() =>
                        setOpenFilters((p) => ({
                          ...p,
                          YearMade: !p["YearMade"],
                        }))
                      }
                    />
                  )}
                  <FilterGroup
                    title="SetName"
                    items={uniqueSets}
                    counts={setCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["SetName"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({ ...p, SetName: !p["SetName"] }))
                    }
                  />
                  <FilterGroup
                    title="cardName"
                    items={uniqueCardName}
                    counts={cardNameCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["cardName"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({
                        ...p,
                        cardName: !p["cardName"],
                      }))
                    }
                  />
                  <FilterGroup
                    title="variationName"
                    items={uniqueVariationName}
                    counts={variationNameCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["variationName"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({
                        ...p,
                        variationName: !p["variationName"],
                      }))
                    }
                    isLast={false}
                  />
                </FilterSection>

                {/* --- optional (sell) --- */}
                {cardGridType === "CardGridSell" && (
                  <FilterSection
                    label={t("ShowName")}
                    openKey="Show"
                    openSections={openSections}
                    setOpenSections={setOpenSections}
                  >
                    <FilterGroup
                      title="ShowName"
                      items={uniqueShowName}
                      counts={showNameCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                      isListOpen={openFilters["ShowName"]}
                      toggleListOpen={() =>
                        setOpenFilters((p) => ({
                          ...p,
                          ShowName: !p["ShowName"],
                        }))
                      }
                      isLast={false}
                    />
                  </FilterSection>
                )}

                {/* --- Recently Deleted --- */}
                <FilterSection
                  label={t("RecentlyDeleted")}
                  openKey="Deleted"
                  openSections={openSections}
                  setOpenSections={setOpenSections}
                >
                  <FilterGroup
                    title="isGone"
                    items={uniqueIsGone}
                    counts={isGoneCounts}
                    checkedCheckboxes={checkedCheckboxes}
                    handleFilterChange={handleFilterChange}
                    isListOpen={openFilters["isGone"]}
                    toggleListOpen={() =>
                      setOpenFilters((p) => ({ ...p, isGone: !p["isGone"] }))
                    }
                    isLast={false}
                  />
                </FilterSection>
              </div>
            </div>
          </div>
        )}

        <div
          className={`collection-container ${
            isFilterVisible ? "with-filters" : "no-filters"
          }`}
        >
          {!viewAsGrid ? (
            <>
              <div className="action-bar-wrapper">
                <div className="action-bar-inner">
                  <ActionModal
                    isVisible={modalVisible}
                    title={modalTitle}
                    message={modalMessage}
                    onCancel={() => setModalVisible(false)}
                    onConfirm={
                      modalConfirmAction
                        ? () => {
                            modalConfirmAction();
                            setModalVisible(false);
                          }
                        : undefined // ✅ Clean: nothing passed if no action needed
                    }
                  >
                    {typeof modalContent === "function"
                      ? modalContent()
                      : modalContent}
                  </ActionModal>
                  <ConfirmationModal
                    isVisible={confirmationVisibleForDeleteFromCollectionOnly}
                    onCancel={() =>
                      setConfirmationVisibleForDeleteFromCollectionOnly(false)
                    }
                    onConfirm={() => removeFromCardsCardsList(true)}
                    message={`${t(
                      "deleteyourselectedCardsFromCollection",
                    )}: ${selectedCollectionTitle} ${t("youareremoving")} (${
                      singleCardOperationId !== 0 ? 1 : selectedCards.length
                    }) ${t("cards")}?`}
                  />

                  <ConfirmationModal
                    isVisible={confirmationVisibleNotForSale}
                    onCancel={() => setConfirmationVisibleNotForSale(false)}
                    onConfirm={() => removeFromMarketplaceNotForSale(true)}
                    message={`${t("areyousureremovelisting")} (${
                      selectedCards.length
                    })?`}
                  />

                  {iconViewImageOnly()}
                  {iconViewPrice()}
                  {/* {viewOnly && viewImageOnly && !viewAsGrid && } */}
                  {userId &&
                    !MultiCardOfferSelection &&
                    !viewAsGrid &&
                    (isEditingPriceVisible && !viewAsGrid ? (
                      <button
                        onClick={() => setIsEditingPriceVisible(false)}
                        className="button-primary ExtraMargin"
                      >
                        {t("Disable Price Editing")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={30}
                          height={30}
                          fill="#fff"
                          viewBox="0 0 36 36"
                        >
                          <title>{"eraser-solid"}</title>
                          <path
                            d="M28 32H15.33L19 28.37l-9.9-9.9L3.54 24a1.83 1.83 0 0 0 0 2.6L9 32H3a1 1 0 0 0 0 2h25a1 1 0 0 0 0-2Z"
                            className="clr-i-solid clr-i-solid-path-1"
                          />
                          <path
                            d="m34.08 10.65-7.3-7.3a1.83 1.83 0 0 0-2.6 0L10.47 17.06l9.9 9.9 13.71-13.71a1.85 1.85 0 0 0 0-2.6Z"
                            className="clr-i-solid clr-i-solid-path-2"
                          />
                          <path fill="none" d="M0 0h36v36H0z" />
                        </svg>
                      </button>
                    ) : (
                      <button
                        onClick={() => setIsEditingPriceVisible(true)}
                        className="button-primary ExtraMargin"
                      >
                        {t("Edit Price")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlSpace="preserve"
                          width={30}
                          height={30}
                          fill="#fff"
                          viewBox="0 0 512 512"
                        >
                          <path d="M498.125 92.38 419.62 13.874c-18.496-18.497-48.436-18.5-66.935 0-13.167 13.169-302.639 302.642-308.16 308.161a16.878 16.878 0 0 0-4.46 7.915L.502 491.068c-3.036 12.368 8.186 23.44 20.431 20.432l161.117-39.564a16.878 16.878 0 0 0 7.915-4.46l308.161-308.161c18.496-18.497 18.501-48.436-.001-66.935zM39.957 472.043l1.612-6.562 4.951 4.951-6.563 1.611zm44.917-11.029-33.887-33.887 14.736-60.009 79.16 79.16-60.009 14.736zm93.148-29.367-97.668-97.668L332.559 81.773l97.668 97.668-252.205 252.206zM474.24 135.429l-19.508 19.507-97.667-97.668 19.507-19.507c5.294-5.293 13.867-5.298 19.163 0l78.506 78.507c5.295 5.295 5.295 13.864-.001 19.161z" />
                        </svg>
                      </button>
                    ))}

                  <div className="multi-edit-wrapper">
                    {MultiCardOfferSelection ? (
                      <button
                        className={`button-primary bigAss ${
                          multiEditState ? "active" : ""
                        }`}
                        onClick={handleSetCardsForOnGoingOffer}
                      >
                        {`${t("AddToOffer")} (${selectedCards.length})`}
                        <CheckIcon />
                      </button>
                    ) : (
                      <>
                        {!viewOnly && (
                          <>
                            <button
                              className={`button-primary ExtraMargin  ${
                                multiEditState ? "active" : ""
                              }`}
                              onClick={handleMultiEditButton}
                            >
                              {!multiEditState
                                ? t("groupSelection")
                                : `${t("undoSelection")} (${
                                    selectedCards.length
                                  })`}
                            </button>

                            {!viewOnly && multiEditState && (
                              <div className="multi-edit-select">
                                {renderSelectMenu()}
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/* <button onClick={toggleViewAsGrid} className="gridOptionButton">
                  {viewAsGrid ? t("Show as Single") : t("Show as Grid")}
                </button> */}

              {/* <div style={{ marginLeft: "auto", marginRight: "1vw" }}>
                  {MultiCardOfferSelection ? (
                    <>
                      <button
                        className={
                          !multiEditState
                            ? "gridOptionButton"
                            : "gridOptionButton active"
                        }
                        onClick={handleSetCardsForOnGoingOffer}
                      >
                        {`${t("AddToOffer")} (${selectedCards.length})`}
                      </button>
                    </>
                  ) : (
                    <div className="flex-h" style={{ paddingBottom: "0" }}>
                      {viewOnly ? null : (
                        <>{multiEditState ? renderSelectMenu() : null}</>
                      )}

                      <button
                        className={
                          !multiEditState
                            ? "gridOptionButton"
                            : "gridOptionButton active"
                        }
                        onClick={handleMultiEditButton}
                        style={{ marginLeft: "15px" }}
                      >
                        {!multiEditState
                          ? t("groupSelection")
                          : `${t("undoSelection")} (${selectedCards.length})`}
                      </button>
                    </div>
                  )} */}
              {/* 
<div style={{ marginLeft: "1vw", marginBottom: "1rem" }}>
            {/* Render FilterComponent and pass the removeFilter function */}

              {/* <FilterComponent
              filterValues={filterValues}
              removeFilter={removeFilter}
              clearCategory={clearCategory}
              handleClearFilters={resetFilters}
            /> 
          </div> */}

              {userId && cardGridType !== "Profil" && (
                <div className="collection-row">
                  <Sousmenu
                    // existing
                    selectedCollectionLive={selectedCollectionLive}
                    handleChangeCollectionLive={handleChangeCollectionLive}
                    handleGroupAction={handleGroupAction}
                    cardGridType={cardGridType}
                    userId={userId}
                    collections={collections}
                    t={t}
                    // new/needed for the menu
                    selectedCollectionIsDefault={selectedCollectionIsDefault}
                    selectedCollectionIsPublic={selectedCollectionIsPublic}
                    selectedCollectionTitle={selectedCollectionTitle}
                    defaultWatchlist={defaultWatchlist}
                    handleSetAsDefault={handleSetAsDefault}
                    handleCollectionPublicClick={handleCollectionPublicClick}
                    handleCopyToClipboard={handleCopyToClipboard}
                    isValidStringForDeleteCollection={
                      isValidStringForDeleteCollection
                    }
                  />
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingBottom: "0",
                  width: "100%",
                }}
              >
                {/* <div className="centered-container">
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    partialOnly={false}
                  />
                </div> */}

                <form
                  className="search-control"
                  style={{ margin: 0, maxWidth: "20rem" }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleClickSearchButton(false); // runs search with current input
                  }}
                >
                  <div className="search-field">
                    <input
                      placeholder={t("Search")}
                      value={searchTermInput}
                      onChange={(e) => {
                        const v = e.target.value;
                        setSearchTermInput(v);
                        // optional: if user deletes everything, reset results immediately
                        if (v.trim() === "") handleClickSearchButton(true);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Escape" && searchTermInput) {
                          setSearchTermInput("");
                          handleClickSearchButton(true); // reset on ESC
                        }
                      }}
                      aria-label={t("Search")}
                    />

                    {/* Clear (×) only when there's a value */}
                    {searchTermInput && (
                      <button
                        type="button"
                        className="search-clear-btn"
                        onClick={() => {
                          setSearchTermInput("");
                          handleClickSearchButton(true); // run empty search to clear filters/results
                        }}
                        aria-label={t("Clear search")}
                        title={t("Clear search")}
                      >
                        ×
                      </button>
                    )}

                    {/* Submit/search icon */}
                    <button
                      type="submit"
                      className="search-icon-btn"
                      aria-label={t("Search")}
                      title={t("Search")}
                    >
                      <img src={search} alt="" aria-hidden="true" />
                    </button>
                  </div>
                </form>

                <SortingSelect
                  cardGridType={cardGridType}
                  data={filteredCards}
                  setData={setFilteredCards}
                  isGrouped={false}
                  originalData={originalData}
                  //bringBackOriginal={()=>setBringBackOriginal(!bringBackOriginal)}
                />
              </div>
            </>
          ) : (
            <>
              <div className="flex-h" style={{ paddingBottom: "0px" }}>
                {/* <button
                  className="toggle-filters-btn"
                  onClick={handleToggleFilters}
                >
                  {isFilterVisible ? "⬅️" : "➡️"}
                </button> */}
                <div
                  style={{
                    marginTop: "4vh",
                    maxWidth: "80%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  {/* <PaginationComponent
                    totalPages={totalPagesGrouped}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    partialOnly={false}
                  /> */}
                  <LoadMoreBar
                    total={totalGrouped}
                    shown={itemsShown}
                    onMore={() => handleShowMore(totalGrouped)}
                    stepIndex={stepIndex}
                    SHOW_MORE_STEPS={SHOW_MORE_STEPS}
                  />
                </div>
              </div>
              <div style={{ alignItems: "center" }} className="flex-h">
                {iconViewImageOnly()}
                {/* 
                <button className="gridOptionButton" onClick={toggleViewAsGrid}>
                  {viewAsGrid ? t("Show as Single") : t("Show as Grid")}
                </button> */}
              </div>
            </>
          )}

          <div
            className={
              !multiEditState ? "card-grid-wrapper" : `card-grid-wrapper multi`
            }
          >
            {!viewAsGrid
              ? //? filteredCards.map((card) => (
                //  <cardDesign card={card}/>
                currentItems.map((card) => {
                  const isVisible = visibleCardIds.includes(card.id);

                  return (
                    <div className="cardcontent">
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      ></div>

                      {cardGridType === "CardGridSell" &&
                        !MultiCardOfferSelection && (
                          <div
                            className="user-profile"
                            onClick={() =>
                              navigate(
                                i18n.language === "fr"
                                  ? `/fr/ViewUserProfil/${card.ShowName}`
                                  : `/ViewUserProfil/${card.ShowName}`,
                              )
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={
                                card.ProfilPicture
                                  ? card.ProfilPicture
                                  : profile
                              }
                              alt="User"
                              className="profile-picture"
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                              }}
                              // Adjust size and shape as needed
                            />
                            <span
                              className="ShowName"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "white",
                                  fontSize: "12px",
                                }}
                              >
                                {card.ShowName} ({card.NumberOfTransactions})
                                {(card.AverageRating * 20).toFixed(1)}%
                                <img
                                  src={`https://flagcdn.com/24x18/${getCountryCode(
                                    card.Country || "ca",
                                  ).toLowerCase()}.png`}
                                  className="country-flag"
                                  alt="flag"
                                  style={{ marginLeft: "3px" }}
                                  isVisible={isVisible}
                                />
                              </a>
                            </span>
                          </div>
                        )}

                      <div
                        key={card.id}
                        className={`card ${
                          selectedCards.includes(card.id) ? "card-selected" : ""
                        }`}
                        onClick={(event) => {
                          if (
                            event.ctrlKey ||
                            event.metaKey ||
                            event.button === 1
                          ) {
                            return; // Prevent onClick from running if Ctrl+Click or Middle Click
                          }
                          if (openMenuCardId === card.id) {
                            event.stopPropagation();
                            return;
                          }
                          handleCardClick(card, false, event);
                        }}
                        onMouseDown={(event) => {
                          if (
                            event.ctrlKey ||
                            event.metaKey ||
                            event.button === 1
                          ) {
                            event.preventDefault(); // Prevent default browser behavior
                            window.open(`/cards/${card.id}`, "_blank");
                          }
                        }}
                      >
                        <div className="img">
                          <div
                            className={`card-image-container ${
                              flippedCardId === card.id ? "flipped" : ""
                            }`}
                          >
                            <LazyImage
                              className="card-image front"
                              src={card.ImageFront || card.Image}
                              alt="Front of Card"
                              isVisible={isVisible}
                            />
                            <LazyImage
                              className="card-image back"
                              src={card.ImageUserBack || card.ImageBack}
                              alt="Back of Card"
                              isVisible={isVisible}
                            />
                          </div>

                          {multiEditState === false && (
                            <CardOverlayActions
                              card={card}
                              userId={userId}
                              cardGridType={cardGridType}
                              selectedCollectionTitle={selectedCollectionTitle}
                              selectedCollectionLive={selectedCollectionLive}
                              collections={collections}
                              viewPrice={viewPrice}
                              t={t}
                              setExpandedCardId={setExpandedCardId}
                              isValidStringForDeleteCollection={
                                isValidStringForDeleteCollection
                              }
                              onFlip={(id) => handleToggleCard(id)}
                              onEdit={(c) => handleSingleCardEditClick(c)}
                              onDelete={(id) => deleteCardsFromAll(id)}
                              onRemoveFromWatchlist={(id) =>
                                handleSingleCardRemoveFromWatchlistClick(id)
                              }
                              onMarkAsSold={(id) =>
                                handleSingleCardMarkAsSold(id)
                              }
                              onAssignCollection={(listId, cardId) =>
                                onAssignCollection(listId, cardId)
                              }
                              removeFromMarketplaceNotForSaleSingle={
                                removeFromMarketplaceNotForSaleSingle
                              }
                              removeFromMarketplaceNotForTradeSingle={
                                removeFromMarketplaceNotForTradeSingle
                              }
                              removeFromMarketplaceNotPC={
                                removeFromMarketplaceNotPC
                              }
                              removeFromMarketplaceNotOnEbay={
                                removeFromMarketplaceNotOnEbay
                              }
                              onMenuToggle={(cardId, isOpen) =>
                                setOpenMenuCardId(isOpen ? cardId : null)
                              }
                            >
                              {cardGridType === "CardGridSell" &&
                                parseInt(card.UserId) !== parseInt(userId) && (
                                  <FavoriteIcon
                                    key={`${card.userCardId}-${!!favoriteCards[card.userCardId]}`}
                                    cardUserCardId={card.userCardId ?? card.id}
                                    cardId={card.CardId}
                                    isFavorite={favoriteCards.some(
                                      (c) =>
                                        c.userCardId ===
                                        (card.userCardId ?? card.id),
                                    )}
                                    toggleFavorite={toggleFavorite}
                                    cardUserId={card.UserId}
                                    userId={userId}
                                    size={30}
                                  />
                                )}
                            </CardOverlayActions>
                          )}

                          {/* Favorite Icon - Positioned in the top-right */}
                          {/* Favorite Icon - Positioned in the top-right */}
                          {cardGridType === "CardGridSell" &&
                            parseInt(card.UserId) !== parseInt(userId) && (
                              <FavoriteIcon
                                key={`${card.userCardId}-${
                                  favoriteCards[card.userCardId]?.isFavorite
                                }`}
                                cardUserCardId={card.userCardId ?? card.id}
                                cardId={card.CardId}
                                isFavorite={favoriteCards.some(
                                  (card123) =>
                                    card123.userCardId ===
                                    (card.userCardId ?? card.id),
                                )}
                                toggleFavorite={toggleFavorite}
                                cardUserId={card.UserId}
                                userId={userId}
                                size={30}
                              />
                            )}

                          {!viewImageOnly ? (
                            <>
                              <div className="filter"></div>

                              {(cardGridType === "CardGrid" ||
                                cardGridType === "Profil") && (
                                <div className="card-top-right-tags">
                                  {card.isForSale === "isForSale" && (
                                    <div className="patch forsale">
                                      <p>FS</p>
                                    </div>
                                  )}
                                  {card.isForTrade === "isForTrade" && (
                                    <div className="patch fortrade">
                                      <p>FT</p>
                                    </div>
                                  )}
                                  {card.isPC === "isPC" && (
                                    <div className="patch pc">
                                      <p>PC</p>
                                    </div>
                                  )}
                                </div>
                              )}

                              <div className="card-isWhat">
                                {card.IsRookie === "Rookie(RC)" && (
                                  <div className="patch spe">
                                    <p className="strong">RC</p>
                                  </div>
                                )}

                                {card.Graded === "Graded" ||
                                card.Graded === true ? (
                                  // <div className="patch cond">
                                  <div
                                    className={`patch ${card.GradeCompany.toLowerCase()} border absoRight`}
                                  >
                                    <p>
                                      {card.GradeCompany} {card.Grade}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="patch cond">
                                    <p>{card.ConditionCard}</p>
                                  </div>
                                )}

                                {card.IsPatch === "Patch" && (
                                  <div className="patch">
                                    <p>
                                      {sport === "Hockey" ? "Patch" : "Holo"}
                                    </p>
                                  </div>
                                )}

                                {card.IsJersey === "Jersey" && (
                                  <div className="patch">
                                    <p>Jersey</p>
                                  </div>
                                )}

                                {card.IsAuto === "Auto" && (
                                  <div className="patch">
                                    <p>Auto</p>
                                  </div>
                                )}
                              </div>
                            </>
                          ) : null}
                        </div>
                        {viewPrice &&
                          viewImageOnly &&
                          (() => {
                            const isForSale = card.isForSale === "isForSale";
                            const isForTrade = card.isForTrade === "isForTrade";
                            const price = Number(card?.Price) || 0;
                            const tv = Number(card?.EstimateValue) || 0;

                            const isMyCollection = cardGridType === "CardGrid";
                            const isMarket = cardGridType === "CardGridSell";

                            // ✅ KEEP price display exactly how it was (but I strongly recommend > 0 later)
                            const showPrice = isForSale && price >= 0;

                            // ✅ CardGridSell: keep old fallback behavior (TV only if no price)
                            // ✅ CardGrid: ALWAYS show TV when it exists (even if price is shown)
                            const showTV = isMyCollection
                              ? tv >= 1
                              : !isMarket && tv >= 1;

                            // Render only if we have something to show (value or action)
                            if (
                              !(
                                showPrice ||
                                showTV ||
                                (isForSale && price >= 0) ||
                                (isForTrade && tv >= 1)
                              )
                            )
                              return null;

                            return (
                              <div className="cta-row-grid">
                                <div className="cta-leftStack">
                                  {/* ✅ KEEP PRICE UI EXACTLY AS BEFORE */}
                                  {showPrice && (
                                    <>
                                      <span className="meta-label">
                                        {t("Price")}
                                      </span>
                                      <span className="meta-amount">
                                        {price.toLocaleString(undefined, {
                                          style: "currency",
                                          currency: "CAD",
                                          currencyDisplay: "narrowSymbol",
                                        })}
                                      </span>
                                    </>
                                  )}

                                  {/* ✅ CardGrid only: show TV even if price exists
            ✅ CardGridSell: show TV only when price not shown (old behavior)
        */}
                                  {showTV && (
                                    <>
                                      {/* If price is also shown (CardGrid), add a tiny separator */}
                                      {isMyCollection && showPrice && (
                                        <div style={{ height: 6 }} />
                                      )}

                                      <span className="meta-label">TV</span>
                                      <span className="meta-amount">
                                        {tv.toLocaleString(undefined, {
                                          style: "currency",
                                          currency: "CAD",
                                          currencyDisplay: "narrowSymbol",
                                        })}
                                      </span>
                                    </>
                                  )}
                                </div>

                                <div className="cta-right">
                                  {/* ✅ keep buttons as you already had them */}
                                  {isForSale === true &&
                                    price >= 0 &&
                                    cardGridType !== "CardGrid" && (
                                      <button
                                        className="cta-icon-button cta-icon--buy"
                                        type="button"
                                        onClick={(e) => {
                                          if (!MultiCardOfferSelection) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            openSale(card);
                                          }
                                        }}
                                        aria-label={t("Buy It Now")}
                                        title={t("Buy It Now")}
                                      >
                                        <svg
                                          viewBox="0 0 24 24"
                                          aria-hidden="true"
                                        >
                                          <path
                                            d="M12 1v22M17 6c0-2.761-2.686-5-6-5S5 3.239 5 6s2.686 5 6 5 6 2.239 6 5-2.686 5-6 5-6-2.239-6-5"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                          />
                                        </svg>
                                      </button>
                                    )}

                                  {isForTrade === true &&
                                    tv >= 1 &&
                                    cardGridType !== "CardGrid" && (
                                      <button
                                        className="cta-icon-button cta-icon--trade"
                                        type="button"
                                        onClick={(e) => {
                                          if (!MultiCardOfferSelection) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectedTradeCard(card);
                                            setIsTradeModalOpen(true);
                                          }
                                        }}
                                        aria-label={t("Trade")}
                                        title={t("Trade")}
                                      >
                                        <svg
                                          viewBox="0 0 24 24"
                                          aria-hidden="true"
                                        >
                                          <path
                                            d="M7 7h13l-3.5-3.5M17 17H4l3.5 3.5"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </button>
                                    )}
                                </div>
                              </div>
                            );
                          })()}

                        {!viewImageOnly ? (
                          <>
                            <div className="txt">
                              <div className="justify">
                                <h4 className="card-name">{card.Name}</h4>
                                <p className="card-IDcard">
                                  #{card.NumberBehind}
                                </p>
                              </div>
                              <p className="card-set">{card.SetName}</p>
                              <div className="flex-h">
                                <p
                                  ref={(el) =>
                                    (variationRefs.current[card.id] = el)
                                  }
                                  className="card-variation-grid"
                                >
                                  {card.cardName}
                                  {truncatedMap[card.id] && (
                                    <span className="dots">. . .</span>
                                  )}{" "}
                                  {card.variationName}
                                </p>
                                {/* 
        {card.Numbered === "" || card.Numbered === "0" || card.Numbered === 0 ? null : (
          <p className="card-numbered">/ {card.Numbered}</p>
        )} 
        */}
                              </div>

                              {(cardGridType === "CardGridSell" ||
                                cardGridType === "Profil" ||
                                cardGridType === "CardGrid") &&
                                viewPrice &&
                                (() => {
                                  const isForSale =
                                    card.isForSale === "isForSale";
                                  const isForTrade =
                                    card.isForTrade === "isForTrade";
                                  const price = Number(card?.Price) || 0;
                                  const tv = Number(card?.EstimateValue) || 0;

                                  // left-side value logic
                                  const showPrice = isForSale && price >= 0; // Price only if actually selling
                                  const showTV = !showPrice && tv >= 1; // Fallback to TV whenever it exists

                                  // render only if we have something to show (left value or any action)
                                  if (
                                    !(
                                      showPrice ||
                                      showTV ||
                                      (isForSale && price >= 0) ||
                                      (isForTrade && tv >= 1)
                                    )
                                  )
                                    return null;

                                  return (
                                    <div className="cta-row-grid">
                                      {/* LEFT: label on top, amount below */}
                                      <div className="cta-leftStack">
                                        <span className="meta-label">
                                          {showPrice
                                            ? t("Price")
                                            : showTV
                                              ? "TV"
                                              : ""}
                                        </span>
                                        <span className="meta-amount">
                                          {showPrice
                                            ? price.toLocaleString(undefined, {
                                                style: "currency",
                                                currency: "CAD",
                                                currencyDisplay: "narrowSymbol",
                                              })
                                            : showTV
                                              ? tv.toLocaleString(undefined, {
                                                  style: "currency",
                                                  currency: "CAD",
                                                  currencyDisplay:
                                                    "narrowSymbol",
                                                })
                                              : ""}
                                        </span>
                                      </div>

                                      {/* RIGHT: actions (only when allowed) */}
                                      <div className="cta-right">
                                        {isForSale === true &&
                                          price >= 0 &&
                                          cardGridType !== "CardGrid" && (
                                            //     <button className="cta-btn- cta-btn---primary" onClick={(e)=>   {e.preventDefault();
                                            // e.stopPropagation(); openSale(card)}}>
                                            //       {t("Buy It Now")}
                                            //     </button>
                                            <button
                                              className="cta-icon-button cta-icon--buy"
                                              type="button"
                                              onClick={(e) => {
                                                if (!MultiCardOfferSelection) {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                  openSale(card);
                                                }
                                              }}
                                              aria-label={t("Buy it Now")}
                                              title={t("Buy it Now")}
                                            >
                                              {/* $ icon */}
                                              <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                              >
                                                <path
                                                  d="M12 1v22M17 6c0-2.761-2.686-5-6-5S5 3.239 5 6s2.686 5 6 5 6 2.239 6 5-2.686 5-6 5-6-2.239-6-5"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                />
                                              </svg>
                                            </button>
                                          )}

                                        {isForTrade === true &&
                                          tv >= 1 &&
                                          cardGridType !== "CardGrid" && (
                                            //     <button
                                            //       className={`cta-btn- ${isForSale && price >= 0 ? "cta-btn---ghost" : "cta-btn---primary"}`}
                                            //       title={t("Propose Trade")}
                                            //       onClick={(e)=>   {e.preventDefault();
                                            // e.stopPropagation();setSelectedTradeCard(card);setIsTradeModalOpen(true);}}
                                            //     >
                                            //       {t("Trade")}
                                            //     </button>
                                            <button
                                              className="cta-icon-button cta-icon--trade"
                                              type="button"
                                              onClick={(e) => {
                                                if (!MultiCardOfferSelection) {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                  setSelectedTradeCard(card);
                                                  setIsTradeModalOpen(true);
                                                }
                                              }}
                                              aria-label={t("Trade")}
                                              title={t("Trade")}
                                              //disabled={MultiCardOfferSelection}
                                            >
                                              {/* swap/trade icon */}
                                              <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                              >
                                                <path
                                                  d="M7 7h13l-3.5-3.5M17 17H4l3.5 3.5"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>
                                            </button>
                                          )}
                                      </div>
                                    </div>
                                  );
                                })()}

                              <div className="card-value">
                                {isEditingPriceVisible &&
                                  parseInt(card.UserId) ===
                                    parseInt(userId) && (
                                    <PriceEditChange
                                      card={card}
                                      onPriceUpdate={handlePriceUpdate}
                                    />
                                  )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="card-value">
                            {isEditingPriceVisible &&
                              parseInt(card.UserId) === parseInt(userId) && (
                                <PriceEditChange
                                  card={card}
                                  onPriceUpdate={handlePriceUpdate}
                                />
                              )}
                          </div>
                        )}
                      </div>
                      <div className="flex-h">
                        {(cardGridType === "CardGridSell" ||
                          cardGridType === "Profil") &&
                          parseInt(card.UserId) !== parseInt(userId) &&
                          currentItems.length > 0 && (
                            <>
                              {selectedCard && (
                                <SaleModals
                                  key={
                                    selectedCard.userCardId || selectedCard.id
                                  } // forces remount per card
                                  isOpen={isSaleModalOpen}
                                  onClose={() => {
                                    setIsSaleModalOpen(false);
                                    setSelectedCard(null);
                                  }}
                                  selectedCard={selectedCard}
                                  SellerId={selectedCard.UserId}
                                  SellerShowName={selectedCard.ShowName}
                                  SellerInfo={{
                                    ShowName: selectedCard.ShowName,
                                    ProfilPicture: selectedCard.ProfilPicture,
                                    NumberOfTransactions:
                                      selectedCard.NumberOfTransactions,
                                    AverageX5: (
                                      selectedCard.AverageRating * 20
                                    ).toFixed(1),
                                    City: selectedCard.City || "Unknown",
                                    Country: selectedCard.Country || "Unknown",
                                    CountryCode: getCountryCode(
                                      selectedCard.Country || "NA",
                                    ),
                                  }}
                                  BuyerId={userId}
                                  liveCsrfToken={liveCsrfToken}
                                  triggerLogin={triggerLogin}
                                />
                              )}

                              {selectedTradeCard &&
                                card.isForTrade === "isForTrade" && (
                                  <ModalTradeOffer
                                    isOpen={isTradeModalOpen}
                                    onClose={() => {
                                      setSelectedTradeCard(null);
                                      setIsTradeModalOpen(false);
                                    }}
                                    theirId={selectedTradeCard.UserId}
                                    thisCurrentCard={[selectedTradeCard]}
                                    yourId={userId}
                                    liveCsrfToken={liveCsrfToken}
                                    triggerLogin={triggerLogin}
                                  />
                                )}
                            </>
                          )}
                      </div>
                    </div>
                  );
                })
              : //[...filteredGroupedCards.values()]
                // currentItemsGrouped.length > 0 &&
                // [...currentItemsGrouped]
                //currentItemsGrouped.length > 0 &&
                // [...currentItemsGrouped.values()]
                //[...filteredGroupedCards.values()]
                Array.isArray(currentItemsGrouped) &&
                currentItemsGrouped.length > 0 &&
                currentItemsGrouped.map((card) => {
                  const isVisible = groupedVisibleCardIds.includes(card.id);

                  return (
                    //  <cardDesign card={card}/>
                    <div className="cardcontent">
                      {ForSearch === false ? (
                        <MoreOptionsButton
                          onEditClick={() => handleSingleCardEditClick(card)}
                          onDeleteClick={() =>
                            handleSingleCardDeleteClick(card.id)
                          }
                          onRemoveFromWatchlistClick={() =>
                            handleSingleCardRemoveFromWatchlistClick(card.id)
                          }
                          onMylisting={selectedCollectionTitle}
                        />
                      ) : null}

                      <div
                        key={card.id}
                        className={`card ${
                          selectedCards.includes(card.id) ? "card-selected" : ""
                        }`}
                        onClick={(event) => handleCardClick(card, false, event)}
                      >
                        <div className="img">
                          <LazyImage
                            className="card-image"
                            src={card.ImageFront || card.Image}
                            isVisible={isVisible}
                          />
                          <div className="filter"></div>
                          <div className="card-isWhat">
                            {card.IsRookie === "Rookie(RC)" && (
                              <div className="patch spe">
                                <p className="strong">RC</p>
                              </div>
                            )}

                            {card.Graded === "Graded" ? (
                              <div className="patch spe">
                                <p>
                                  {card.GradeCompany} - {card.Grade}
                                </p>
                              </div>
                            ) : null}

                            {card.IsPatch === "Patch" && (
                              <div className="patch">
                                <p>Patch</p>
                              </div>
                            )}

                            {card.IsJersey === "Jersey" && (
                              <div className="patch">
                                <p>Jersey</p>
                              </div>
                            )}

                            {card.IsAuto === "Auto" && (
                              <div className="patch">
                                <p>Auto</p>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="txt">
                          {!viewImageOnly && (
                            <>
                              <div className="justify">
                                <p className="card-name">{card.Name}</p>
                                <p className="card-IDcard">
                                  {card.CardId}#{card.NumberBehind}
                                </p>
                              </div>
                              <p className="card-set">{card.SetName}</p>
                              <div className="flex-h">
                                <p className="card-variation">{`${card.cardName} - ${card.variationName}`}</p>

                                {card.Numbered !== "" &&
                                  card.Numbered !== "0" && (
                                    <p className="card-numbered">
                                      / {card.Numbered}
                                    </p>
                                  )}
                              </div>
                            </>
                          )}
                          <div className="justify bottom">
                            <h4>
                              {cardGridType === "CardGrid" && !viewAsGrid ? (
                                <div className="flex-h">
                                  {card.EstimateValue}$
                                </div>
                              ) : null}
                              {cardGridType === "CardGridSell" &&
                              !viewAsGrid ? (
                                <div className="flex-h">{card.Price}$</div>
                              ) : null}
                              {cardGridType === "Profil" ? (
                                <>
                                  {" "}
                                  {card.isForTrade ? (
                                    <>
                                      <div>TV ${card.EstimateValue}</div>
                                    </>
                                  ) : null}{" "}
                                  <br />
                                  {card.isForSale ? (
                                    <>
                                      <div>
                                        <p style={{ fontSize: "10px" }}>
                                          {card.Price} $
                                        </p>
                                      </div>
                                    </>
                                  ) : null}{" "}
                                </>
                              ) : null}
                            </h4>
                            {cardGridType === "CardGrid" ? (
                              <div className="flex-h">
                                <div
                                  className="card-isfor"
                                  style={{ marginTop: "0px" }}
                                >
                                  {card.isForSale === "isForSale" && (
                                    <div className="patch">
                                      <p>{t("ForSale")}</p>
                                    </div>
                                  )}

                                  {card.isPC === "isPC" && (
                                    <div className="patch">
                                      <p>PC</p>
                                    </div>
                                  )}

                                  {card.isForTrade === "isForTrade" && (
                                    <div className="patch">
                                      <p>{t("ForTrade")}</p>
                                    </div>
                                  )}

                                  {card.isOnEbay === "isOnEbay" && (
                                    <div className="patch">
                                      <p>{t("OnEbay")}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : null}
                          </div>
                          {viewAsGrid && (
                            <>
                              <div className="flex-h">
                                <button
                                  style={{
                                    maxHeight: "25px",
                                    width: "100%",
                                    fontSize: "13px",
                                  }}
                                >
                                  {t("graded")} ({card.grades.Graded.count}
                                  ){" "}
                                </button>
                                <button
                                  style={{
                                    maxHeight: "25px",
                                    width: "100%",
                                    fontSize: "13px",
                                  }}
                                >
                                  {t("raw")} ({card.grades.Raw.count})
                                </button>
                              </div>
                              <div className="flex-h">
                                {card.grades.Graded.lowestEstimateValue !==
                                Infinity ? (
                                  <div className="from-graded">
                                    <p>
                                      {t("From")} - $
                                      {card.grades.Graded.lowestEstimateValue.toFixed(
                                        2,
                                      )}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="from-graded"></div>
                                )}
                                {card.grades.Raw.lowestEstimateValue !==
                                Infinity ? (
                                  <div
                                    className="from-raw"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    <p>
                                      {t("From")} - $
                                      {card.grades.Raw.lowestEstimateValue.toFixed(
                                        2,
                                      )}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="from-raw"></div>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>

          {/* {selectedCard && <CardFullView card={selectedCard} />} */}
          <div style={{ marginTop: "25px" }}>
            {!viewAsGrid ? (
              <LoadMoreBar
                total={totalFlat}
                shown={itemsShown}
                onMore={() => handleShowMore(totalFlat)}
                stepIndex={stepIndex}
                SHOW_MORE_STEPS={SHOW_MORE_STEPS}
              />
            ) : (
              <LoadMoreBar
                total={totalGrouped}
                shown={itemsShown}
                onMore={() => handleShowMore(totalGrouped)}
                stepIndex={stepIndex}
                SHOW_MORE_STEPS={SHOW_MORE_STEPS}
              />
            )}
          </div>
        </div>

        {/* Pagination controls */}
      </div>
    </>
  );
}

export default FullCardGrid;
